
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8339"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8339"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug("on readable", state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("bF5dL", function(module, exports) {
"use strict";
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d792cd1b95f90e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    key = $87d792cd1b95f90e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87d792cd1b95f90e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87d792cd1b95f90e$var$_toPropertyKey(arg) {
    var key = $87d792cd1b95f90e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $87d792cd1b95f90e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || "inspect";
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread($87d792cd1b95f90e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRegister("04a3B", function(module, exports) {
"use strict";

var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6JySE")).codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRegister("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
"use strict";
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $4e720097bc0bc9d8$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$4e720097bc0bc9d8$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    key = $21db958e3a099d7d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21db958e3a099d7d$var$_toPropertyKey(arg) {
    var key = $21db958e3a099d7d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $21db958e3a099d7d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol("lastResolve");
var $21db958e3a099d7d$var$kLastReject = Symbol("lastReject");
var $21db958e3a099d7d$var$kError = Symbol("error");
var $21db958e3a099d7d$var$kEnded = Symbol("ended");
var $21db958e3a099d7d$var$kLastPromise = Symbol("lastPromise");
var $21db958e3a099d7d$var$kHandlePromise = Symbol("handlePromise");
var $21db958e3a099d7d$var$kStream = Symbol("stream");
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on("readable", $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRegister("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6JySE")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRegister("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});

parcelRegister("4oKKP", function(module, exports) {
/**
 * WEBMIDI.js v3.1.8
 * A JavaScript library to kickstart your MIDI projects
 * https://webmidijs.org
 * Build generated on December 16th, 2023.
 *
 * © Copyright 2015-2023, Jean-Philippe Côté.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
class EventEmitter {
    constructor(e11 = !1){
        this.eventMap = {}, this.eventsSuspended = 1 == e11;
    }
    addListener(e11, t11, n11 = {}) {
        if ("string" == typeof e11 && e11.length < 1 || e11 instanceof String && e11.length < 1 || "string" != typeof e11 && !(e11 instanceof String) && e11 !== EventEmitter.ANY_EVENT) throw new TypeError("The 'event' parameter must be a string or EventEmitter.ANY_EVENT.");
        if ("function" != typeof t11) throw new TypeError("The callback must be a function.");
        const r11 = new Listener(e11, this, t11, n11);
        return this.eventMap[e11] || (this.eventMap[e11] = []), n11.prepend ? this.eventMap[e11].unshift(r11) : this.eventMap[e11].push(r11), r11;
    }
    addOneTimeListener(e11, t11, n11 = {}) {
        n11.remaining = 1, this.addListener(e11, t11, n11);
    }
    static get ANY_EVENT() {
        return Symbol.for("Any event");
    }
    hasListener(e11, t11) {
        if (void 0 === e11) return !!(this.eventMap[EventEmitter.ANY_EVENT] && this.eventMap[EventEmitter.ANY_EVENT].length > 0) || Object.entries(this.eventMap).some(([, e11])=>e11.length > 0);
        if (this.eventMap[e11] && this.eventMap[e11].length > 0) {
            if (t11 instanceof Listener) return this.eventMap[e11].filter((e11)=>e11 === t11).length > 0;
            if ("function" == typeof t11) return this.eventMap[e11].filter((e11)=>e11.callback === t11).length > 0;
            return null == t11;
        }
        return !1;
    }
    get eventNames() {
        return Object.keys(this.eventMap);
    }
    getListeners(e11) {
        return this.eventMap[e11] || [];
    }
    suspendEvent(e11) {
        this.getListeners(e11).forEach((e11)=>{
            e11.suspended = !0;
        });
    }
    unsuspendEvent(e11) {
        this.getListeners(e11).forEach((e11)=>{
            e11.suspended = !1;
        });
    }
    getListenerCount(e11) {
        return this.getListeners(e11).length;
    }
    emit(e11, ...t11) {
        if ("string" != typeof e11 && !(e11 instanceof String)) throw new TypeError("The 'event' parameter must be a string.");
        if (this.eventsSuspended) return;
        let n11 = [], r11 = this.eventMap[EventEmitter.ANY_EVENT] || [];
        return this.eventMap[e11] && (r11 = r11.concat(this.eventMap[e11])), r11.forEach((e11)=>{
            if (e11.suspended) return;
            let r11 = [
                ...t11
            ];
            Array.isArray(e11.arguments) && (r11 = r11.concat(e11.arguments)), e11.remaining > 0 && (n11.push(e11.callback.apply(e11.context, r11)), e11.count++), --e11.remaining < 1 && e11.remove();
        }), n11;
    }
    removeListener(e11, t11, n11 = {}) {
        if (void 0 === e11) return void (this.eventMap = {});
        if (!this.eventMap[e11]) return;
        let r11 = this.eventMap[e11].filter((e11)=>t11 && e11.callback !== t11 || n11.remaining && n11.remaining !== e11.remaining || n11.context && n11.context !== e11.context);
        r11.length ? this.eventMap[e11] = r11 : delete this.eventMap[e11];
    }
    async waitFor(e11, t11 = {}) {
        return t11.duration = parseInt(t11.duration), (isNaN(t11.duration) || t11.duration <= 0) && (t11.duration = 1 / 0), new Promise((n11, r11)=>{
            let i11, s11 = this.addListener(e11, ()=>{
                clearTimeout(i11), n11();
            }, {
                remaining: 1
            });
            t11.duration !== 1 / 0 && (i11 = setTimeout(()=>{
                s11.remove(), r11("The duration expired before the event was emitted.");
            }, t11.duration));
        });
    }
    get eventCount() {
        return Object.keys(this.eventMap).length;
    }
}
class Listener {
    constructor(e11, t11, n11, r11 = {}){
        if ("string" != typeof e11 && !(e11 instanceof String) && e11 !== EventEmitter.ANY_EVENT) throw new TypeError("The 'event' parameter must be a string or EventEmitter.ANY_EVENT.");
        if (!t11) throw new ReferenceError("The 'target' parameter is mandatory.");
        if ("function" != typeof n11) throw new TypeError("The 'callback' must be a function.");
        void 0 === r11.arguments || Array.isArray(r11.arguments) || (r11.arguments = [
            r11.arguments
        ]), (r11 = Object.assign({
            context: t11,
            remaining: 1 / 0,
            arguments: void 0,
            duration: 1 / 0
        }, r11)).duration !== 1 / 0 && setTimeout(()=>this.remove(), r11.duration), this.arguments = r11.arguments, this.callback = n11, this.context = r11.context, this.count = 0, this.event = e11, this.remaining = parseInt(r11.remaining) >= 1 ? parseInt(r11.remaining) : 1 / 0, this.suspended = !1, this.target = t11;
    }
    remove() {
        this.target.removeListener(this.event, this.callback, {
            context: this.context,
            remaining: this.remaining
        });
    }
}
/**
 * The `Enumerations` class contains enumerations and arrays of elements used throughout the
 * library. All its properties are static and should be referenced using the class name. For
 * example: `Enumerations.CHANNEL_MESSAGES`.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Enumerations {
    static get MIDI_CHANNEL_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MESSAGES enum has been deprecated. Use the Enumerations.CHANNEL_MESSAGES enum instead."), Enumerations.CHANNEL_MESSAGES;
    }
    static get CHANNEL_MESSAGES() {
        return {
            noteoff: 8,
            noteon: 9,
            keyaftertouch: 10,
            controlchange: 11,
            programchange: 12,
            channelaftertouch: 13,
            pitchbend: 14
        };
    }
    static get CHANNEL_NUMBERS() {
        return [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ];
    }
    static get MIDI_CHANNEL_NUMBERS() {
        return this.validation && console.warn("The MIDI_CHANNEL_NUMBERS array has been deprecated. Use the Enumerations.CHANNEL_NUMBERS array instead."), [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ];
    }
    static get CHANNEL_MODE_MESSAGES() {
        return {
            allsoundoff: 120,
            resetallcontrollers: 121,
            localcontrol: 122,
            allnotesoff: 123,
            omnimodeoff: 124,
            omnimodeon: 125,
            monomodeon: 126,
            polymodeon: 127
        };
    }
    static get MIDI_CHANNEL_MODE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MODE_MESSAGES enum has been deprecated. Use the Enumerations.CHANNEL_MODE_MESSAGES enum instead."), Enumerations.CHANNEL_MODE_MESSAGES;
    }
    static get MIDI_CONTROL_CHANGE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CONTROL_CHANGE_MESSAGES enum has been deprecated. Use the Enumerations.CONTROL_CHANGE_MESSAGES array instead."), {
            bankselectcoarse: 0,
            modulationwheelcoarse: 1,
            breathcontrollercoarse: 2,
            controller3: 3,
            footcontrollercoarse: 4,
            portamentotimecoarse: 5,
            dataentrycoarse: 6,
            volumecoarse: 7,
            balancecoarse: 8,
            controller9: 9,
            pancoarse: 10,
            expressioncoarse: 11,
            effectcontrol1coarse: 12,
            effectcontrol2coarse: 13,
            controller14: 14,
            controller15: 15,
            generalpurposeslider1: 16,
            generalpurposeslider2: 17,
            generalpurposeslider3: 18,
            generalpurposeslider4: 19,
            controller20: 20,
            controller21: 21,
            controller22: 22,
            controller23: 23,
            controller24: 24,
            controller25: 25,
            controller26: 26,
            controller27: 27,
            controller28: 28,
            controller29: 29,
            controller30: 30,
            controller31: 31,
            bankselectfine: 32,
            modulationwheelfine: 33,
            breathcontrollerfine: 34,
            controller35: 35,
            footcontrollerfine: 36,
            portamentotimefine: 37,
            dataentryfine: 38,
            volumefine: 39,
            balancefine: 40,
            controller41: 41,
            panfine: 42,
            expressionfine: 43,
            effectcontrol1fine: 44,
            effectcontrol2fine: 45,
            controller46: 46,
            controller47: 47,
            controller48: 48,
            controller49: 49,
            controller50: 50,
            controller51: 51,
            controller52: 52,
            controller53: 53,
            controller54: 54,
            controller55: 55,
            controller56: 56,
            controller57: 57,
            controller58: 58,
            controller59: 59,
            controller60: 60,
            controller61: 61,
            controller62: 62,
            controller63: 63,
            holdpedal: 64,
            portamento: 65,
            sustenutopedal: 66,
            softpedal: 67,
            legatopedal: 68,
            hold2pedal: 69,
            soundvariation: 70,
            resonance: 71,
            soundreleasetime: 72,
            soundattacktime: 73,
            brightness: 74,
            soundcontrol6: 75,
            soundcontrol7: 76,
            soundcontrol8: 77,
            soundcontrol9: 78,
            soundcontrol10: 79,
            generalpurposebutton1: 80,
            generalpurposebutton2: 81,
            generalpurposebutton3: 82,
            generalpurposebutton4: 83,
            controller84: 84,
            controller85: 85,
            controller86: 86,
            controller87: 87,
            controller88: 88,
            controller89: 89,
            controller90: 90,
            reverblevel: 91,
            tremololevel: 92,
            choruslevel: 93,
            celestelevel: 94,
            phaserlevel: 95,
            databuttonincrement: 96,
            databuttondecrement: 97,
            nonregisteredparametercoarse: 98,
            nonregisteredparameterfine: 99,
            registeredparametercoarse: 100,
            registeredparameterfine: 101,
            controller102: 102,
            controller103: 103,
            controller104: 104,
            controller105: 105,
            controller106: 106,
            controller107: 107,
            controller108: 108,
            controller109: 109,
            controller110: 110,
            controller111: 111,
            controller112: 112,
            controller113: 113,
            controller114: 114,
            controller115: 115,
            controller116: 116,
            controller117: 117,
            controller118: 118,
            controller119: 119,
            allsoundoff: 120,
            resetallcontrollers: 121,
            localcontrol: 122,
            allnotesoff: 123,
            omnimodeoff: 124,
            omnimodeon: 125,
            monomodeon: 126,
            polymodeon: 127
        };
    }
    static get CONTROL_CHANGE_MESSAGES() {
        return [
            {
                number: 0,
                name: "bankselectcoarse",
                description: "Bank Select (Coarse)",
                position: "msb"
            },
            {
                number: 1,
                name: "modulationwheelcoarse",
                description: "Modulation Wheel (Coarse)",
                position: "msb"
            },
            {
                number: 2,
                name: "breathcontrollercoarse",
                description: "Breath Controller (Coarse)",
                position: "msb"
            },
            {
                number: 3,
                name: "controller3",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 4,
                name: "footcontrollercoarse",
                description: "Foot Controller (Coarse)",
                position: "msb"
            },
            {
                number: 5,
                name: "portamentotimecoarse",
                description: "Portamento Time (Coarse)",
                position: "msb"
            },
            {
                number: 6,
                name: "dataentrycoarse",
                description: "Data Entry (Coarse)",
                position: "msb"
            },
            {
                number: 7,
                name: "volumecoarse",
                description: "Channel Volume (Coarse)",
                position: "msb"
            },
            {
                number: 8,
                name: "balancecoarse",
                description: "Balance (Coarse)",
                position: "msb"
            },
            {
                number: 9,
                name: "controller9",
                description: "Controller 9 (Coarse)",
                position: "msb"
            },
            {
                number: 10,
                name: "pancoarse",
                description: "Pan (Coarse)",
                position: "msb"
            },
            {
                number: 11,
                name: "expressioncoarse",
                description: "Expression Controller (Coarse)",
                position: "msb"
            },
            {
                number: 12,
                name: "effectcontrol1coarse",
                description: "Effect Control 1 (Coarse)",
                position: "msb"
            },
            {
                number: 13,
                name: "effectcontrol2coarse",
                description: "Effect Control 2 (Coarse)",
                position: "msb"
            },
            {
                number: 14,
                name: "controller14",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 15,
                name: "controller15",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 16,
                name: "generalpurposecontroller1",
                description: "General Purpose Controller 1 (Coarse)",
                position: "msb"
            },
            {
                number: 17,
                name: "generalpurposecontroller2",
                description: "General Purpose Controller 2 (Coarse)",
                position: "msb"
            },
            {
                number: 18,
                name: "generalpurposecontroller3",
                description: "General Purpose Controller 3 (Coarse)",
                position: "msb"
            },
            {
                number: 19,
                name: "generalpurposecontroller4",
                description: "General Purpose Controller 4 (Coarse)",
                position: "msb"
            },
            {
                number: 20,
                name: "controller20",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 21,
                name: "controller21",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 22,
                name: "controller22",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 23,
                name: "controller23",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 24,
                name: "controller24",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 25,
                name: "controller25",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 26,
                name: "controller26",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 27,
                name: "controller27",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 28,
                name: "controller28",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 29,
                name: "controller29",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 30,
                name: "controller30",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 31,
                name: "controller31",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 32,
                name: "bankselectfine",
                description: "Bank Select (Fine)",
                position: "lsb"
            },
            {
                number: 33,
                name: "modulationwheelfine",
                description: "Modulation Wheel (Fine)",
                position: "lsb"
            },
            {
                number: 34,
                name: "breathcontrollerfine",
                description: "Breath Controller (Fine)",
                position: "lsb"
            },
            {
                number: 35,
                name: "controller35",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 36,
                name: "footcontrollerfine",
                description: "Foot Controller (Fine)",
                position: "lsb"
            },
            {
                number: 37,
                name: "portamentotimefine",
                description: "Portamento Time (Fine)",
                position: "lsb"
            },
            {
                number: 38,
                name: "dataentryfine",
                description: "Data Entry (Fine)",
                position: "lsb"
            },
            {
                number: 39,
                name: "channelvolumefine",
                description: "Channel Volume (Fine)",
                position: "lsb"
            },
            {
                number: 40,
                name: "balancefine",
                description: "Balance (Fine)",
                position: "lsb"
            },
            {
                number: 41,
                name: "controller41",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 42,
                name: "panfine",
                description: "Pan (Fine)",
                position: "lsb"
            },
            {
                number: 43,
                name: "expressionfine",
                description: "Expression Controller (Fine)",
                position: "lsb"
            },
            {
                number: 44,
                name: "effectcontrol1fine",
                description: "Effect control 1 (Fine)",
                position: "lsb"
            },
            {
                number: 45,
                name: "effectcontrol2fine",
                description: "Effect control 2 (Fine)",
                position: "lsb"
            },
            {
                number: 46,
                name: "controller46",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 47,
                name: "controller47",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 48,
                name: "controller48",
                description: "General Purpose Controller 1 (Fine)",
                position: "lsb"
            },
            {
                number: 49,
                name: "controller49",
                description: "General Purpose Controller 2 (Fine)",
                position: "lsb"
            },
            {
                number: 50,
                name: "controller50",
                description: "General Purpose Controller 3 (Fine)",
                position: "lsb"
            },
            {
                number: 51,
                name: "controller51",
                description: "General Purpose Controller 4 (Fine)",
                position: "lsb"
            },
            {
                number: 52,
                name: "controller52",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 53,
                name: "controller53",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 54,
                name: "controller54",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 55,
                name: "controller55",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 56,
                name: "controller56",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 57,
                name: "controller57",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 58,
                name: "controller58",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 59,
                name: "controller59",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 60,
                name: "controller60",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 61,
                name: "controller61",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 62,
                name: "controller62",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 63,
                name: "controller63",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 64,
                name: "damperpedal",
                description: "Damper Pedal On/Off"
            },
            {
                number: 65,
                name: "portamento",
                description: "Portamento On/Off"
            },
            {
                number: 66,
                name: "sostenuto",
                description: "Sostenuto On/Off"
            },
            {
                number: 67,
                name: "softpedal",
                description: "Soft Pedal On/Off"
            },
            {
                number: 68,
                name: "legatopedal",
                description: "Legato Pedal On/Off"
            },
            {
                number: 69,
                name: "hold2",
                description: "Hold 2 On/Off"
            },
            {
                number: 70,
                name: "soundvariation",
                description: "Sound Variation",
                position: "lsb"
            },
            {
                number: 71,
                name: "resonance",
                description: "Resonance",
                position: "lsb"
            },
            {
                number: 72,
                name: "releasetime",
                description: "Release Time",
                position: "lsb"
            },
            {
                number: 73,
                name: "attacktime",
                description: "Attack Time",
                position: "lsb"
            },
            {
                number: 74,
                name: "brightness",
                description: "Brightness",
                position: "lsb"
            },
            {
                number: 75,
                name: "decaytime",
                description: "Decay Time",
                position: "lsb"
            },
            {
                number: 76,
                name: "vibratorate",
                description: "Vibrato Rate",
                position: "lsb"
            },
            {
                number: 77,
                name: "vibratodepth",
                description: "Vibrato Depth",
                position: "lsb"
            },
            {
                number: 78,
                name: "vibratodelay",
                description: "Vibrato Delay",
                position: "lsb"
            },
            {
                number: 79,
                name: "controller79",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 80,
                name: "generalpurposecontroller5",
                description: "General Purpose Controller 5",
                position: "lsb"
            },
            {
                number: 81,
                name: "generalpurposecontroller6",
                description: "General Purpose Controller 6",
                position: "lsb"
            },
            {
                number: 82,
                name: "generalpurposecontroller7",
                description: "General Purpose Controller 7",
                position: "lsb"
            },
            {
                number: 83,
                name: "generalpurposecontroller8",
                description: "General Purpose Controller 8",
                position: "lsb"
            },
            {
                number: 84,
                name: "portamentocontrol",
                description: "Portamento Control",
                position: "lsb"
            },
            {
                number: 85,
                name: "controller85",
                description: "Undefined"
            },
            {
                number: 86,
                name: "controller86",
                description: "Undefined"
            },
            {
                number: 87,
                name: "controller87",
                description: "Undefined"
            },
            {
                number: 88,
                name: "highresolutionvelocityprefix",
                description: "High Resolution Velocity Prefix",
                position: "lsb"
            },
            {
                number: 89,
                name: "controller89",
                description: "Undefined"
            },
            {
                number: 90,
                name: "controller90",
                description: "Undefined"
            },
            {
                number: 91,
                name: "effect1depth",
                description: "Effects 1 Depth (Reverb Send Level)"
            },
            {
                number: 92,
                name: "effect2depth",
                description: "Effects 2 Depth"
            },
            {
                number: 93,
                name: "effect3depth",
                description: "Effects 3 Depth (Chorus Send Level)"
            },
            {
                number: 94,
                name: "effect4depth",
                description: "Effects 4 Depth"
            },
            {
                number: 95,
                name: "effect5depth",
                description: "Effects 5 Depth"
            },
            {
                number: 96,
                name: "dataincrement",
                description: "Data Increment"
            },
            {
                number: 97,
                name: "datadecrement",
                description: "Data Decrement"
            },
            {
                number: 98,
                name: "nonregisteredparameterfine",
                description: "Non-Registered Parameter Number (Fine)",
                position: "lsb"
            },
            {
                number: 99,
                name: "nonregisteredparametercoarse",
                description: "Non-Registered Parameter Number (Coarse)",
                position: "msb"
            },
            {
                number: 100,
                name: "registeredparameterfine",
                description: "Registered Parameter Number (Fine)",
                position: "lsb"
            },
            {
                number: 101,
                name: "registeredparametercoarse",
                description: "Registered Parameter Number (Coarse)",
                position: "msb"
            },
            {
                number: 102,
                name: "controller102",
                description: "Undefined"
            },
            {
                number: 103,
                name: "controller103",
                description: "Undefined"
            },
            {
                number: 104,
                name: "controller104",
                description: "Undefined"
            },
            {
                number: 105,
                name: "controller105",
                description: "Undefined"
            },
            {
                number: 106,
                name: "controller106",
                description: "Undefined"
            },
            {
                number: 107,
                name: "controller107",
                description: "Undefined"
            },
            {
                number: 108,
                name: "controller108",
                description: "Undefined"
            },
            {
                number: 109,
                name: "controller109",
                description: "Undefined"
            },
            {
                number: 110,
                name: "controller110",
                description: "Undefined"
            },
            {
                number: 111,
                name: "controller111",
                description: "Undefined"
            },
            {
                number: 112,
                name: "controller112",
                description: "Undefined"
            },
            {
                number: 113,
                name: "controller113",
                description: "Undefined"
            },
            {
                number: 114,
                name: "controller114",
                description: "Undefined"
            },
            {
                number: 115,
                name: "controller115",
                description: "Undefined"
            },
            {
                number: 116,
                name: "controller116",
                description: "Undefined"
            },
            {
                number: 117,
                name: "controller117",
                description: "Undefined"
            },
            {
                number: 118,
                name: "controller118",
                description: "Undefined"
            },
            {
                number: 119,
                name: "controller119",
                description: "Undefined"
            },
            {
                number: 120,
                name: "allsoundoff",
                description: "All Sound Off"
            },
            {
                number: 121,
                name: "resetallcontrollers",
                description: "Reset All Controllers"
            },
            {
                number: 122,
                name: "localcontrol",
                description: "Local Control On/Off"
            },
            {
                number: 123,
                name: "allnotesoff",
                description: "All Notes Off"
            },
            {
                number: 124,
                name: "omnimodeoff",
                description: "Omni Mode Off"
            },
            {
                number: 125,
                name: "omnimodeon",
                description: "Omni Mode On"
            },
            {
                number: 126,
                name: "monomodeon",
                description: "Mono Mode On"
            },
            {
                number: 127,
                name: "polymodeon",
                description: "Poly Mode On"
            }
        ];
    }
    static get REGISTERED_PARAMETERS() {
        return {
            pitchbendrange: [
                0,
                0
            ],
            channelfinetuning: [
                0,
                1
            ],
            channelcoarsetuning: [
                0,
                2
            ],
            tuningprogram: [
                0,
                3
            ],
            tuningbank: [
                0,
                4
            ],
            modulationrange: [
                0,
                5
            ],
            azimuthangle: [
                61,
                0
            ],
            elevationangle: [
                61,
                1
            ],
            gain: [
                61,
                2
            ],
            distanceratio: [
                61,
                3
            ],
            maximumdistance: [
                61,
                4
            ],
            maximumdistancegain: [
                61,
                5
            ],
            referencedistanceratio: [
                61,
                6
            ],
            panspreadangle: [
                61,
                7
            ],
            rollangle: [
                61,
                8
            ]
        };
    }
    static get MIDI_REGISTERED_PARAMETERS() {
        return this.validation && console.warn("The MIDI_REGISTERED_PARAMETERS enum has been deprecated. Use the Enumerations.REGISTERED_PARAMETERS enum instead."), Enumerations.MIDI_REGISTERED_PARAMETERS;
    }
    static get SYSTEM_MESSAGES() {
        return {
            sysex: 240,
            timecode: 241,
            songposition: 242,
            songselect: 243,
            tunerequest: 246,
            tuningrequest: 246,
            sysexend: 247,
            clock: 248,
            start: 250,
            continue: 251,
            stop: 252,
            activesensing: 254,
            reset: 255,
            midimessage: 0,
            unknownsystemmessage: -1
        };
    }
    static get MIDI_SYSTEM_MESSAGES() {
        return this.validation && console.warn("The MIDI_SYSTEM_MESSAGES enum has been deprecated. Use the Enumerations.SYSTEM_MESSAGES enum instead."), Enumerations.SYSTEM_MESSAGES;
    }
    static get CHANNEL_EVENTS() {
        return [
            "noteoff",
            "controlchange",
            "noteon",
            "keyaftertouch",
            "programchange",
            "channelaftertouch",
            "pitchbend",
            "allnotesoff",
            "allsoundoff",
            "localcontrol",
            "monomode",
            "omnimode",
            "resetallcontrollers",
            "nrpn",
            "nrpn-dataentrycoarse",
            "nrpn-dataentryfine",
            "nrpn-dataincrement",
            "nrpn-datadecrement",
            "rpn",
            "rpn-dataentrycoarse",
            "rpn-dataentryfine",
            "rpn-dataincrement",
            "rpn-datadecrement",
            "nrpn-databuttonincrement",
            "nrpn-databuttondecrement",
            "rpn-databuttonincrement",
            "rpn-databuttondecrement"
        ];
    }
}
/**
 * The `Note` class represents a single musical note such as `"D3"`, `"G#4"`, `"F-1"`, `"Gb7"`, etc.
 *
 * `Note` objects can be played back on a single channel by calling
 * [`OutputChannel.playNote()`]{@link OutputChannel#playNote} or, on multiple channels of the same
 * output, by calling [`Output.playNote()`]{@link Output#playNote}.
 *
 * The note has [`attack`](#attack) and [`release`](#release) velocities set at `0.5` by default.
 * These can be changed by passing in the appropriate option. It is also possible to set a
 * system-wide default for attack and release velocities by using the
 * [`WebMidi.defaults`](WebMidi#defaults) property.
 *
 * If you prefer to work with raw MIDI values (`0` to `127`), you can use [`rawAttack`](#rawAttack) and
 * [`rawRelease`](#rawRelease) to both get and set the values.
 *
 * The note may have a [`duration`](#duration). If it does, playback will be automatically stopped
 * when the duration has elapsed by sending a `"noteoff"` event. By default, the duration is set to
 * `Infinity`. In this case, it will never stop playing unless explicitly stopped by calling a
 * method such as [`OutputChannel.stopNote()`]{@link OutputChannel#stopNote},
 * [`Output.stopNote()`]{@link Output#stopNote} or similar.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Note {
    constructor(e11, t11 = {}){
        this.duration = wm.defaults.note.duration, this.attack = wm.defaults.note.attack, this.release = wm.defaults.note.release, null != t11.duration && (this.duration = t11.duration), null != t11.attack && (this.attack = t11.attack), null != t11.rawAttack && (this.attack = Utilities.from7bitToFloat(t11.rawAttack)), null != t11.release && (this.release = t11.release), null != t11.rawRelease && (this.release = Utilities.from7bitToFloat(t11.rawRelease)), Number.isInteger(e11) ? this.identifier = Utilities.toNoteIdentifier(e11) : this.identifier = e11;
    }
    get identifier() {
        return this._name + (this._accidental || "") + this._octave;
    }
    set identifier(e11) {
        const t11 = Utilities.getNoteDetails(e11);
        if (wm.validation && !e11) throw new Error("Invalid note identifier");
        this._name = t11.name, this._accidental = t11.accidental, this._octave = t11.octave;
    }
    get name() {
        return this._name;
    }
    set name(e11) {
        if (wm.validation && (e11 = e11.toUpperCase(), ![
            "C",
            "D",
            "E",
            "F",
            "G",
            "A",
            "B"
        ].includes(e11))) throw new Error("Invalid name value");
        this._name = e11;
    }
    get accidental() {
        return this._accidental;
    }
    set accidental(e11) {
        if (wm.validation && (e11 = e11.toLowerCase(), ![
            "#",
            "##",
            "b",
            "bb"
        ].includes(e11))) throw new Error("Invalid accidental value");
        this._accidental = e11;
    }
    get octave() {
        return this._octave;
    }
    set octave(e11) {
        if (wm.validation && (e11 = parseInt(e11), isNaN(e11))) throw new Error("Invalid octave value");
        this._octave = e11;
    }
    get duration() {
        return this._duration;
    }
    set duration(e11) {
        if (wm.validation && (e11 = parseFloat(e11), isNaN(e11) || null === e11 || e11 < 0)) throw new RangeError("Invalid duration value.");
        this._duration = e11;
    }
    get attack() {
        return this._attack;
    }
    set attack(e11) {
        if (wm.validation && (e11 = parseFloat(e11), isNaN(e11) || !(e11 >= 0 && e11 <= 1))) throw new RangeError("Invalid attack value.");
        this._attack = e11;
    }
    get release() {
        return this._release;
    }
    set release(e11) {
        if (wm.validation && (e11 = parseFloat(e11), isNaN(e11) || !(e11 >= 0 && e11 <= 1))) throw new RangeError("Invalid release value.");
        this._release = e11;
    }
    get rawAttack() {
        return Utilities.fromFloatTo7Bit(this._attack);
    }
    set rawAttack(e11) {
        this._attack = Utilities.from7bitToFloat(e11);
    }
    get rawRelease() {
        return Utilities.fromFloatTo7Bit(this._release);
    }
    set rawRelease(e11) {
        this._release = Utilities.from7bitToFloat(e11);
    }
    get number() {
        return Utilities.toNoteNumber(this.identifier);
    }
    getOffsetNumber(e11 = 0, t11 = 0) {
        return wm.validation && (e11 = parseInt(e11) || 0, t11 = parseInt(t11) || 0), Math.min(Math.max(this.number + 12 * e11 + t11, 0), 127);
    }
}
/**
 * The `Utilities` class contains general-purpose utility methods. All methods are static and
 * should be called using the class name. For example: `Utilities.getNoteDetails("C4")`.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Utilities {
    /**
   * Returns a MIDI note number matching the identifier passed in the form of a string. The
   * identifier must include the octave number. The identifier also optionally include a sharp (#),
   * a double sharp (##), a flat (b) or a double flat (bb) symbol. For example, these are all valid
   * identifiers: C5, G4, D#-1, F0, Gb7, Eb-1, Abb4, B##6, etc.
   *
   * When converting note identifiers to numbers, C4 is considered to be middle C (MIDI note number
   * 60) as per the scientific pitch notation standard.
   *
   * The resulting note number can be offset by using the `octaveOffset` parameter.
   *
   * @param identifier {string} The identifier in the form of a letter, followed by an optional "#",
   * "##", "b" or "bb" followed by the octave number. For exemple: C5, G4, D#-1, F0, Gb7, Eb-1,
   * Abb4, B##6, etc.
   *
   * @param {number} [octaveOffset=0] A integer to offset the octave by.
   *
   * @returns {number} The MIDI note number (an integer between 0 and 127).
   *
   * @throws RangeError Invalid 'octaveOffset' value
   *
   * @throws TypeError Invalid note identifier
   *
   * @license Apache-2.0
   * @since 3.0.0
   * @static
   */ static toNoteNumber(e11, t11 = 0) {
        if (t11 = null == t11 ? 0 : parseInt(t11), isNaN(t11)) throw new RangeError("Invalid 'octaveOffset' value");
        "string" != typeof e11 && (e11 = "");
        const n11 = this.getNoteDetails(e11);
        if (!n11) throw new TypeError("Invalid note identifier");
        let r11 = 12 * (n11.octave + 1 + t11);
        if (r11 += ({
            C: 0,
            D: 2,
            E: 4,
            F: 5,
            G: 7,
            A: 9,
            B: 11
        })[n11.name], n11.accidental && (n11.accidental.startsWith("b") ? r11 -= n11.accidental.length : r11 += n11.accidental.length), r11 < 0 || r11 > 127) throw new RangeError("Invalid octaveOffset value");
        return r11;
    }
    static getNoteDetails(e11) {
        Number.isInteger(e11) && (e11 = this.toNoteIdentifier(e11));
        const t11 = e11.match(/^([CDEFGAB])(#{0,2}|b{0,2})(-?\d+)$/i);
        if (!t11) throw new TypeError("Invalid note identifier");
        const n11 = t11[1].toUpperCase(), r11 = parseInt(t11[3]);
        let i11 = t11[2].toLowerCase();
        i11 = "" === i11 ? void 0 : i11;
        return {
            accidental: i11,
            identifier: n11 + (i11 || "") + r11,
            name: n11,
            octave: r11
        };
    }
    static sanitizeChannels(e11) {
        let t11;
        if (wm.validation) {
            if ("all" === e11) t11 = [
                "all"
            ];
            else if ("none" === e11) return [];
        }
        return t11 = Array.isArray(e11) ? e11 : [
            e11
        ], t11.indexOf("all") > -1 && (t11 = Enumerations.MIDI_CHANNEL_NUMBERS), t11.map(function(e11) {
            return parseInt(e11);
        }).filter(function(e11) {
            return e11 >= 1 && e11 <= 16;
        });
    }
    static toTimestamp(e11) {
        let t11 = !1;
        const n11 = parseFloat(e11);
        return !isNaN(n11) && ("string" == typeof e11 && "+" === e11.substring(0, 1) ? n11 >= 0 && (t11 = wm.time + n11) : n11 >= 0 && (t11 = n11), t11);
    }
    static guessNoteNumber(e11, t11) {
        t11 = parseInt(t11) || 0;
        let n11 = !1;
        if (Number.isInteger(e11) && e11 >= 0 && e11 <= 127) n11 = parseInt(e11);
        else if (parseInt(e11) >= 0 && parseInt(e11) <= 127) n11 = parseInt(e11);
        else if ("string" == typeof e11 || e11 instanceof String) try {
            n11 = this.toNoteNumber(e11.trim(), t11);
        } catch (e11) {
            return !1;
        }
        return n11;
    }
    static toNoteIdentifier(e11, t11) {
        if (e11 = parseInt(e11), isNaN(e11) || e11 < 0 || e11 > 127) throw new RangeError("Invalid note number");
        if (t11 = null == t11 ? 0 : parseInt(t11), isNaN(t11)) throw new RangeError("Invalid octaveOffset value");
        const n11 = Math.floor(e11 / 12 - 1) + t11;
        return [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ][e11 % 12] + n11.toString();
    }
    static buildNote(e11, t11 = {}) {
        if (t11.octaveOffset = parseInt(t11.octaveOffset) || 0, e11 instanceof Note) return e11;
        let n11 = this.guessNoteNumber(e11, t11.octaveOffset);
        if (!1 === n11) throw new TypeError(`The input could not be parsed as a note (${e11})`);
        return t11.octaveOffset = void 0, new Note(n11, t11);
    }
    static buildNoteArray(e11, t11 = {}) {
        let n11 = [];
        return Array.isArray(e11) || (e11 = [
            e11
        ]), e11.forEach((e11)=>{
            n11.push(this.buildNote(e11, t11));
        }), n11;
    }
    static from7bitToFloat(e11) {
        return e11 === 1 / 0 && (e11 = 127), e11 = parseInt(e11) || 0, Math.min(Math.max(e11 / 127, 0), 1);
    }
    static fromFloatTo7Bit(e11) {
        return e11 === 1 / 0 && (e11 = 1), e11 = parseFloat(e11) || 0, Math.min(Math.max(Math.round(127 * e11), 0), 127);
    }
    static fromMsbLsbToFloat(e11, t11 = 0) {
        wm.validation && (e11 = Math.min(Math.max(parseInt(e11) || 0, 0), 127), t11 = Math.min(Math.max(parseInt(t11) || 0, 0), 127));
        const n11 = ((e11 << 7) + t11) / 16383;
        return Math.min(Math.max(n11, 0), 1);
    }
    static fromFloatToMsbLsb(e11) {
        wm.validation && (e11 = Math.min(Math.max(parseFloat(e11) || 0, 0), 1));
        const t11 = Math.round(16383 * e11);
        return {
            msb: t11 >> 7,
            lsb: 127 & t11
        };
    }
    static offsetNumber(e11, t11 = 0, n11 = 0) {
        if (wm.validation) {
            if (e11 = parseInt(e11), isNaN(e11)) throw new Error("Invalid note number");
            t11 = parseInt(t11) || 0, n11 = parseInt(n11) || 0;
        }
        return Math.min(Math.max(e11 + 12 * t11 + n11, 0), 127);
    }
    static getPropertyByValue(e11, t11) {
        return Object.keys(e11).find((n11)=>e11[n11] === t11);
    }
    static getCcNameByNumber(e11) {
        if (!wm.validation || (e11 = parseInt(e11)) >= 0 && e11 <= 127) return Enumerations.CONTROL_CHANGE_MESSAGES[e11].name;
    }
    static getCcNumberByName(e11) {
        let t11 = Enumerations.CONTROL_CHANGE_MESSAGES.find((t11)=>t11.name === e11);
        return t11 ? t11.number : Enumerations.MIDI_CONTROL_CHANGE_MESSAGES[e11];
    }
    static getChannelModeByNumber(e11) {
        if (!(e11 >= 120 && e11 <= 127)) return !1;
        for(let t11 in Enumerations.CHANNEL_MODE_MESSAGES)if (Enumerations.CHANNEL_MODE_MESSAGES.hasOwnProperty(t11) && e11 === Enumerations.CHANNEL_MODE_MESSAGES[t11]) return t11;
        return !1;
    }
    static get isNode() {
        return "undefined" != typeof $hPtJY && null != $hPtJY.versions && null != $hPtJY.versions.node;
    }
    static get isBrowser() {
        return "undefined" != typeof window && void 0 !== window.document;
    }
}
/**
 * The `OutputChannel` class represents a single output MIDI channel. `OutputChannel` objects are
 * provided by an [`Output`](Output) port which, itself, is made available by a device. The
 * `OutputChannel` object is derived from the host's MIDI subsystem and should not be instantiated
 * directly.
 *
 * All 16 `OutputChannel` objects can be found inside the parent output's
 * [`channels`]{@link Output#channels} property.
 *
 * @param {Output} output The [`Output`](Output) this channel belongs to.
 * @param {number} number The MIDI channel number (`1` - `16`).
 *
 * @extends EventEmitter
 * @license Apache-2.0
 * @since 3.0.0
 */ class OutputChannel extends EventEmitter {
    constructor(e11, t11){
        super(), this._output = e11, this._number = t11, this._octaveOffset = 0;
    }
    destroy() {
        this._output = null, this._number = null, this._octaveOffset = 0, this.removeListener();
    }
    send(e11, t11 = {
        time: 0
    }) {
        return this.output.send(e11, t11), this;
    }
    sendKeyAftertouch(e11, t11, n11 = {}) {
        if (wm.validation) {
            if (n11.useRawValue && (n11.rawValue = n11.useRawValue), isNaN(parseFloat(t11))) throw new RangeError("Invalid key aftertouch value.");
            if (n11.rawValue) {
                if (!(t11 >= 0 && t11 <= 127 && Number.isInteger(t11))) throw new RangeError("Key aftertouch raw value must be an integer between 0 and 127.");
            } else if (!(t11 >= 0 && t11 <= 1)) throw new RangeError("Key aftertouch value must be a float between 0 and 1.");
        }
        n11.rawValue || (t11 = Utilities.fromFloatTo7Bit(t11));
        const r11 = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Array.isArray(e11) || (e11 = [
            e11
        ]), Utilities.buildNoteArray(e11).forEach((e11)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.keyaftertouch << 4) + (this.number - 1),
                e11.getOffsetNumber(r11),
                t11
            ], {
                time: Utilities.toTimestamp(n11.time)
            });
        }), this;
    }
    /**
   * Sends a MIDI **control change** message to the channel at the scheduled time. The control
   * change message to send can be specified numerically (`0` to `127`) or by using one of the
   * following common names:
   *
   * | Number | Name                          |
   * |--------|-------------------------------|
   * | 0      |`bankselectcoarse`             |
   * | 1      |`modulationwheelcoarse`        |
   * | 2      |`breathcontrollercoarse`       |
   * | 4      |`footcontrollercoarse`         |
   * | 5      |`portamentotimecoarse`         |
   * | 6      |`dataentrycoarse`              |
   * | 7      |`volumecoarse`                 |
   * | 8      |`balancecoarse`                |
   * | 10     |`pancoarse`                    |
   * | 11     |`expressioncoarse`             |
   * | 12     |`effectcontrol1coarse`         |
   * | 13     |`effectcontrol2coarse`         |
   * | 18     |`generalpurposeslider3`        |
   * | 19     |`generalpurposeslider4`        |
   * | 32     |`bankselectfine`               |
   * | 33     |`modulationwheelfine`          |
   * | 34     |`breathcontrollerfine`         |
   * | 36     |`footcontrollerfine`           |
   * | 37     |`portamentotimefine`           |
   * | 38     |`dataentryfine`                |
   * | 39     |`volumefine`                   |
   * | 40     |`balancefine`                  |
   * | 42     |`panfine`                      |
   * | 43     |`expressionfine`               |
   * | 44     |`effectcontrol1fine`           |
   * | 45     |`effectcontrol2fine`           |
   * | 64     |`holdpedal`                    |
   * | 65     |`portamento`                   |
   * | 66     |`sustenutopedal`               |
   * | 67     |`softpedal`                    |
   * | 68     |`legatopedal`                  |
   * | 69     |`hold2pedal`                   |
   * | 70     |`soundvariation`               |
   * | 71     |`resonance`                    |
   * | 72     |`soundreleasetime`             |
   * | 73     |`soundattacktime`              |
   * | 74     |`brightness`                   |
   * | 75     |`soundcontrol6`                |
   * | 76     |`soundcontrol7`                |
   * | 77     |`soundcontrol8`                |
   * | 78     |`soundcontrol9`                |
   * | 79     |`soundcontrol10`               |
   * | 80     |`generalpurposebutton1`        |
   * | 81     |`generalpurposebutton2`        |
   * | 82     |`generalpurposebutton3`        |
   * | 83     |`generalpurposebutton4`        |
   * | 91     |`reverblevel`                  |
   * | 92     |`tremololevel`                 |
   * | 93     |`choruslevel`                  |
   * | 94     |`celestelevel`                 |
   * | 95     |`phaserlevel`                  |
   * | 96     |`dataincrement`                |
   * | 97     |`datadecrement`                |
   * | 98     |`nonregisteredparametercoarse` |
   * | 99     |`nonregisteredparameterfine`   |
   * | 100    |`registeredparametercoarse`    |
   * | 101    |`registeredparameterfine`      |
   * | 120    |`allsoundoff`                  |
   * | 121    |`resetallcontrollers`          |
   * | 122    |`localcontrol`                 |
   * | 123    |`allnotesoff`                  |
   * | 124    |`omnimodeoff`                  |
   * | 125    |`omnimodeon`                   |
   * | 126    |`monomodeon`                   |
   * | 127    |`polymodeon`                   |
   *
   * As you can see above, not all control change message have a matching name. This does not mean
   * you cannot use the others. It simply means you will need to use their number
   * (`0` to `127`) instead of their name. While you can still use them, numbers `120` to `127` are
   * usually reserved for *channel mode* messages. See
   * [`sendChannelMode()`]{@link OutputChannel#sendChannelMode} method for more info.
   *
   * To view a detailed list of all available **control change** messages, please consult "Table 3 -
   * Control Change Messages" from the [MIDI Messages](
   * https://www.midi.org/specifications/item/table-3-control-change-messages-data-bytes-2)
   * specification.
   *
   * **Note**: messages #0-31 (MSB) are paired with messages #32-63 (LSB). For example, message #1
   * (`modulationwheelcoarse`) can be accompanied by a second control change message for
   * `modulationwheelfine` to achieve a greater level of precision. if you want to specify both MSB
   * and LSB for messages between `0` and `31`, you can do so by passing a 2-value array as the
   * second parameter.
   *
   * @param {number|string} controller The MIDI controller name or number (`0` - `127`).
   *
   * @param {number|number[]} value The value to send (0-127). You can also use a two-position array
   * for controllers 0 to 31. In this scenario, the first value will be sent as usual and the second
   * value will be sent to the matching LSB controller (which is obtained by adding 32 to the first
   * controller)
   *
   * @param {object} [options={}]
   *
   * @param {number|string} [options.time=(now)] If `time` is a string prefixed with `"+"` and
   * followed by a number, the message will be delayed by that many milliseconds. If the value is a
   * positive number
   * ([`DOMHighResTimeStamp`]{@link https://developer.mozilla.org/docs/Web/API/DOMHighResTimeStamp}),
   * the operation will be scheduled for that time. The current time can be retrieved with
   * [`WebMidi.time`]{@link WebMidi#time}. If `options.time` is omitted, or in the past, the
   * operation will be carried out as soon as possible.
   *
   * @throws {RangeError} Controller numbers must be between 0 and 127.
   * @throws {RangeError} Invalid controller name.
   * @throws {TypeError} The value array must have a length of 2.
   *
   * @returns {OutputChannel} Returns the `OutputChannel` object so methods can be chained.
   *
   * @license Apache-2.0
   * @since 3.0.0
   */ sendControlChange(e11, t11, n11 = {}) {
        if ("string" == typeof e11 && (e11 = Utilities.getCcNumberByName(e11)), Array.isArray(t11) || (t11 = [
            t11
        ]), wm.validation) {
            if (void 0 === e11) throw new TypeError("Control change must be identified with a valid name or an integer between 0 and 127.");
            if (!Number.isInteger(e11) || !(e11 >= 0 && e11 <= 127)) throw new TypeError("Control change number must be an integer between 0 and 127.");
            if (2 === (t11 = t11.map((e11)=>{
                const t11 = Math.min(Math.max(parseInt(e11), 0), 127);
                if (isNaN(t11)) throw new TypeError("Values must be integers between 0 and 127");
                return t11;
            })).length && e11 >= 32) throw new TypeError("To use a value array, the controller must be between 0 and 31");
        }
        return t11.forEach((r11, i11)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.controlchange << 4) + (this.number - 1),
                e11 + 32 * i11,
                t11[i11]
            ], {
                time: Utilities.toTimestamp(n11.time)
            });
        }), this;
    }
    _selectNonRegisteredParameter(e11, t11 = {}) {
        return this.sendControlChange(99, e11[0], t11), this.sendControlChange(98, e11[1], t11), this;
    }
    _deselectRegisteredParameter(e11 = {}) {
        return this.sendControlChange(101, 127, e11), this.sendControlChange(100, 127, e11), this;
    }
    _deselectNonRegisteredParameter(e11 = {}) {
        return this.sendControlChange(101, 127, e11), this.sendControlChange(100, 127, e11), this;
    }
    _selectRegisteredParameter(e11, t11 = {}) {
        return this.sendControlChange(101, e11[0], t11), this.sendControlChange(100, e11[1], t11), this;
    }
    _setCurrentParameter(e11, t11 = {}) {
        return e11 = [].concat(e11), this.sendControlChange(6, e11[0], t11), e11.length < 2 || this.sendControlChange(38, e11[1], t11), this;
    }
    sendRpnDecrement(e11, t11 = {}) {
        if (Array.isArray(e11) || (e11 = Enumerations.REGISTERED_PARAMETERS[e11]), wm.validation) {
            if (void 0 === e11) throw new TypeError("The specified registered parameter is invalid.");
            let t11 = !1;
            if (Object.getOwnPropertyNames(Enumerations.REGISTERED_PARAMETERS).forEach((n11)=>{
                Enumerations.REGISTERED_PARAMETERS[n11][0] === e11[0] && Enumerations.REGISTERED_PARAMETERS[n11][1] === e11[1] && (t11 = !0);
            }), !t11) throw new TypeError("The specified registered parameter is invalid.");
        }
        return this._selectRegisteredParameter(e11, t11), this.sendControlChange(97, 0, t11), this._deselectRegisteredParameter(t11), this;
    }
    sendRpnIncrement(e11, t11 = {}) {
        if (Array.isArray(e11) || (e11 = Enumerations.REGISTERED_PARAMETERS[e11]), wm.validation) {
            if (void 0 === e11) throw new TypeError("The specified registered parameter is invalid.");
            let t11 = !1;
            if (Object.getOwnPropertyNames(Enumerations.REGISTERED_PARAMETERS).forEach((n11)=>{
                Enumerations.REGISTERED_PARAMETERS[n11][0] === e11[0] && Enumerations.REGISTERED_PARAMETERS[n11][1] === e11[1] && (t11 = !0);
            }), !t11) throw new TypeError("The specified registered parameter is invalid.");
        }
        return this._selectRegisteredParameter(e11, t11), this.sendControlChange(96, 0, t11), this._deselectRegisteredParameter(t11), this;
    }
    playNote(e11, t11 = {}) {
        this.sendNoteOn(e11, t11);
        const n11 = Array.isArray(e11) ? e11 : [
            e11
        ];
        for (let e11 of n11)if (parseInt(e11.duration) > 0) {
            const n11 = {
                time: (Utilities.toTimestamp(t11.time) || wm.time) + parseInt(e11.duration),
                release: e11.release,
                rawRelease: e11.rawRelease
            };
            this.sendNoteOff(e11, n11);
        } else if (parseInt(t11.duration) > 0) {
            const n11 = {
                time: (Utilities.toTimestamp(t11.time) || wm.time) + parseInt(t11.duration),
                release: t11.release,
                rawRelease: t11.rawRelease
            };
            this.sendNoteOff(e11, n11);
        }
        return this;
    }
    sendNoteOff(e11, t11 = {}) {
        if (wm.validation) {
            if (null != t11.rawRelease && !(t11.rawRelease >= 0 && t11.rawRelease <= 127)) throw new RangeError("The 'rawRelease' option must be an integer between 0 and 127");
            if (null != t11.release && !(t11.release >= 0 && t11.release <= 1)) throw new RangeError("The 'release' option must be an number between 0 and 1");
            t11.rawVelocity && (t11.rawRelease = t11.velocity, console.warn("The 'rawVelocity' option is deprecated. Use 'rawRelease' instead.")), t11.velocity && (t11.release = t11.velocity, console.warn("The 'velocity' option is deprecated. Use 'attack' instead."));
        }
        let n11 = 64;
        null != t11.rawRelease ? n11 = t11.rawRelease : isNaN(t11.release) || (n11 = Math.round(127 * t11.release));
        const r11 = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Utilities.buildNoteArray(e11, {
            rawRelease: parseInt(n11)
        }).forEach((e11)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.noteoff << 4) + (this.number - 1),
                e11.getOffsetNumber(r11),
                e11.rawRelease
            ], {
                time: Utilities.toTimestamp(t11.time)
            });
        }), this;
    }
    stopNote(e11, t11 = {}) {
        return this.sendNoteOff(e11, t11);
    }
    sendNoteOn(e11, t11 = {}) {
        if (wm.validation) {
            if (null != t11.rawAttack && !(t11.rawAttack >= 0 && t11.rawAttack <= 127)) throw new RangeError("The 'rawAttack' option must be an integer between 0 and 127");
            if (null != t11.attack && !(t11.attack >= 0 && t11.attack <= 1)) throw new RangeError("The 'attack' option must be an number between 0 and 1");
            t11.rawVelocity && (t11.rawAttack = t11.velocity, t11.rawRelease = t11.release, console.warn("The 'rawVelocity' option is deprecated. Use 'rawAttack' or 'rawRelease'.")), t11.velocity && (t11.attack = t11.velocity, console.warn("The 'velocity' option is deprecated. Use 'attack' instead."));
        }
        let n11 = 64;
        null != t11.rawAttack ? n11 = t11.rawAttack : isNaN(t11.attack) || (n11 = Math.round(127 * t11.attack));
        const r11 = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Utilities.buildNoteArray(e11, {
            rawAttack: n11
        }).forEach((e11)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.noteon << 4) + (this.number - 1),
                e11.getOffsetNumber(r11),
                e11.rawAttack
            ], {
                time: Utilities.toTimestamp(t11.time)
            });
        }), this;
    }
    sendChannelMode(e11, t11 = 0, n11 = {}) {
        if ("string" == typeof e11 && (e11 = Enumerations.CHANNEL_MODE_MESSAGES[e11]), wm.validation) {
            if (void 0 === e11) throw new TypeError("Invalid channel mode message name or number.");
            if (isNaN(e11) || !(e11 >= 120 && e11 <= 127)) throw new TypeError("Invalid channel mode message number.");
            if (isNaN(parseInt(t11)) || t11 < 0 || t11 > 127) throw new RangeError("Value must be an integer between 0 and 127.");
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.controlchange << 4) + (this.number - 1),
            e11,
            t11
        ], {
            time: Utilities.toTimestamp(n11.time)
        }), this;
    }
    sendOmniMode(e11, t11 = {}) {
        return void 0 === e11 || e11 ? this.sendChannelMode("omnimodeon", 0, t11) : this.sendChannelMode("omnimodeoff", 0, t11), this;
    }
    sendChannelAftertouch(e11, t11 = {}) {
        if (wm.validation) {
            if (isNaN(parseFloat(e11))) throw new RangeError("Invalid channel aftertouch value.");
            if (t11.rawValue) {
                if (!(e11 >= 0 && e11 <= 127 && Number.isInteger(e11))) throw new RangeError("Channel aftertouch raw value must be an integer between 0 and 127.");
            } else if (!(e11 >= 0 && e11 <= 1)) throw new RangeError("Channel aftertouch value must be a float between 0 and 1.");
        }
        return t11.rawValue || (e11 = Utilities.fromFloatTo7Bit(e11)), this.send([
            (Enumerations.CHANNEL_MESSAGES.channelaftertouch << 4) + (this.number - 1),
            Math.round(e11)
        ], {
            time: Utilities.toTimestamp(t11.time)
        }), this;
    }
    sendMasterTuning(e11, t11 = {}) {
        if (e11 = parseFloat(e11) || 0, wm.validation && !(e11 > -65 && e11 < 64)) throw new RangeError("The value must be a decimal number larger than -65 and smaller than 64.");
        let n11 = Math.floor(e11) + 64, r11 = e11 - Math.floor(e11);
        r11 = Math.round((r11 + 1) / 2 * 16383);
        let i11 = r11 >> 7 & 127, s11 = 127 & r11;
        return this.sendRpnValue("channelcoarsetuning", n11, t11), this.sendRpnValue("channelfinetuning", [
            i11,
            s11
        ], t11), this;
    }
    sendModulationRange(e11, t11, n11 = {}) {
        if (wm.validation) {
            if (!Number.isInteger(e11) || !(e11 >= 0 && e11 <= 127)) throw new RangeError("The semitones value must be an integer between 0 and 127.");
            if (!(null == t11 || Number.isInteger(t11) && t11 >= 0 && t11 <= 127)) throw new RangeError("If specified, the cents value must be an integer between 0 and 127.");
        }
        return t11 >= 0 && t11 <= 127 || (t11 = 0), this.sendRpnValue("modulationrange", [
            e11,
            t11
        ], n11), this;
    }
    sendNrpnValue(e11, t11, n11 = {}) {
        if (t11 = [].concat(t11), wm.validation) {
            if (!Array.isArray(e11) || !Number.isInteger(e11[0]) || !Number.isInteger(e11[1])) throw new TypeError("The specified NRPN is invalid.");
            if (!(e11[0] >= 0 && e11[0] <= 127)) throw new RangeError("The first byte of the NRPN must be between 0 and 127.");
            if (!(e11[1] >= 0 && e11[1] <= 127)) throw new RangeError("The second byte of the NRPN must be between 0 and 127.");
            t11.forEach((e11)=>{
                if (!(e11 >= 0 && e11 <= 127)) throw new RangeError("The data bytes of the NRPN must be between 0 and 127.");
            });
        }
        return this._selectNonRegisteredParameter(e11, n11), this._setCurrentParameter(t11, n11), this._deselectNonRegisteredParameter(n11), this;
    }
    sendPitchBend(e11, t11 = {}) {
        if (wm.validation) {
            if (t11.rawValue && Array.isArray(e11)) {
                if (!(e11[0] >= 0 && e11[0] <= 127)) throw new RangeError("The pitch bend MSB must be an integer between 0 and 127.");
                if (!(e11[1] >= 0 && e11[1] <= 127)) throw new RangeError("The pitch bend LSB must be an integer between 0 and 127.");
            } else if (t11.rawValue && !Array.isArray(e11)) {
                if (!(e11 >= 0 && e11 <= 127)) throw new RangeError("The pitch bend MSB must be an integer between 0 and 127.");
            } else {
                if (isNaN(e11) || null === e11) throw new RangeError("Invalid pitch bend value.");
                if (!(e11 >= -1 && e11 <= 1)) throw new RangeError("The pitch bend value must be a float between -1 and 1.");
            }
        }
        let n11 = 0, r11 = 0;
        if (t11.rawValue && Array.isArray(e11)) n11 = e11[0], r11 = e11[1];
        else if (t11.rawValue && !Array.isArray(e11)) n11 = e11;
        else {
            const t11 = Utilities.fromFloatToMsbLsb((e11 + 1) / 2);
            n11 = t11.msb, r11 = t11.lsb;
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.pitchbend << 4) + (this.number - 1),
            r11,
            n11
        ], {
            time: Utilities.toTimestamp(t11.time)
        }), this;
    }
    sendPitchBendRange(e11, t11, n11 = {}) {
        if (wm.validation) {
            if (!Number.isInteger(e11) || !(e11 >= 0 && e11 <= 127)) throw new RangeError("The semitones value must be an integer between 0 and 127.");
            if (!Number.isInteger(t11) || !(t11 >= 0 && t11 <= 127)) throw new RangeError("The cents value must be an integer between 0 and 127.");
        }
        return this.sendRpnValue("pitchbendrange", [
            e11,
            t11
        ], n11), this;
    }
    sendProgramChange(e11, t11 = {}) {
        if (e11 = parseInt(e11) || 0, wm.validation && !(e11 >= 0 && e11 <= 127)) throw new RangeError("The program number must be between 0 and 127.");
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.programchange << 4) + (this.number - 1),
            e11
        ], {
            time: Utilities.toTimestamp(t11.time)
        }), this;
    }
    sendRpnValue(e11, t11, n11 = {}) {
        if (Array.isArray(e11) || (e11 = Enumerations.REGISTERED_PARAMETERS[e11]), wm.validation) {
            if (!Number.isInteger(e11[0]) || !Number.isInteger(e11[1])) throw new TypeError("The specified NRPN is invalid.");
            if (!(e11[0] >= 0 && e11[0] <= 127)) throw new RangeError("The first byte of the RPN must be between 0 and 127.");
            if (!(e11[1] >= 0 && e11[1] <= 127)) throw new RangeError("The second byte of the RPN must be between 0 and 127.");
            [].concat(t11).forEach((e11)=>{
                if (!(e11 >= 0 && e11 <= 127)) throw new RangeError("The data bytes of the RPN must be between 0 and 127.");
            });
        }
        return this._selectRegisteredParameter(e11, n11), this._setCurrentParameter(t11, n11), this._deselectRegisteredParameter(n11), this;
    }
    sendTuningBank(e11, t11 = {}) {
        if (wm.validation && (!Number.isInteger(e11) || !(e11 >= 0 && e11 <= 127))) throw new RangeError("The tuning bank number must be between 0 and 127.");
        return this.sendRpnValue("tuningbank", e11, t11), this;
    }
    sendTuningProgram(e11, t11 = {}) {
        if (wm.validation && (!Number.isInteger(e11) || !(e11 >= 0 && e11 <= 127))) throw new RangeError("The tuning program number must be between 0 and 127.");
        return this.sendRpnValue("tuningprogram", e11, t11), this;
    }
    sendLocalControl(e11, t11 = {}) {
        return e11 ? this.sendChannelMode("localcontrol", 127, t11) : this.sendChannelMode("localcontrol", 0, t11);
    }
    sendAllNotesOff(e11 = {}) {
        return this.sendChannelMode("allnotesoff", 0, e11);
    }
    sendAllSoundOff(e11 = {}) {
        return this.sendChannelMode("allsoundoff", 0, e11);
    }
    sendResetAllControllers(e11 = {}) {
        return this.sendChannelMode("resetallcontrollers", 0, e11);
    }
    sendPolyphonicMode(e11, t11 = {}) {
        return "mono" === e11 ? this.sendChannelMode("monomodeon", 0, t11) : this.sendChannelMode("polymodeon", 0, t11);
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e11) {
        if (this.validation && (e11 = parseInt(e11), isNaN(e11))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e11;
    }
    get output() {
        return this._output;
    }
    get number() {
        return this._number;
    }
}
/**
 * The `Output` class represents a single MIDI output port (not to be confused with a MIDI channel).
 * A port is made available by a MIDI device. A MIDI device can advertise several input and output
 * ports. Each port has 16 MIDI channels which can be accessed via the [`channels`](#channels)
 * property.
 *
 * The `Output` object is automatically instantiated by the library according to the host's MIDI
 * subsystem and should not be directly instantiated.
 *
 * You can access all available `Output` objects by referring to the
 * [`WebMidi.outputs`](WebMidi#outputs) array or by using methods such as
 * [`WebMidi.getOutputByName()`](WebMidi#getOutputByName) or
 * [`WebMidi.getOutputById()`](WebMidi#getOutputById).
 *
 * @fires Output#opened
 * @fires Output#disconnected
 * @fires Output#closed
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class Output extends EventEmitter {
    constructor(e11){
        super(), this._midiOutput = e11, this._octaveOffset = 0, this.channels = [];
        for(let e11 = 1; e11 <= 16; e11++)this.channels[e11] = new OutputChannel(this, e11);
        this._midiOutput.onstatechange = this._onStateChange.bind(this);
    }
    async destroy() {
        this.removeListener(), this.channels.forEach((e11)=>e11.destroy()), this.channels = [], this._midiOutput && (this._midiOutput.onstatechange = null), await this.close(), this._midiOutput = null;
    }
    _onStateChange(e11) {
        let t11 = {
            timestamp: wm.time
        };
        "open" === e11.port.connection ? (t11.type = "opened", t11.target = this, t11.port = t11.target, this.emit("opened", t11)) : "closed" === e11.port.connection && "connected" === e11.port.state ? (t11.type = "closed", t11.target = this, t11.port = t11.target, this.emit("closed", t11)) : "closed" === e11.port.connection && "disconnected" === e11.port.state ? (t11.type = "disconnected", t11.port = {
            connection: e11.port.connection,
            id: e11.port.id,
            manufacturer: e11.port.manufacturer,
            name: e11.port.name,
            state: e11.port.state,
            type: e11.port.type
        }, this.emit("disconnected", t11)) : "pending" === e11.port.connection && "disconnected" === e11.port.state || console.warn("This statechange event was not caught:", e11.port.connection, e11.port.state);
    }
    async open() {
        try {
            return await this._midiOutput.open(), Promise.resolve(this);
        } catch (e11) {
            return Promise.reject(e11);
        }
    }
    async close() {
        this._midiOutput ? await this._midiOutput.close() : await Promise.resolve();
    }
    /**
   * Sends a MIDI message on the MIDI output port. If no time is specified, the message will be
   * sent immediately. The message should be an array of 8 bit unsigned integers (0-225), a
   * [`Uint8Array`]{@link https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array}
   * object or a [`Message`](Message) object.
   *
   * It is usually not necessary to use this method directly as you can use one of the simpler
   * helper methods such as [`playNote()`](#playNote), [`stopNote()`](#stopNote),
   * [`sendControlChange()`](#sendControlChange), etc.
   *
   * Details on the format of MIDI messages are available in the summary of
   * [MIDI messages]{@link https://www.midi.org/specifications-old/item/table-1-summary-of-midi-message}
   * from the MIDI Manufacturers Association.
   *
   * @param message {number[]|Uint8Array|Message} An array of 8bit unsigned integers, a `Uint8Array`
   * object (not available in Node.js) containing the message bytes or a `Message` object.
   *
   * @param {object} [options={}]
   *
   * @param {number|string} [options.time=(now)] If `time` is a string prefixed with `"+"` and
   * followed by a number, the message will be delayed by that many milliseconds. If the value is a
   * positive number
   * ([`DOMHighResTimeStamp`]{@link https://developer.mozilla.org/docs/Web/API/DOMHighResTimeStamp}),
   * the operation will be scheduled for that time. The current time can be retrieved with
   * [`WebMidi.time`]{@link WebMidi#time}. If `options.time` is omitted, or in the past, the
   * operation will be carried out as soon as possible.
   *
   * @throws {RangeError} The first byte (status) must be an integer between 128 and 255.
   *
   * @returns {Output} Returns the `Output` object so methods can be chained.
   *
   * @license Apache-2.0
   */ send(e11, t11 = {
        time: 0
    }, n11 = 0) {
        if (e11 instanceof Message && (e11 = Utilities.isNode ? e11.data : e11.rawData), e11 instanceof Uint8Array && Utilities.isNode && (e11 = Array.from(e11)), wm.validation) {
            if (Array.isArray(e11) || e11 instanceof Uint8Array || (e11 = [
                e11
            ], Array.isArray(t11) && (e11 = e11.concat(t11)), t11 = isNaN(n11) ? {
                time: 0
            } : {
                time: n11
            }), !(parseInt(e11[0]) >= 128 && parseInt(e11[0]) <= 255)) throw new RangeError("The first byte (status) must be an integer between 128 and 255.");
            e11.slice(1).forEach((e11)=>{
                if (!((e11 = parseInt(e11)) >= 0 && e11 <= 255)) throw new RangeError("Data bytes must be integers between 0 and 255.");
            }), t11 || (t11 = {
                time: 0
            });
        }
        return this._midiOutput.send(e11, Utilities.toTimestamp(t11.time)), this;
    }
    sendSysex(e11, t11 = [], n11 = {}) {
        if (e11 = [].concat(e11), t11 instanceof Uint8Array) {
            const r11 = new Uint8Array(1 + e11.length + t11.length + 1);
            r11[0] = Enumerations.SYSTEM_MESSAGES.sysex, r11.set(Uint8Array.from(e11), 1), r11.set(t11, 1 + e11.length), r11[r11.length - 1] = Enumerations.SYSTEM_MESSAGES.sysexend, this.send(r11, {
                time: n11.time
            });
        } else {
            const r11 = e11.concat(t11, Enumerations.SYSTEM_MESSAGES.sysexend);
            this.send([
                Enumerations.SYSTEM_MESSAGES.sysex
            ].concat(r11), {
                time: n11.time
            });
        }
        return this;
    }
    clear() {
        return this._midiOutput.clear ? this._midiOutput.clear() : wm.validation && console.warn("The 'clear()' method has not yet been implemented in your environment."), this;
    }
    sendTimecodeQuarterFrame(e11, t11 = {}) {
        if (wm.validation && (e11 = parseInt(e11), isNaN(e11) || !(e11 >= 0 && e11 <= 127))) throw new RangeError("The value must be an integer between 0 and 127.");
        return this.send([
            Enumerations.SYSTEM_MESSAGES.timecode,
            e11
        ], {
            time: t11.time
        }), this;
    }
    sendSongPosition(e11 = 0, t11 = {}) {
        var n11 = (e11 = Math.floor(e11) || 0) >> 7 & 127, r11 = 127 & e11;
        return this.send([
            Enumerations.SYSTEM_MESSAGES.songposition,
            n11,
            r11
        ], {
            time: t11.time
        }), this;
    }
    sendSongSelect(e11 = 0, t11 = {}) {
        if (wm.validation && (e11 = parseInt(e11), isNaN(e11) || !(e11 >= 0 && e11 <= 127))) throw new RangeError("The program value must be between 0 and 127");
        return this.send([
            Enumerations.SYSTEM_MESSAGES.songselect,
            e11
        ], {
            time: t11.time
        }), this;
    }
    sendTuneRequest(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.tunerequest
        ], {
            time: e11.time
        }), this;
    }
    sendClock(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.clock
        ], {
            time: e11.time
        }), this;
    }
    sendStart(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.start
        ], {
            time: e11.time
        }), this;
    }
    sendContinue(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.continue
        ], {
            time: e11.time
        }), this;
    }
    sendStop(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.stop
        ], {
            time: e11.time
        }), this;
    }
    sendActiveSensing(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.activesensing
        ], {
            time: e11.time
        }), this;
    }
    sendReset(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.reset
        ], {
            time: e11.time
        }), this;
    }
    sendTuningRequest(e11 = {}) {
        return wm.validation && console.warn("The sendTuningRequest() method has been deprecated. Use sendTuningRequest() instead."), this.sendTuneRequest(e11);
    }
    sendKeyAftertouch(e11, t11, n11 = {}) {
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendKeyAftertouch(e11, t11, n11);
        }), this;
    }
    sendControlChange(e11, t11, n11 = {}, r11 = {}) {
        if (wm.validation && (Array.isArray(n11) || Number.isInteger(n11) || "all" === n11)) {
            const e11 = n11;
            (n11 = r11).channels = e11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendControlChange(e11, t11, n11);
        }), this;
    }
    sendPitchBendRange(e11 = 0, t11 = 0, n11 = {}) {
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendPitchBendRange(e11, t11, n11);
        }), this;
    }
    setPitchBendRange(e11 = 0, t11 = 0, n11 = "all", r11 = {}) {
        return wm.validation && (console.warn("The setPitchBendRange() method is deprecated. Use sendPitchBendRange() instead."), r11.channels = n11, "all" === r11.channels && (r11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendPitchBendRange(e11, t11, r11);
    }
    sendRpnValue(e11, t11, n11 = {}) {
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendRpnValue(e11, t11, n11);
        }), this;
    }
    setRegisteredParameter(e11, t11 = [], n11 = "all", r11 = {}) {
        return wm.validation && (console.warn("The setRegisteredParameter() method is deprecated. Use sendRpnValue() instead."), r11.channels = n11, "all" === r11.channels && (r11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnValue(e11, t11, r11);
    }
    sendChannelAftertouch(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendChannelAftertouch(e11, t11);
        }), this;
    }
    sendPitchBend(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendPitchBend(e11, t11);
        }), this;
    }
    sendProgramChange(e11 = 0, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendProgramChange(e11, t11);
        }), this;
    }
    sendModulationRange(e11, t11, n11 = {}) {
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendModulationRange(e11, t11, n11);
        }), this;
    }
    setModulationRange(e11 = 0, t11 = 0, n11 = "all", r11 = {}) {
        return wm.validation && (console.warn("The setModulationRange() method is deprecated. Use sendModulationRange() instead."), r11.channels = n11, "all" === r11.channels && (r11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendModulationRange(e11, t11, r11);
    }
    sendMasterTuning(e11, t11 = {}) {
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendMasterTuning(e11, t11);
        }), this;
    }
    setMasterTuning(e11, t11 = {}, n11 = {}) {
        return wm.validation && (console.warn("The setMasterTuning() method is deprecated. Use sendMasterTuning() instead."), n11.channels = t11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendMasterTuning(e11, n11);
    }
    sendTuningProgram(e11, t11 = {}) {
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendTuningProgram(e11, t11);
        }), this;
    }
    setTuningProgram(e11, t11 = "all", n11 = {}) {
        return wm.validation && (console.warn("The setTuningProgram() method is deprecated. Use sendTuningProgram() instead."), n11.channels = t11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendTuningProgram(e11, n11);
    }
    sendTuningBank(e11 = 0, t11 = {}) {
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendTuningBank(e11, t11);
        }), this;
    }
    setTuningBank(e11, t11 = "all", n11 = {}) {
        return wm.validation && (console.warn("The setTuningBank() method is deprecated. Use sendTuningBank() instead."), n11.channels = t11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendTuningBank(e11, n11);
    }
    sendChannelMode(e11, t11 = 0, n11 = {}, r11 = {}) {
        if (wm.validation && (Array.isArray(n11) || Number.isInteger(n11) || "all" === n11)) {
            const e11 = n11;
            (n11 = r11).channels = e11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendChannelMode(e11, t11, n11);
        }), this;
    }
    sendAllSoundOff(e11 = {}) {
        return null == e11.channels && (e11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e11.channels).forEach((t11)=>{
            this.channels[t11].sendAllSoundOff(e11);
        }), this;
    }
    sendAllNotesOff(e11 = {}) {
        return null == e11.channels && (e11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e11.channels).forEach((t11)=>{
            this.channels[t11].sendAllNotesOff(e11);
        }), this;
    }
    sendResetAllControllers(e11 = {}, t11 = {}) {
        if (wm.validation && (Array.isArray(e11) || Number.isInteger(e11) || "all" === e11)) {
            const n11 = e11;
            (e11 = t11).channels = n11, "all" === e11.channels && (e11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == e11.channels && (e11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e11.channels).forEach((t11)=>{
            this.channels[t11].sendResetAllControllers(e11);
        }), this;
    }
    sendPolyphonicMode(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendPolyphonicMode(e11, t11);
        }), this;
    }
    sendLocalControl(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendLocalControl(e11, t11);
        }), this;
    }
    sendOmniMode(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendOmniMode(e11, t11);
        }), this;
    }
    sendNrpnValue(e11, t11, n11 = {}) {
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendNrpnValue(e11, t11, n11);
        }), this;
    }
    setNonRegisteredParameter(e11, t11 = [], n11 = "all", r11 = {}) {
        return wm.validation && (console.warn("The setNonRegisteredParameter() method is deprecated. Use sendNrpnValue() instead."), r11.channels = n11, "all" === r11.channels && (r11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendNrpnValue(e11, t11, r11);
    }
    sendRpnIncrement(e11, t11 = {}) {
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendRpnIncrement(e11, t11);
        }), this;
    }
    incrementRegisteredParameter(e11, t11 = "all", n11 = {}) {
        return wm.validation && (console.warn("The incrementRegisteredParameter() method is deprecated. Use sendRpnIncrement() instead."), n11.channels = t11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnIncrement(e11, n11);
    }
    sendRpnDecrement(e11, t11 = {}) {
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendRpnDecrement(e11, t11);
        }), this;
    }
    decrementRegisteredParameter(e11, t11 = "all", n11 = {}) {
        return wm.validation && (console.warn("The decrementRegisteredParameter() method is deprecated. Use sendRpnDecrement() instead."), n11.channels = t11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnDecrement(e11, n11);
    }
    sendNoteOff(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendNoteOff(e11, t11);
        }), this;
    }
    stopNote(e11, t11) {
        return this.sendNoteOff(e11, t11);
    }
    playNote(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (t11.rawVelocity && console.warn("The 'rawVelocity' option is deprecated. Use 'rawAttack' instead."), t11.velocity && console.warn("The 'velocity' option is deprecated. Use 'velocity' instead."), Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].playNote(e11, t11);
        }), this;
    }
    sendNoteOn(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendNoteOn(e11, t11);
        }), this;
    }
    get name() {
        return this._midiOutput.name;
    }
    get id() {
        return this._midiOutput.id;
    }
    get connection() {
        return this._midiOutput.connection;
    }
    get manufacturer() {
        return this._midiOutput.manufacturer;
    }
    get state() {
        return this._midiOutput.state;
    }
    get type() {
        return this._midiOutput.type;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e11) {
        if (this.validation && (e11 = parseInt(e11), isNaN(e11))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e11;
    }
}
/**
 * The `Forwarder` class allows the forwarding of MIDI messages to predetermined outputs. When you
 * call its [`forward()`](#forward) method, it will send the specified [`Message`](Message) object
 * to all the outputs listed in its [`destinations`](#destinations) property.
 *
 * If specific channels or message types have been defined in the [`channels`](#channels) or
 * [`types`](#types) properties, only messages matching the channels/types will be forwarded.
 *
 * While it can be manually instantiated, you are more likely to come across a `Forwarder` object as
 * the return value of the [`Input.addForwarder()`](Input#addForwarder) method.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Forwarder {
    constructor(e11 = [], t11 = {}){
        this.destinations = [], this.types = [
            ...Object.keys(Enumerations.SYSTEM_MESSAGES),
            ...Object.keys(Enumerations.CHANNEL_MESSAGES)
        ], this.channels = Enumerations.MIDI_CHANNEL_NUMBERS, this.suspended = !1, Array.isArray(e11) || (e11 = [
            e11
        ]), t11.types && !Array.isArray(t11.types) && (t11.types = [
            t11.types
        ]), t11.channels && !Array.isArray(t11.channels) && (t11.channels = [
            t11.channels
        ]), wm.validation && (e11.forEach((e11)=>{
            if (!(e11 instanceof Output)) throw new TypeError("Destinations must be of type 'Output'.");
        }), void 0 !== t11.types && t11.types.forEach((e11)=>{
            if (!Enumerations.SYSTEM_MESSAGES.hasOwnProperty(e11) && !Enumerations.CHANNEL_MESSAGES.hasOwnProperty(e11)) throw new TypeError("Type must be a valid message type.");
        }), void 0 !== t11.channels && t11.channels.forEach((e11)=>{
            if (!Enumerations.MIDI_CHANNEL_NUMBERS.includes(e11)) throw new TypeError("MIDI channel must be between 1 and 16.");
        })), this.destinations = e11, t11.types && (this.types = t11.types), t11.channels && (this.channels = t11.channels);
    }
    forward(e11) {
        this.suspended || this.types.includes(e11.type) && (e11.channel && !this.channels.includes(e11.channel) || this.destinations.forEach((t11)=>{
            (!wm.validation || t11 instanceof Output) && t11.send(e11);
        }));
    }
}
/**
 * The `InputChannel` class represents a single MIDI input channel (1-16) from a single input
 * device. This object is derived from the host's MIDI subsystem and should not be instantiated
 * directly.
 *
 * All 16 `InputChannel` objects can be found inside the input's [`channels`](Input#channels)
 * property.
 *
 * @fires InputChannel#midimessage
 * @fires InputChannel#unknownmessage
 *
 * @fires InputChannel#noteoff
 * @fires InputChannel#noteon
 * @fires InputChannel#keyaftertouch
 * @fires InputChannel#programchange
 * @fires InputChannel#channelaftertouch
 * @fires InputChannel#pitchbend
 *
 * @fires InputChannel#allnotesoff
 * @fires InputChannel#allsoundoff
 * @fires InputChannel#localcontrol
 * @fires InputChannel#monomode
 * @fires InputChannel#omnimode
 * @fires InputChannel#resetallcontrollers
 *
 * @fires InputChannel#event:nrpn
 * @fires InputChannel#event:nrpn-dataentrycoarse
 * @fires InputChannel#event:nrpn-dataentryfine
 * @fires InputChannel#event:nrpn-dataincrement
 * @fires InputChannel#event:nrpn-datadecrement
 * @fires InputChannel#event:rpn
 * @fires InputChannel#event:rpn-dataentrycoarse
 * @fires InputChannel#event:rpn-dataentryfine
 * @fires InputChannel#event:rpn-dataincrement
 * @fires InputChannel#event:rpn-datadecrement
 *
 * @fires InputChannel#controlchange
 * @fires InputChannel#event:controlchange-controllerxxx
 * @fires InputChannel#event:controlchange-bankselectcoarse
 * @fires InputChannel#event:controlchange-modulationwheelcoarse
 * @fires InputChannel#event:controlchange-breathcontrollercoarse
 * @fires InputChannel#event:controlchange-footcontrollercoarse
 * @fires InputChannel#event:controlchange-portamentotimecoarse
 * @fires InputChannel#event:controlchange-dataentrycoarse
 * @fires InputChannel#event:controlchange-volumecoarse
 * @fires InputChannel#event:controlchange-balancecoarse
 * @fires InputChannel#event:controlchange-pancoarse
 * @fires InputChannel#event:controlchange-expressioncoarse
 * @fires InputChannel#event:controlchange-effectcontrol1coarse
 * @fires InputChannel#event:controlchange-effectcontrol2coarse
 * @fires InputChannel#event:controlchange-generalpurposecontroller1
 * @fires InputChannel#event:controlchange-generalpurposecontroller2
 * @fires InputChannel#event:controlchange-generalpurposecontroller3
 * @fires InputChannel#event:controlchange-generalpurposecontroller4
 * @fires InputChannel#event:controlchange-bankselectfine
 * @fires InputChannel#event:controlchange-modulationwheelfine
 * @fires InputChannel#event:controlchange-breathcontrollerfine
 * @fires InputChannel#event:controlchange-footcontrollerfine
 * @fires InputChannel#event:controlchange-portamentotimefine
 * @fires InputChannel#event:controlchange-dataentryfine
 * @fires InputChannel#event:controlchange-channelvolumefine
 * @fires InputChannel#event:controlchange-balancefine
 * @fires InputChannel#event:controlchange-panfine
 * @fires InputChannel#event:controlchange-expressionfine
 * @fires InputChannel#event:controlchange-effectcontrol1fine
 * @fires InputChannel#event:controlchange-effectcontrol2fine
 * @fires InputChannel#event:controlchange-damperpedal
 * @fires InputChannel#event:controlchange-portamento
 * @fires InputChannel#event:controlchange-sostenuto
 * @fires InputChannel#event:controlchange-softpedal
 * @fires InputChannel#event:controlchange-legatopedal
 * @fires InputChannel#event:controlchange-hold2
 * @fires InputChannel#event:controlchange-soundvariation
 * @fires InputChannel#event:controlchange-resonance
 * @fires InputChannel#event:controlchange-releasetime
 * @fires InputChannel#event:controlchange-attacktime
 * @fires InputChannel#event:controlchange-brightness
 * @fires InputChannel#event:controlchange-decaytime
 * @fires InputChannel#event:controlchange-vibratorate
 * @fires InputChannel#event:controlchange-vibratodepth
 * @fires InputChannel#event:controlchange-vibratodelay
 * @fires InputChannel#event:controlchange-generalpurposecontroller5
 * @fires InputChannel#event:controlchange-generalpurposecontroller6
 * @fires InputChannel#event:controlchange-generalpurposecontroller7
 * @fires InputChannel#event:controlchange-generalpurposecontroller8
 * @fires InputChannel#event:controlchange-portamentocontrol
 * @fires InputChannel#event:controlchange-highresolutionvelocityprefix
 * @fires InputChannel#event:controlchange-effect1depth
 * @fires InputChannel#event:controlchange-effect2depth
 * @fires InputChannel#event:controlchange-effect3depth
 * @fires InputChannel#event:controlchange-effect4depth
 * @fires InputChannel#event:controlchange-effect5depth
 * @fires InputChannel#event:controlchange-dataincrement
 * @fires InputChannel#event:controlchange-datadecrement
 * @fires InputChannel#event:controlchange-nonregisteredparameterfine
 * @fires InputChannel#event:controlchange-nonregisteredparametercoarse
 * @fires InputChannel#event:controlchange-registeredparameterfine
 * @fires InputChannel#event:controlchange-registeredparametercoarse
 * @fires InputChannel#event:controlchange-allsoundoff
 * @fires InputChannel#event:controlchange-resetallcontrollers
 * @fires InputChannel#event:controlchange-localcontrol
 * @fires InputChannel#event:controlchange-allnotesoff
 * @fires InputChannel#event:controlchange-omnimodeoff
 * @fires InputChannel#event:controlchange-omnimodeon
 * @fires InputChannel#event:controlchange-monomodeon
 * @fires InputChannel#event:controlchange-polymodeon
 * @fires InputChannel#event:
 *
 * @extends EventEmitter
 * @license Apache-2.0
 * @since 3.0.0
 */ class InputChannel extends EventEmitter {
    constructor(e11, t11){
        super(), this._input = e11, this._number = t11, this._octaveOffset = 0, this._nrpnBuffer = [], this._rpnBuffer = [], this.parameterNumberEventsEnabled = !0, this.notesState = new Array(128).fill(!1);
    }
    destroy() {
        this._input = null, this._number = null, this._octaveOffset = 0, this._nrpnBuffer = [], this.notesState = new Array(128).fill(!1), this.parameterNumberEventsEnabled = !1, this.removeListener();
    }
    _processMidiMessageEvent(e11) {
        const t11 = Object.assign({}, e11);
        t11.port = this.input, t11.target = this, t11.type = "midimessage", this.emit(t11.type, t11), this._parseEventForStandardMessages(t11);
    }
    _parseEventForStandardMessages(e11) {
        const t11 = Object.assign({}, e11);
        t11.type = t11.message.type || "unknownmessage";
        const n11 = e11.message.dataBytes[0], r11 = e11.message.dataBytes[1];
        if ("noteoff" === t11.type || "noteon" === t11.type && 0 === r11) this.notesState[n11] = !1, t11.type = "noteoff", t11.note = new Note(Utilities.offsetNumber(n11, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset), {
            rawAttack: 0,
            rawRelease: r11
        }), t11.value = Utilities.from7bitToFloat(r11), t11.rawValue = r11, t11.velocity = t11.note.release, t11.rawVelocity = t11.note.rawRelease;
        else if ("noteon" === t11.type) this.notesState[n11] = !0, t11.note = new Note(Utilities.offsetNumber(n11, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset), {
            rawAttack: r11
        }), t11.value = Utilities.from7bitToFloat(r11), t11.rawValue = r11, t11.velocity = t11.note.attack, t11.rawVelocity = t11.note.rawAttack;
        else if ("keyaftertouch" === t11.type) t11.note = new Note(Utilities.offsetNumber(n11, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset)), t11.value = Utilities.from7bitToFloat(r11), t11.rawValue = r11, t11.identifier = t11.note.identifier, t11.key = t11.note.number, t11.rawKey = n11;
        else if ("controlchange" === t11.type) {
            t11.controller = {
                number: n11,
                name: Enumerations.CONTROL_CHANGE_MESSAGES[n11].name,
                description: Enumerations.CONTROL_CHANGE_MESSAGES[n11].description,
                position: Enumerations.CONTROL_CHANGE_MESSAGES[n11].position
            }, t11.subtype = t11.controller.name || "controller" + n11, t11.value = Utilities.from7bitToFloat(r11), t11.rawValue = r11;
            const e11 = Object.assign({}, t11);
            e11.type = `${t11.type}-controller${n11}`, delete e11.subtype, this.emit(e11.type, e11);
            const i11 = Object.assign({}, t11);
            i11.type = t11.type + "-" + Enumerations.CONTROL_CHANGE_MESSAGES[n11].name, delete i11.subtype, 0 !== i11.type.indexOf("controller") && this.emit(i11.type, i11), t11.message.dataBytes[0] >= 120 && this._parseChannelModeMessage(t11), this.parameterNumberEventsEnabled && this._isRpnOrNrpnController(t11.message.dataBytes[0]) && this._parseEventForParameterNumber(t11);
        } else "programchange" === t11.type ? (t11.value = n11, t11.rawValue = t11.value) : "channelaftertouch" === t11.type ? (t11.value = Utilities.from7bitToFloat(n11), t11.rawValue = n11) : "pitchbend" === t11.type ? (t11.value = ((r11 << 7) + n11 - 8192) / 8192, t11.rawValue = (r11 << 7) + n11) : t11.type = "unknownmessage";
        this.emit(t11.type, t11);
    }
    _parseChannelModeMessage(e11) {
        const t11 = Object.assign({}, e11);
        t11.type = t11.controller.name, "localcontrol" === t11.type && (t11.value = 127 === t11.message.data[2], t11.rawValue = t11.message.data[2]), "omnimodeon" === t11.type ? (t11.type = "omnimode", t11.value = !0, t11.rawValue = t11.message.data[2]) : "omnimodeoff" === t11.type && (t11.type = "omnimode", t11.value = !1, t11.rawValue = t11.message.data[2]), "monomodeon" === t11.type ? (t11.type = "monomode", t11.value = !0, t11.rawValue = t11.message.data[2]) : "polymodeon" === t11.type && (t11.type = "monomode", t11.value = !1, t11.rawValue = t11.message.data[2]), this.emit(t11.type, t11);
    }
    _parseEventForParameterNumber(e11) {
        const t11 = e11.message.dataBytes[0], n11 = e11.message.dataBytes[1];
        99 === t11 || 101 === t11 ? (this._nrpnBuffer = [], this._rpnBuffer = [], 99 === t11 ? this._nrpnBuffer = [
            e11.message
        ] : 127 !== n11 && (this._rpnBuffer = [
            e11.message
        ])) : 98 === t11 || 100 === t11 ? 98 === t11 ? (this._rpnBuffer = [], 1 === this._nrpnBuffer.length ? this._nrpnBuffer.push(e11.message) : this._nrpnBuffer = []) : (this._nrpnBuffer = [], 1 === this._rpnBuffer.length && 127 !== n11 ? this._rpnBuffer.push(e11.message) : this._rpnBuffer = []) : 6 !== t11 && 38 !== t11 && 96 !== t11 && 97 !== t11 || (2 === this._rpnBuffer.length ? this._dispatchParameterNumberEvent("rpn", this._rpnBuffer[0].dataBytes[1], this._rpnBuffer[1].dataBytes[1], e11) : 2 === this._nrpnBuffer.length ? this._dispatchParameterNumberEvent("nrpn", this._nrpnBuffer[0].dataBytes[1], this._nrpnBuffer[1].dataBytes[1], e11) : (this._nrpnBuffer = [], this._rpnBuffer = []));
    }
    _isRpnOrNrpnController(e11) {
        return 6 === e11 || 38 === e11 || 96 === e11 || 97 === e11 || 98 === e11 || 99 === e11 || 100 === e11 || 101 === e11;
    }
    _dispatchParameterNumberEvent(e11, t11, n11, r11) {
        e11 = "nrpn" === e11 ? "nrpn" : "rpn";
        const i11 = {
            target: r11.target,
            timestamp: r11.timestamp,
            message: r11.message,
            parameterMsb: t11,
            parameterLsb: n11,
            value: Utilities.from7bitToFloat(r11.message.dataBytes[1]),
            rawValue: r11.message.dataBytes[1]
        };
        i11.parameter = "rpn" === e11 ? Object.keys(Enumerations.REGISTERED_PARAMETERS).find((e11)=>Enumerations.REGISTERED_PARAMETERS[e11][0] === t11 && Enumerations.REGISTERED_PARAMETERS[e11][1] === n11) : (t11 << 7) + n11;
        const s11 = Enumerations.CONTROL_CHANGE_MESSAGES[r11.message.dataBytes[0]].name;
        i11.type = `${e11}-${s11}`, this.emit(i11.type, i11);
        const a11 = Object.assign({}, i11);
        "nrpn-dataincrement" === a11.type ? a11.type = "nrpn-databuttonincrement" : "nrpn-datadecrement" === a11.type ? a11.type = "nrpn-databuttondecrement" : "rpn-dataincrement" === a11.type ? a11.type = "rpn-databuttonincrement" : "rpn-datadecrement" === a11.type && (a11.type = "rpn-databuttondecrement"), this.emit(a11.type, a11), i11.type = e11, i11.subtype = s11, this.emit(i11.type, i11);
    }
    getChannelModeByNumber(e11) {
        return wm.validation && (console.warn("The 'getChannelModeByNumber()' method has been moved to the 'Utilities' class."), e11 = Math.floor(e11)), Utilities.getChannelModeByNumber(e11);
    }
    getCcNameByNumber(e11) {
        if (wm.validation && (console.warn("The 'getCcNameByNumber()' method has been moved to the 'Utilities' class."), !((e11 = parseInt(e11)) >= 0 && e11 <= 127))) throw new RangeError("Invalid control change number.");
        return Utilities.getCcNameByNumber(e11);
    }
    getNoteState(e11) {
        e11 instanceof Note && (e11 = e11.identifier);
        const t11 = Utilities.guessNoteNumber(e11, wm.octaveOffset + this.input.octaveOffset + this.octaveOffset);
        return this.notesState[t11];
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e11) {
        if (this.validation && (e11 = parseInt(e11), isNaN(e11))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e11;
    }
    get input() {
        return this._input;
    }
    get number() {
        return this._number;
    }
    get nrpnEventsEnabled() {
        return this.parameterNumberEventsEnabled;
    }
    set nrpnEventsEnabled(e11) {
        this.validation && (e11 = !!e11), this.parameterNumberEventsEnabled = e11;
    }
}
/**
 * The `Message` class represents a single MIDI message. It has several properties that make it
 * easy to make sense of the binary data it contains.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Message {
    constructor(e11){
        this.rawData = e11, this.data = Array.from(this.rawData), this.statusByte = this.rawData[0], this.rawDataBytes = this.rawData.slice(1), this.dataBytes = this.data.slice(1), this.isChannelMessage = !1, this.isSystemMessage = !1, this.command = void 0, this.channel = void 0, this.manufacturerId = void 0, this.type = void 0, this.statusByte < 240 ? (this.isChannelMessage = !0, this.command = this.statusByte >> 4, this.channel = 1 + (15 & this.statusByte)) : (this.isSystemMessage = !0, this.command = this.statusByte), this.isChannelMessage ? this.type = Utilities.getPropertyByValue(Enumerations.CHANNEL_MESSAGES, this.command) : this.isSystemMessage && (this.type = Utilities.getPropertyByValue(Enumerations.SYSTEM_MESSAGES, this.command)), this.statusByte === Enumerations.SYSTEM_MESSAGES.sysex && (0 === this.dataBytes[0] ? (this.manufacturerId = this.dataBytes.slice(0, 3), this.dataBytes = this.dataBytes.slice(3, this.rawDataBytes.length - 1), this.rawDataBytes = this.rawDataBytes.slice(3, this.rawDataBytes.length - 1)) : (this.manufacturerId = [
            this.dataBytes[0]
        ], this.dataBytes = this.dataBytes.slice(1, this.dataBytes.length - 1), this.rawDataBytes = this.rawDataBytes.slice(1, this.rawDataBytes.length - 1)));
    }
}
/**
 * The `Input` class represents a single MIDI input port. This object is automatically instantiated
 * by the library according to the host's MIDI subsystem and does not need to be directly
 * instantiated. Instead, you can access all `Input` objects by referring to the
 * [`WebMidi.inputs`](WebMidi#inputs) array. You can also retrieve inputs by using methods such as
 * [`WebMidi.getInputByName()`](WebMidi#getInputByName) and
 * [`WebMidi.getInputById()`](WebMidi#getInputById).
 *
 * Note that a single MIDI device may expose several inputs and/or outputs.
 *
 * **Important**: the `Input` class does not directly fire channel-specific MIDI messages
 * (such as [`noteon`](InputChannel#event:noteon) or
 * [`controlchange`](InputChannel#event:controlchange), etc.). The [`InputChannel`](InputChannel)
 * object does that. However, you can still use the
 * [`Input.addListener()`](#addListener) method to listen to channel-specific events on multiple
 * [`InputChannel`](InputChannel) objects at once.
 *
 * @fires Input#opened
 * @fires Input#disconnected
 * @fires Input#closed
 * @fires Input#midimessage
 *
 * @fires Input#sysex
 * @fires Input#timecode
 * @fires Input#songposition
 * @fires Input#songselect
 * @fires Input#tunerequest
 * @fires Input#clock
 * @fires Input#start
 * @fires Input#continue
 * @fires Input#stop
 * @fires Input#activesensing
 * @fires Input#reset
 *
 * @fires Input#unknownmidimessage
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class Input extends EventEmitter {
    constructor(e11){
        super(), this._midiInput = e11, this._octaveOffset = 0, this.channels = [];
        for(let e11 = 1; e11 <= 16; e11++)this.channels[e11] = new InputChannel(this, e11);
        this._forwarders = [], this._midiInput.onstatechange = this._onStateChange.bind(this), this._midiInput.onmidimessage = this._onMidiMessage.bind(this);
    }
    async destroy() {
        this.removeListener(), this.channels.forEach((e11)=>e11.destroy()), this.channels = [], this._forwarders = [], this._midiInput && (this._midiInput.onstatechange = null, this._midiInput.onmidimessage = null), await this.close(), this._midiInput = null;
    }
    _onStateChange(e11) {
        let t11 = {
            timestamp: wm.time,
            target: this,
            port: this
        };
        "open" === e11.port.connection ? (t11.type = "opened", this.emit("opened", t11)) : "closed" === e11.port.connection && "connected" === e11.port.state ? (t11.type = "closed", this.emit("closed", t11)) : "closed" === e11.port.connection && "disconnected" === e11.port.state ? (t11.type = "disconnected", t11.port = {
            connection: e11.port.connection,
            id: e11.port.id,
            manufacturer: e11.port.manufacturer,
            name: e11.port.name,
            state: e11.port.state,
            type: e11.port.type
        }, this.emit("disconnected", t11)) : "pending" === e11.port.connection && "disconnected" === e11.port.state || console.warn("This statechange event was not caught: ", e11.port.connection, e11.port.state);
    }
    _onMidiMessage(e11) {
        const t11 = new Message(e11.data), n11 = {
            port: this,
            target: this,
            message: t11,
            timestamp: e11.timeStamp,
            type: "midimessage",
            data: t11.data,
            rawData: t11.data,
            statusByte: t11.data[0],
            dataBytes: t11.dataBytes
        };
        this.emit("midimessage", n11), t11.isSystemMessage ? this._parseEvent(n11) : t11.isChannelMessage && this.channels[t11.channel]._processMidiMessageEvent(n11), this._forwarders.forEach((e11)=>e11.forward(t11));
    }
    _parseEvent(e11) {
        const t11 = Object.assign({}, e11);
        t11.type = t11.message.type || "unknownmidimessage", "songselect" === t11.type && (t11.song = e11.data[1] + 1, t11.value = e11.data[1], t11.rawValue = t11.value), this.emit(t11.type, t11);
    }
    async open() {
        try {
            await this._midiInput.open();
        } catch (e11) {
            return Promise.reject(e11);
        }
        return Promise.resolve(this);
    }
    async close() {
        if (!this._midiInput) return Promise.resolve(this);
        try {
            await this._midiInput.close();
        } catch (e11) {
            return Promise.reject(e11);
        }
        return Promise.resolve(this);
    }
    getChannelModeByNumber() {
        wm.validation && console.warn("The 'getChannelModeByNumber()' method has been moved to the 'Utilities' class.");
    }
    addListener(e11, t11, n11 = {}) {
        if (wm.validation && "function" == typeof n11) {
            let e11 = null != t11 ? [].concat(t11) : void 0;
            t11 = n11, n11 = {
                channels: e11
            };
        }
        if (Enumerations.CHANNEL_EVENTS.includes(e11)) {
            void 0 === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
            let r11 = [];
            return Utilities.sanitizeChannels(n11.channels).forEach((i11)=>{
                r11.push(this.channels[i11].addListener(e11, t11, n11));
            }), r11;
        }
        return super.addListener(e11, t11, n11);
    }
    addOneTimeListener(e11, t11, n11 = {}) {
        return n11.remaining = 1, this.addListener(e11, t11, n11);
    }
    on(e11, t11, n11, r11) {
        return this.addListener(e11, t11, n11, r11);
    }
    hasListener(e11, t11, n11 = {}) {
        if (wm.validation && "function" == typeof n11) {
            let e11 = [].concat(t11);
            t11 = n11, n11 = {
                channels: e11
            };
        }
        return Enumerations.CHANNEL_EVENTS.includes(e11) ? (void 0 === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).every((n11)=>this.channels[n11].hasListener(e11, t11))) : super.hasListener(e11, t11);
    }
    removeListener(e11, t11, n11 = {}) {
        if (wm.validation && "function" == typeof n11) {
            let e11 = [].concat(t11);
            t11 = n11, n11 = {
                channels: e11
            };
        }
        if (void 0 === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), null == e11) return Utilities.sanitizeChannels(n11.channels).forEach((e11)=>{
            this.channels[e11] && this.channels[e11].removeListener();
        }), super.removeListener();
        Enumerations.CHANNEL_EVENTS.includes(e11) ? Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].removeListener(e11, t11, n11);
        }) : super.removeListener(e11, t11, n11);
    }
    addForwarder(e11, t11 = {}) {
        let n11;
        return n11 = e11 instanceof Forwarder ? e11 : new Forwarder(e11, t11), this._forwarders.push(n11), n11;
    }
    removeForwarder(e11) {
        this._forwarders = this._forwarders.filter((t11)=>t11 !== e11);
    }
    hasForwarder(e11) {
        return this._forwarders.includes(e11);
    }
    get name() {
        return this._midiInput.name;
    }
    get id() {
        return this._midiInput.id;
    }
    get connection() {
        return this._midiInput.connection;
    }
    get manufacturer() {
        return this._midiInput.manufacturer;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e11) {
        if (this.validation && (e11 = parseInt(e11), isNaN(e11))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e11;
    }
    get state() {
        return this._midiInput.state;
    }
    get type() {
        return this._midiInput.type;
    }
    get nrpnEventsEnabled() {
        return wm.validation && console.warn("The 'nrpnEventsEnabled' property has been moved to the 'InputChannel' class."), !1;
    }
}
if (Utilities.isNode) {
    try {
        window.navigator;
    } catch (err) {
        let jzz;
        eval('jzz = require("jzz")'), $parcel$global.navigator || ($parcel$global.navigator = {}), Object.assign($parcel$global.navigator, jzz);
    }
    try {
        performance;
    } catch (err) {
        let performance;
        eval('performance = require("perf_hooks").performance'), $parcel$global.performance = performance;
    }
}
/**
 * The `WebMidi` object makes it easier to work with the low-level Web MIDI API. Basically, it
 * simplifies sending outgoing MIDI messages and reacting to incoming MIDI messages.
 *
 * When using the WebMidi.js library, you should know that the `WebMidi` class has already been
 * instantiated. You cannot instantiate it yourself. If you use the **IIFE** version, you should
 * simply use the global object called `WebMidi`. If you use the **CJS** (CommonJS) or **ESM** (ES6
 * module) version, you get an already-instantiated object when you import the module.
 *
 * @fires WebMidi#connected
 * @fires WebMidi#disabled
 * @fires WebMidi#disconnected
 * @fires WebMidi#enabled
 * @fires WebMidi#error
 * @fires WebMidi#midiaccessgranted
 * @fires WebMidi#portschanged
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class WebMidi extends EventEmitter {
    constructor(){
        super(), this.defaults = {
            note: {
                attack: Utilities.from7bitToFloat(64),
                release: Utilities.from7bitToFloat(64),
                duration: 1 / 0
            }
        }, this.interface = null, this.validation = !0, this._inputs = [], this._disconnectedInputs = [], this._outputs = [], this._disconnectedOutputs = [], this._stateChangeQueue = [], this._octaveOffset = 0;
    }
    async enable(e11 = {}, t11 = !1) {
        if (this.validation = !1 !== e11.validation, this.validation && ("function" == typeof e11 && (e11 = {
            callback: e11,
            sysex: t11
        }), t11 && (e11.sysex = !0)), this.enabled) return "function" == typeof e11.callback && e11.callback(), Promise.resolve();
        const n11 = {
            timestamp: this.time,
            target: this,
            type: "error",
            error: void 0
        }, r11 = {
            timestamp: this.time,
            target: this,
            type: "midiaccessgranted"
        }, i11 = {
            timestamp: this.time,
            target: this,
            type: "enabled"
        };
        try {
            "function" == typeof e11.requestMIDIAccessFunction ? this.interface = await e11.requestMIDIAccessFunction({
                sysex: e11.sysex,
                software: e11.software
            }) : this.interface = await navigator.requestMIDIAccess({
                sysex: e11.sysex,
                software: e11.software
            });
        } catch (t11) {
            return n11.error = t11, this.emit("error", n11), "function" == typeof e11.callback && e11.callback(t11), Promise.reject(t11);
        }
        this.emit("midiaccessgranted", r11), this.interface.onstatechange = this._onInterfaceStateChange.bind(this);
        try {
            await this._updateInputsAndOutputs();
        } catch (t11) {
            return n11.error = t11, this.emit("error", n11), "function" == typeof e11.callback && e11.callback(t11), Promise.reject(t11);
        }
        return this.emit("enabled", i11), "function" == typeof e11.callback && e11.callback(), Promise.resolve(this);
    }
    async disable() {
        return this.interface && (this.interface.onstatechange = void 0), this._destroyInputsAndOutputs().then(()=>{
            navigator && "function" == typeof navigator.close && navigator.close(), this.interface = null;
            let e11 = {
                timestamp: this.time,
                target: this,
                type: "disabled"
            };
            this.emit("disabled", e11), this.removeListener();
        });
    }
    getInputById(e11, t11 = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e11) return;
        }
        if (t11.disconnected) {
            for(let t11 = 0; t11 < this._disconnectedInputs.length; t11++)if (this._disconnectedInputs[t11].id === e11.toString()) return this._disconnectedInputs[t11];
        } else for(let t11 = 0; t11 < this.inputs.length; t11++)if (this.inputs[t11].id === e11.toString()) return this.inputs[t11];
    }
    getInputByName(e11, t11 = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e11) return;
            e11 = e11.toString();
        }
        if (t11.disconnected) {
            for(let t11 = 0; t11 < this._disconnectedInputs.length; t11++)if (~this._disconnectedInputs[t11].name.indexOf(e11)) return this._disconnectedInputs[t11];
        } else for(let t11 = 0; t11 < this.inputs.length; t11++)if (~this.inputs[t11].name.indexOf(e11)) return this.inputs[t11];
    }
    getOutputByName(e11, t11 = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e11) return;
            e11 = e11.toString();
        }
        if (t11.disconnected) {
            for(let t11 = 0; t11 < this._disconnectedOutputs.length; t11++)if (~this._disconnectedOutputs[t11].name.indexOf(e11)) return this._disconnectedOutputs[t11];
        } else for(let t11 = 0; t11 < this.outputs.length; t11++)if (~this.outputs[t11].name.indexOf(e11)) return this.outputs[t11];
    }
    getOutputById(e11, t11 = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e11) return;
        }
        if (t11.disconnected) {
            for(let t11 = 0; t11 < this._disconnectedOutputs.length; t11++)if (this._disconnectedOutputs[t11].id === e11.toString()) return this._disconnectedOutputs[t11];
        } else for(let t11 = 0; t11 < this.outputs.length; t11++)if (this.outputs[t11].id === e11.toString()) return this.outputs[t11];
    }
    noteNameToNumber(e11) {
        return this.validation && console.warn("The noteNameToNumber() method is deprecated. Use Utilities.toNoteNumber() instead."), Utilities.toNoteNumber(e11, this.octaveOffset);
    }
    getOctave(e11) {
        return this.validation && (console.warn("The getOctave()is deprecated. Use Utilities.getNoteDetails() instead"), e11 = parseInt(e11)), !isNaN(e11) && e11 >= 0 && e11 <= 127 && Utilities.getNoteDetails(Utilities.offsetNumber(e11, this.octaveOffset)).octave;
    }
    sanitizeChannels(e11) {
        return this.validation && console.warn("The sanitizeChannels() method has been moved to the utilities class."), Utilities.sanitizeChannels(e11);
    }
    toMIDIChannels(e11) {
        return this.validation && console.warn("The toMIDIChannels() method has been deprecated. Use Utilities.sanitizeChannels() instead."), Utilities.sanitizeChannels(e11);
    }
    guessNoteNumber(e11) {
        return this.validation && console.warn("The guessNoteNumber() method has been deprecated. Use Utilities.guessNoteNumber() instead."), Utilities.guessNoteNumber(e11, this.octaveOffset);
    }
    getValidNoteArray(e11, t11 = {}) {
        return this.validation && console.warn("The getValidNoteArray() method has been moved to the Utilities.buildNoteArray()"), Utilities.buildNoteArray(e11, t11);
    }
    convertToTimestamp(e11) {
        return this.validation && console.warn("The convertToTimestamp() method has been moved to Utilities.toTimestamp()."), Utilities.toTimestamp(e11);
    }
    async _destroyInputsAndOutputs() {
        let e11 = [];
        return this.inputs.forEach((t11)=>e11.push(t11.destroy())), this.outputs.forEach((t11)=>e11.push(t11.destroy())), Promise.all(e11).then(()=>{
            this._inputs = [], this._outputs = [];
        });
    }
    _onInterfaceStateChange(e11) {
        this._updateInputsAndOutputs();
        let t11 = {
            timestamp: e11.timeStamp,
            type: e11.port.state,
            target: this
        };
        if ("connected" === e11.port.state && "open" === e11.port.connection) {
            "output" === e11.port.type ? t11.port = this.getOutputById(e11.port.id) : "input" === e11.port.type && (t11.port = this.getInputById(e11.port.id)), this.emit(e11.port.state, t11);
            const n11 = Object.assign({}, t11);
            n11.type = "portschanged", this.emit(n11.type, n11);
        } else if ("disconnected" === e11.port.state && "pending" === e11.port.connection) {
            "input" === e11.port.type ? t11.port = this.getInputById(e11.port.id, {
                disconnected: !0
            }) : "output" === e11.port.type && (t11.port = this.getOutputById(e11.port.id, {
                disconnected: !0
            })), this.emit(e11.port.state, t11);
            const n11 = Object.assign({}, t11);
            n11.type = "portschanged", this.emit(n11.type, n11);
        }
    }
    async _updateInputsAndOutputs() {
        return Promise.all([
            this._updateInputs(),
            this._updateOutputs()
        ]);
    }
    async _updateInputs() {
        if (!this.interface) return;
        for(let e11 = this._inputs.length - 1; e11 >= 0; e11--){
            const t11 = this._inputs[e11];
            Array.from(this.interface.inputs.values()).find((e11)=>e11 === t11._midiInput) || (this._disconnectedInputs.push(t11), this._inputs.splice(e11, 1));
        }
        let e11 = [];
        return this.interface.inputs.forEach((t11)=>{
            if (!this._inputs.find((e11)=>e11._midiInput === t11)) {
                let n11 = this._disconnectedInputs.find((e11)=>e11._midiInput === t11);
                n11 || (n11 = new Input(t11)), this._inputs.push(n11), e11.push(n11.open());
            }
        }), Promise.all(e11);
    }
    async _updateOutputs() {
        if (!this.interface) return;
        for(let e11 = this._outputs.length - 1; e11 >= 0; e11--){
            const t11 = this._outputs[e11];
            Array.from(this.interface.outputs.values()).find((e11)=>e11 === t11._midiOutput) || (this._disconnectedOutputs.push(t11), this._outputs.splice(e11, 1));
        }
        let e11 = [];
        return this.interface.outputs.forEach((t11)=>{
            if (!this._outputs.find((e11)=>e11._midiOutput === t11)) {
                let n11 = this._disconnectedOutputs.find((e11)=>e11._midiOutput === t11);
                n11 || (n11 = new Output(t11)), this._outputs.push(n11), e11.push(n11.open());
            }
        }), Promise.all(e11);
    }
    get enabled() {
        return null !== this.interface;
    }
    get inputs() {
        return this._inputs;
    }
    get isNode() {
        return this.validation && console.warn("WebMidi.isNode has been deprecated. Use Utilities.isNode instead."), Utilities.isNode;
    }
    get isBrowser() {
        return this.validation && console.warn("WebMidi.isBrowser has been deprecated. Use Utilities.isBrowser instead."), Utilities.isBrowser;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e11) {
        if (this.validation && (e11 = parseInt(e11), isNaN(e11))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e11;
    }
    get outputs() {
        return this._outputs;
    }
    get supported() {
        return "undefined" != typeof navigator && navigator.requestMIDIAccess;
    }
    get sysexEnabled() {
        return !(!this.interface || !this.interface.sysexEnabled);
    }
    get time() {
        return performance.now();
    }
    get version() {
        return "3.1.8";
    }
    get flavour() {
        return "cjs";
    }
    get CHANNEL_EVENTS() {
        return this.validation && console.warn("The CHANNEL_EVENTS enum has been moved to Enumerations.CHANNEL_EVENTS."), Enumerations.CHANNEL_EVENTS;
    }
    get MIDI_SYSTEM_MESSAGES() {
        return this.validation && console.warn("The MIDI_SYSTEM_MESSAGES enum has been moved to Enumerations.SYSTEM_MESSAGES."), Enumerations.SYSTEM_MESSAGES;
    }
    get MIDI_CHANNEL_MODE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MODE_MESSAGES enum has been moved to Enumerations.CHANNEL_MODE_MESSAGES."), Enumerations.CHANNEL_MODE_MESSAGES;
    }
    get MIDI_CONTROL_CHANGE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CONTROL_CHANGE_MESSAGES enum has been replaced by the Enumerations.CONTROL_CHANGE_MESSAGES array."), Enumerations.MIDI_CONTROL_CHANGE_MESSAGES;
    }
    get MIDI_REGISTERED_PARAMETER() {
        return this.validation && console.warn("The MIDI_REGISTERED_PARAMETER enum has been moved to Enumerations.REGISTERED_PARAMETERS."), Enumerations.REGISTERED_PARAMETERS;
    }
    get NOTES() {
        return this.validation && console.warn("The NOTES enum has been deprecated."), [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ];
    }
}
const wm = new WebMidi;
wm.constructor = null, exports.Enumerations = Enumerations, exports.Forwarder = Forwarder, exports.Input = Input, exports.InputChannel = InputChannel, exports.Message = Message, exports.Note = Note, exports.Output = Output, exports.OutputChannel = OutputChannel, exports.Utilities = Utilities, exports.WebMidi = wm;

});

var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$c = {}, $13c40c34b78c8ee2$var$s = [], $13c40c34b78c8ee2$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$h = Array.isArray;
function $13c40c34b78c8ee2$var$v(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $13c40c34b78c8ee2$var$d(l, f, i, o, null);
}
function $13c40c34b78c8ee2$var$d(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$13c40c34b78c8ee2$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(f), f;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$m(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$m(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$m(n) : null;
}
function $13c40c34b78c8ee2$var$k(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$k(n);
    }
}
function $13c40c34b78c8ee2$var$w(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$x.__r++ || $13c40c34b78c8ee2$var$o !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$r)($13c40c34b78c8ee2$var$x);
}
function $13c40c34b78c8ee2$var$x() {
    var n, u, t, o, r, e, c, s, a;
    for($13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f); n = $13c40c34b78c8ee2$var$i.shift();)n.__d && (u = $13c40c34b78c8ee2$var$i.length, o = void 0, e = (r = (t = n).__v).__e, s = [], a = [], (c = t.__P) && ((o = $13c40c34b78c8ee2$var$v({}, r)).__v = r.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(o), $13c40c34b78c8ee2$var$L(c, o, r, t.__n, void 0 !== c.ownerSVGElement, 32 & r.__u ? [
        e
    ] : null, s, null == e ? $13c40c34b78c8ee2$var$m(r) : e, !!(32 & r.__u), a), o.__.__k[o.__i] = o, $13c40c34b78c8ee2$var$M(s, o, a), o.__e != e && $13c40c34b78c8ee2$var$k(o)), $13c40c34b78c8ee2$var$i.length > u && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f));
    $13c40c34b78c8ee2$var$x.__r = 0;
}
function $13c40c34b78c8ee2$var$C(n, l, u, t, i, o, r, f, e, a, h) {
    var v, p, y, d, _, g = t && t.__k || $13c40c34b78c8ee2$var$s, b = l.length;
    for(u.__d = e, $13c40c34b78c8ee2$var$P(u, l, g), e = u.__d, v = 0; v < b; v++)null != (y = u.__k[v]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $13c40c34b78c8ee2$var$c : g[y.__i] || $13c40c34b78c8ee2$var$c, y.__i = v, $13c40c34b78c8ee2$var$L(n, y, p, i, o, r, f, e, a, h), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $13c40c34b78c8ee2$var$z(p.ref, null, y), h.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? e = $13c40c34b78c8ee2$var$S(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $13c40c34b78c8ee2$var$P(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $13c40c34b78c8ee2$var$d(null, i, null, null, i) : $13c40c34b78c8ee2$var$h(i) ? $13c40c34b78c8ee2$var$d($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $13c40c34b78c8ee2$var$d(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $13c40c34b78c8ee2$var$H(i, u, r = t + a, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : a = f < r && f == r - 1 ? f - r : 0, f !== t + a && (i.__u |= 65536))) : (o = u[t]) && null == o.key && o.__e && (o.__e == n.__d && (n.__d = $13c40c34b78c8ee2$var$m(o)), $13c40c34b78c8ee2$var$N(o, o, !1), u[t] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $13c40c34b78c8ee2$var$m(o)), $13c40c34b78c8ee2$var$N(o, o));
}
function $13c40c34b78c8ee2$var$S(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $13c40c34b78c8ee2$var$S(t[i], l, u));
        return l;
    }
    return n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e), l && l.nextSibling;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$h(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$H(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $13c40c34b78c8ee2$var$I(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$a.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$T(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$I(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $13c40c34b78c8ee2$var$I(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? $13c40c34b78c8ee2$var$D : $13c40c34b78c8ee2$var$A, o)) : n.removeEventListener(l, o ? $13c40c34b78c8ee2$var$D : $13c40c34b78c8ee2$var$A, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $13c40c34b78c8ee2$var$A(n) {
    var u = this.l[n.type + !1];
    if (n.t) {
        if (n.t <= u.u) return;
    } else n.t = Date.now();
    return u($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
}
function $13c40c34b78c8ee2$var$D(n) {
    return this.l[n.type + !0]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
}
function $13c40c34b78c8ee2$var$L(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, m, k, w, x, P, S, $, H, I, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (w = u.props, x = (a = A.contextType) && i[a.__c], P = a ? x ? x.props.value : a.__ : i, t.__c ? k = (p = u.__c = t.__c).__ = p.__E : ("prototype" in A && A.prototype.render ? u.__c = p = new A(w, P) : (u.__c = p = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(w, P), p.constructor = A, p.render = $13c40c34b78c8ee2$var$O), x && x.sub(p), p.props = w, p.state || (p.state = {}), p.context = P, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != A.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $13c40c34b78c8ee2$var$v({}, p.__s)), $13c40c34b78c8ee2$var$v(p.__s, A.getDerivedStateFromProps(w, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == A.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && w !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(w, P), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(w, p.__s, P) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = w, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), S = 0; S < p._sb.length; S++)p.__h.push(p._sb[S]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(w, p.__s, P), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, m);
            });
        }
        if (p.context = P, p.props = w, p.__P = n, p.__e = !1, $ = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, H = 0, "prototype" in A && A.prototype.render) {
            for(p.state = p.__s, p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), I = 0; I < p._sb.length; I++)p.__h.push(p._sb[I]);
            p._sb = [];
        } else do p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++H < 25);
        p.state = p.__s, null != p.getChildContext && (i = $13c40c34b78c8ee2$var$v($13c40c34b78c8ee2$var$v({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(d, _)), $13c40c34b78c8ee2$var$C(n, $13c40c34b78c8ee2$var$h(T = null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__u &= -161, p.__h.length && f.push(p), k && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $13c40c34b78c8ee2$var$j(t.__e, u, t, i, o, r, f, c, s);
    (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(u);
}
function $13c40c34b78c8ee2$var$M(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$z(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$j(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d, _, g, b, k = t.props, w = u.props, x = u.type;
    if ("svg" === x && (o = !0), null != r) {
        for(a = 0; a < r.length; a++)if ((_ = r[a]) && "setAttribute" in _ == !!x && (x ? _.localName === x : 3 === _.nodeType)) {
            l = _, r[a] = null;
            break;
        }
    }
    if (null == l) {
        if (null === x) return document.createTextNode(w);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, w.is && w), r = null, e = !1;
    }
    if (null === x) k === w || e && l.data === w || (l.data = w);
    else {
        if (r = r && $13c40c34b78c8ee2$var$n.call(l.childNodes), k = t.props || $13c40c34b78c8ee2$var$c, !e && null != r) for(k = {}, a = 0; a < l.attributes.length; a++)k[(_ = l.attributes[a]).name] = _.value;
        for(a in k)_ = k[a], "children" == a || ("dangerouslySetInnerHTML" == a ? y = _ : "key" === a || a in w || $13c40c34b78c8ee2$var$T(l, a, null, _, o));
        for(a in w)_ = w[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? b = _ : "key" === a || e && "function" != typeof _ || k[a] === _ || $13c40c34b78c8ee2$var$T(l, a, _, k[a], o);
        if (v) e || y && (v.__html === y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];
        else if (y && (l.innerHTML = ""), $13c40c34b78c8ee2$var$C(l, $13c40c34b78c8ee2$var$h(d) ? d : [
            d
        ], u, t, i, o && "foreignObject" !== x, r, f, r ? r[0] : t.__k && $13c40c34b78c8ee2$var$m(t, 0), e, s), null != r) for(a = r.length; a--;)null != r[a] && $13c40c34b78c8ee2$var$p(r[a]);
        e || (a = "value", void 0 !== g && (g !== l[a] || "progress" === x && !g || "option" === x && g !== k[a]) && $13c40c34b78c8ee2$var$T(l, a, g, k[a], !1), a = "checked", void 0 !== b && b !== l[a] && $13c40c34b78c8ee2$var$T(l, a, b, k[a], !1));
    }
    return l;
}
function $13c40c34b78c8ee2$var$z(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$N(n, u, t) {
    var i, o;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $13c40c34b78c8ee2$var$z(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $13c40c34b78c8ee2$var$N(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $13c40c34b78c8ee2$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $13c40c34b78c8ee2$var$O(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $13c40c34b78c8ee2$var$L(t, u = (!o && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), r || $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$c, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $13c40c34b78c8ee2$var$M(f, u, e);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $13c40c34b78c8ee2$var$v({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$d(l.type, e, i || l.key, o || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $13c40c34b78c8ee2$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $13c40c34b78c8ee2$var$w(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$s.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$v({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$v({}, u), this.props)), n && $13c40c34b78c8ee2$var$v(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$w(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$w(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$x.__r = 0, $13c40c34b78c8ee2$var$e = 0;



var $204a33a7557cbbd0$var$t, $204a33a7557cbbd0$var$r, $204a33a7557cbbd0$var$u, $204a33a7557cbbd0$var$i, $204a33a7557cbbd0$var$o = 0, $204a33a7557cbbd0$var$f = [], $204a33a7557cbbd0$var$c = [], $204a33a7557cbbd0$var$e = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__b, $204a33a7557cbbd0$var$a = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__r, $204a33a7557cbbd0$var$v = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).diffed, $204a33a7557cbbd0$var$l = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__c, $204a33a7557cbbd0$var$m = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).unmount;
function $204a33a7557cbbd0$var$d(t, u) {
    (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__h && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__h($204a33a7557cbbd0$var$r, t, $204a33a7557cbbd0$var$o || u), $204a33a7557cbbd0$var$o = 0;
    var i = $204a33a7557cbbd0$var$r.__H || ($204a33a7557cbbd0$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $204a33a7557cbbd0$var$c
    }), i.__[t];
}
function $204a33a7557cbbd0$export$60241385465d0a34(n) {
    return $204a33a7557cbbd0$var$o = 1, $204a33a7557cbbd0$export$13e3392192263954($204a33a7557cbbd0$var$B, n);
}
function $204a33a7557cbbd0$export$13e3392192263954(n, u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $204a33a7557cbbd0$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $204a33a7557cbbd0$var$r, !$204a33a7557cbbd0$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $204a33a7557cbbd0$var$r.u = !0;
        var c = $204a33a7557cbbd0$var$r.shouldComponentUpdate, e = $204a33a7557cbbd0$var$r.componentWillUpdate;
        $204a33a7557cbbd0$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $204a33a7557cbbd0$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $204a33a7557cbbd0$export$6d9c69b0de29b591(u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 3);
    !(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__s && $204a33a7557cbbd0$var$z(o.__H, i) && (o.__ = u, o.i = i, $204a33a7557cbbd0$var$r.__H.__h.push(o));
}
function $204a33a7557cbbd0$export$e5c5a5f917a5871c(u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 4);
    !(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__s && $204a33a7557cbbd0$var$z(o.__H, i) && (o.__ = u, o.i = i, $204a33a7557cbbd0$var$r.__h.push(o));
}
function $204a33a7557cbbd0$export$b8f5890fc79d6aca(n) {
    return $204a33a7557cbbd0$var$o = 5, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $204a33a7557cbbd0$export$d5a552a76deda3c2(n, t, r) {
    $204a33a7557cbbd0$var$o = 6, $204a33a7557cbbd0$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $204a33a7557cbbd0$export$1538c33de8887b59(n, r) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 7);
    return $204a33a7557cbbd0$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $204a33a7557cbbd0$export$35808ee640e87ca7(n, t) {
    return $204a33a7557cbbd0$var$o = 8, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $204a33a7557cbbd0$export$fae74005e78b1a27(n) {
    var u = $204a33a7557cbbd0$var$r.context[n.__c], i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($204a33a7557cbbd0$var$r)), u.props.value) : n.__;
}
function $204a33a7557cbbd0$export$dc8fbce3eb94dc1e(t, r) {
    (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).useDebugValue && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).useDebugValue(r ? r(t) : t);
}
function $204a33a7557cbbd0$export$c052f6604b7d51fe(n) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 10), i = $204a33a7557cbbd0$export$60241385465d0a34();
    return u.__ = n, $204a33a7557cbbd0$var$r.componentDidCatch || ($204a33a7557cbbd0$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $204a33a7557cbbd0$export$f680877a34711e37() {
    var n = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 11);
    if (!n.__) {
        for(var u = $204a33a7557cbbd0$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $204a33a7557cbbd0$var$b() {
    for(var t; t = $204a33a7557cbbd0$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($204a33a7557cbbd0$var$k), t.__H.__h.forEach($204a33a7557cbbd0$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e(r, t.__v);
    }
}
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__b = function(n) {
    $204a33a7557cbbd0$var$r = null, $204a33a7557cbbd0$var$e && $204a33a7557cbbd0$var$e(n);
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__r = function(n) {
    $204a33a7557cbbd0$var$a && $204a33a7557cbbd0$var$a(n), $204a33a7557cbbd0$var$t = 0;
    var i = ($204a33a7557cbbd0$var$r = n.__c).__H;
    i && ($204a33a7557cbbd0$var$u === $204a33a7557cbbd0$var$r ? (i.__h = [], $204a33a7557cbbd0$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $204a33a7557cbbd0$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($204a33a7557cbbd0$var$k), i.__h.forEach($204a33a7557cbbd0$var$w), i.__h = [], $204a33a7557cbbd0$var$t = 0)), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r;
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).diffed = function(t) {
    $204a33a7557cbbd0$var$v && $204a33a7557cbbd0$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $204a33a7557cbbd0$var$f.push(o) && $204a33a7557cbbd0$var$i === (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).requestAnimationFrame || (($204a33a7557cbbd0$var$i = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).requestAnimationFrame) || $204a33a7557cbbd0$var$j)($204a33a7557cbbd0$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $204a33a7557cbbd0$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $204a33a7557cbbd0$var$c;
    })), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r = null;
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($204a33a7557cbbd0$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $204a33a7557cbbd0$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e(u, t.__v);
        }
    }), $204a33a7557cbbd0$var$l && $204a33a7557cbbd0$var$l(t, r);
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).unmount = function(t) {
    $204a33a7557cbbd0$var$m && $204a33a7557cbbd0$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $204a33a7557cbbd0$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e(r, u.__v));
};
var $204a33a7557cbbd0$var$g = "function" == typeof requestAnimationFrame;
function $204a33a7557cbbd0$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $204a33a7557cbbd0$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $204a33a7557cbbd0$var$g && (t = requestAnimationFrame(r));
}
function $204a33a7557cbbd0$var$k(n) {
    var t = $204a33a7557cbbd0$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$w(n) {
    var t = $204a33a7557cbbd0$var$r;
    n.__c = n.__(), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $204a33a7557cbbd0$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}




const $2a6fa0b8412142c6$var$midiSettings = {
    defaultLength: 250,
    defaultRhythm: 120
};
class $2a6fa0b8412142c6$var$MidiRhythm extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    convertSignalToNotes(signalArray, signalToNotesMap) {
        const notesArray = signalArray.map((signal)=>{
            return signalToNotesMap.map((channel)=>{
                return channel.notes[signal - 1];
            });
        });
        return notesArray;
    }
    playArrayToMidi(WebMidi, notesArray, loop, timeSeries, onNotePlayed, generateGridData, mode, lengthOfSignal, midiOutput, channelsToNotes, rotateSolos, noteLength, beVerbose, setCurrentMessage) {
        const midiExists = WebMidi && midiOutput && midiOutput.label ? true : false;
        const myOutput = midiExists && midiOutput ? WebMidi.getOutputByName(midiOutput.label) : {};
        const myChannels = channelsToNotes.map((state)=>state.channel); // const myChannel = myOutput.channels[midiSettings.defaultChannel];
        let startingPoint = 0;
        const delays = new Array(notesArray.length).fill().map((_, i)=>{
            if (timeSeries && timeSeries[i]) startingPoint += timeSeries[i];
            else startingPoint += 60 / $2a6fa0b8412142c6$var$midiSettings.defaultRhythm * 1000;
            return startingPoint;
        });
        const possibleCombos = $2a6fa0b8412142c6$var$getAllCombinations(myChannels);
        const soloGrid = possibleCombos && possibleCombos.length > 1 ? generateGridData(mode, [
            0,
            possibleCombos.length - 1
        ], lengthOfSignal) : new Array(notesArray.length).fill(0);
        console.log("rotateSolos", rotateSolos);
        console.log("soloGrid", soloGrid);
        const timeOutIds = notesArray.map((note, index)=>{
            const timeoutId = setTimeout(()=>{
                const comboOfChannels = soloGrid[index];
                if (midiExists) myChannels.forEach((channel, _index)=>{
                    if (!rotateSolos || possibleCombos[comboOfChannels].includes(channel)) {
                        const ind = _index; // Math.random() > 0.5 ? 0 : index;
                        myOutput.playNote(note[ind], [
                            channel
                        ], {
                            duration: noteLength ? noteLength : $2a6fa0b8412142c6$var$midiSettings.defaultLength
                        });
                        if (beVerbose && setCurrentMessage) setCurrentMessage(`${note[ind]} @ ch ${channel} | ${timeSeries[index]}ms`);
                    }
                });
                onNotePlayed(index);
            // myChannel.playNote(note, {
            // 	duration: midiSettings.defaultLength,
            // });
            }, delays[index]); // index * midiSettings.defaultLength
            return timeoutId;
        });
        return timeOutIds;
    }
    play(WebMidi, signalArray, pause, loop, timeSeries, onNotePlayed, generateGridData, mode, lengthOfSignal, midiOutput, channelsToNotes, currentCycle, rotateSolos, noteLength, beVerbose, setCurrentMessage) {
        const shouldPause = pause ? false : true;
        let myOutput = false;
        if (midiOutput && midiOutput.value) myOutput = WebMidi.getOutputById(midiOutput.value);
        if (shouldPause) {
            if (myOutput) myOutput.sendAllSoundOff();
            // if (this.props.timeOutIds) {
            // 	this.props.timeOutIds.forEach((id) => {
            // 		clearTimeout(id);
            // 	});
            // }
            return false;
        }
        const notesArray = this.convertSignalToNotes(signalArray, channelsToNotes[currentCycle % 2]);
        const timeOutIds = this.playArrayToMidi(WebMidi, notesArray, loop, timeSeries, onNotePlayed, generateGridData, mode, lengthOfSignal, midiOutput, channelsToNotes[currentCycle % 2], rotateSolos, noteLength, beVerbose, setCurrentMessage);
        return timeOutIds;
    }
}
function $2a6fa0b8412142c6$var$getAllCombinations(arr) {
    // Function to generate combinations
    function generateCombinations(subset, remainingElements, results) {
        if (remainingElements.length === 0 && subset.length > 0) {
            // If no more elements to add and subset is not empty, add the current subset
            results.push(subset);
            return;
        }
        // Stop if there are no more elements to add
        if (remainingElements.length === 0) return;
        // Include the next element
        generateCombinations(subset.concat([
            remainingElements[0]
        ]), remainingElements.slice(1), results);
        // Exclude the next element
        generateCombinations(subset, remainingElements.slice(1), results);
    }
    const results = [];
    generateCombinations([], arr, results);
    return results;
}
var $2a6fa0b8412142c6$export$2e2bcd8739ae039 = $2a6fa0b8412142c6$var$MidiRhythm;


var $cbaadc3121311d77$exports = {};
var $77e1714696375bad$exports = {};
/* 
    Detrended Fluctuation Analysis (DFA)
    Javascript port
    available on https://github.com/deemeetree/dfa

    based on the approach described on https://noduslabs.com/featured/fractal-variability-feedback-system/
    based on the python script https://github.com/dokato/dfa


    ~ Concept 

    DFA is used to measure the behaviour of a time series. 
    
    An obtained alpha component (closely related to the Hurst exponent) will indicate 
    the presence of correlations in the time series. 

    It is based on the relationship between the length of an observation and cumulated variability.
    

    ~ Algorithm:

    1) represent a time series as a one-dimensional vector
    2) transform it into cumulative sum of variances from the mean
    3) generate the scales of different window sizes for the time series — each containing the number of observations
    4) split the cumulative variance vector into those chunks
    5) for each chunk: generate polinomial in the range in a window (to detrend it)
    6) calculate RMS of the fluctuations of the original from the fit
    7) get the average RMS value for each window in the scale
    8) take the average for each squared RMS for each scale
    9) if they align along in a straight line in loglog plot, there is power law relation
    i.e. as observations increase in length, the amplitude of average fluctuations increases as well 
    that is, there is an exponential growth of fluctuations when there's an exponential growth of scale (2^n)
    on the smaller scales the deviations are smaller. on the bigger scales they are much bigger.

    ~ Simple use

    let time_series = [8, 10, 6, 9, 7, 5, 5, 11, 11, 8, 6, 7, 9, 10, 7, 9]
    let dfa = new DFA(time_series)
    let alpha_component = dfa.compute()
    console.log(alpha_component)

    */ let $77e1714696375bad$var$DFA = function() {
    function log2(x) {
        return Math.log(x) / Math.log(2);
    }
    function range(size) {
        let result = [];
        for(let i = 0; i < size; i++)result.push(i);
        return result;
    }
    let DFA = function(x) {
        if (!(this instanceof DFA)) return new DFA(x);
        if (!(x instanceof Array || x instanceof Float32Array || x instanceof Float64Array)) throw new Error("x must be an array");
        this.x = x;
    };
    DFA.prototype.cumsumVariance = function(x, mean) {
        let cumulativeSumVariance = ((sum)=>(value)=>sum += value - mean)(0);
        return x.map(cumulativeSumVariance);
    };
    DFA.prototype.averageVariance = function(x, mean) {
        // Sum the absolute deviations
        let totalDeviation = 0;
        for(let i = 0; i < x.length; i++)totalDeviation += Math.abs(x[i] - mean);
        // Return the average deviation
        return totalDeviation / x.length;
    };
    DFA.prototype.deviationsFromMean = function(x, mean) {
        const deviationsVector = x.map((value)=>value - mean);
        return deviationsVector;
    };
    DFA.prototype.squareVector = function(x) {
        return x.map((value)=>Math.pow(value, 2));
    };
    DFA.prototype.SDNN = function(x) {
        const deviationsFromMean = this.deviationsFromMean(x, this.meanOfVector(x));
        const squaredVector = this.squareVector(deviationsFromMean);
        const meanSquaredVector = this.meanOfVectorNoBias(squaredVector);
        return Math.pow(meanSquaredVector, 0.5);
    };
    DFA.prototype.averageDifferences = function(x) {
        let sumOfDifferences = 0;
        // Loop through the intervals and calculate the sum of differences
        for(let i = 0; i < x.length - 1; i++)sumOfDifferences += Math.abs(x[i + 1] - x[i]);
        // Return the average difference
        return sumOfDifferences / (x.length - 1);
    };
    DFA.prototype.RMSSD = function(x) {
        let sumOfSquaredDifferences = 0;
        // Loop through the intervals and calculate the sum of squared differences
        for(let i = 0; i < x.length - 1; i++){
            const difference = Math.abs(x[i + 1] - x[i]);
            sumOfSquaredDifferences += difference * difference;
        }
        // Calculate RMSSD
        const rmssd = Math.sqrt(sumOfSquaredDifferences / (x.length - 1));
        return rmssd;
    };
    DFA.prototype.naturalLog = function(value) {
        return Math.log(value);
    };
    DFA.prototype.PNN50 = function(rrIntervals) {
        let differences = [];
        let countDifferencesOver50ms = 0;
        // Calculate differences between successive RR intervals
        for(let i = 1; i < rrIntervals.length; i++){
            differences.push(Math.abs(rrIntervals[i] - rrIntervals[i - 1])); // absolute difference
            if (differences[i - 1] > 50) countDifferencesOver50ms++;
        }
        // Calculate pNN50
        let pNN50 = countDifferencesOver50ms / (rrIntervals.length - 1) * 100;
        return pNN50;
    };
    DFA.prototype.generateRange = function(array, startAt = 0, step = 1) {
        let size = array.length;
        return range(size).map((i)=>i * step + startAt);
    };
    DFA.prototype.generateZeroArray = function(size) {
        return range(size).map((i)=>0);
    };
    DFA.prototype.generateScaleRange = function(array, startAt = 4, step = 0.5) {
        // the size of the scale should be not longer than the array
        let startPow = Math.sqrt(startAt);
        let size = Math.floor((log2(array.length) - startPow) / step + 1);
        return range(size).map((i)=>Math.floor(Math.pow(2, i * step + startPow))); // Math.round could be used, but .floor makes it possible to have more windows
    };
    DFA.prototype.splitArrayIntoChunks = function(arr, size, strict = false) {
        let chunkedArray = [];
        for(let i = 0; i < arr.length; i += size)chunkedArray.push(arr.slice(i, i + size));
        if (strict) {
            if (chunkedArray[chunkedArray.length - 1].length < size) chunkedArray.pop();
        }
        return chunkedArray;
    };
    DFA.prototype.meanOfVector = function(x) {
        // Declare y within the function scope
        let y = x || this.x; // If x is not provided, use this.x
        // Define the mean function
        let mean = (arr)=>arr.reduce((p, c)=>p + c, 0) / arr.length;
        // Return the computed mean
        return mean(y);
    };
    DFA.prototype.meanOfVectorNoBias = function(x) {
        // Properly declare y within the function scope
        let y = x || this.x;
        // Define the mean function
        let mean = (arr)=>arr.reduce((p, c)=>p + c, 0) / (arr.length - 1);
        // Return the computed mean (or adjusted value)
        return mean(y);
    };
    DFA.prototype.log2Vector = function(x) {
        if (!(x instanceof Array)) throw new Error("log2Vector input must be an array");
        let y = [];
        for(let i in x)y[i] = log2(x[i]);
        return y;
    };
    DFA.prototype.RMS = function(cut, fit) {
        if (cut.length != fit.length) throw new Error("for calculating the RMS of the two vectors they should be equal");
        // let's build the variance vector for the 2 vectors
        let variance_vector = [];
        for(let i = 0; i < cut.length; i++)variance_vector[i] = Math.pow(cut[i] - fit[i], 2);
        // let's calculate the average for that vector and take a square root of it
        return Math.sqrt(this.meanOfVector(variance_vector));
    };
    DFA.prototype.alphaScore = function(alpha, level = "moderate") {
        let thresholds = [
            0.55,
            0.95,
            1.05
        ];
        if (level == "relaxed") thresholds = [
            0.65,
            0.9,
            1.1
        ];
        else if (level == "strict") thresholds = [
            0.5,
            0.98,
            1.02
        ];
        if (alpha <= thresholds[0]) return "recovering";
        else if (alpha > thresholds[0] && alpha < thresholds[1]) return "regular";
        else if (alpha >= thresholds[1] && alpha <= thresholds[2]) return "resilient";
        else if (alpha > thresholds[2]) return "tension";
    };
    DFA.prototype.compute = function(min_window = 4, step = 0.5, level = "moderate") {
        /* 
					Transform the series into the cumulative sum of variances (deviations from the mean).
					We need this to only look at the fluctuations and not the absolute values.
					*/ let cumsum = this.cumsumVariance(this.x, this.meanOfVector(this.x));
        let averageVariance = this.averageVariance(this.x, this.meanOfVector(this.x));
        let meanValue = this.meanOfVector(this.x);
        let SDNN = this.SDNN(this.x);
        let RMSSD = this.RMSSD(this.x);
        let lnRMSSD = this.naturalLog(RMSSD);
        let PNN50 = this.PNN50(this.x);
        let averageDifferences = this.averageDifferences(this.x);
        let lengthOfData = this.x.length;
        /* 
					Create observation windows of length, e.g scales = [4,5,8,11,16]
					Scale of the window size from min_window to max series length.
					Each increment is made at the rate of 2^step.
					This is done to have exponential increase of the scale windows.
					*/ let scales = this.generateScaleRange(cumsum, min_window, step);
        /* 
					Split the cumulative sum into the window chunks of scales.
					E.g. for a series of 16 values, the first window of size 4 will split it into 4 windows of 4 values in each.
					*/ let split_scales = {};
        let fluctuations = [];
        for(let s in scales){
            // split cumsum into the window sizes of scales[s]
            let window_size = scales[s];
            split_scales[window_size] = this.splitArrayIntoChunks(cumsum, window_size, true);
            let num_windows = split_scales[window_size].length;
            /* 
						For each window let's build a polynomial in order to detrend it.
						Then we will calculate RMS (root mean square) for each window (standard deviation)
						*/ let rms = this.generateZeroArray(num_windows);
            for(let chunk in split_scales[window_size]){
                // a chunk window of the scale w
                let xcut = split_scales[window_size][chunk];
                // values vector
                let vector = this.generateRange(xcut, 0, 1);
                // calculate polynomial fit of the cumsum in the split scale
                // e.g. make a straight line that fits values found in that window row
                let poly = new Polyfit(vector, xcut);
                // use polyfit coefficients to build a straight line xfit along the split_scales[w] data
                // using the coefficiens that can be retried via poly.computeCoefficients(1)
                // this is how we detrend the data
                let coeff = poly.getPolynomial(1); // 1 is the degree
                let xfit = [];
                for(let c in vector)xfit[c] = coeff(c);
                // let's now calculate the root mean square off the differences
                // between the values in this window chunk (xcut) and the fit (xfit)
                rms[chunk] = Math.pow(this.RMS(xcut, xfit), 2);
                poly = null;
            }
            // let's get the average of the variance for each window in this scale
            // and calculate its deviation
            fluctuations[s] = Math.sqrt(this.meanOfVector(rms));
        }
        /* 
					Calculate best-fit for the Scales to Fluctuations (RMS)
					We now have the vector with scales that shows the number of values in each window.
					We also have the fluctuations vector, which shows the square root of the mean RMS.
					We plot them against each other on the log base 2 scales and find the coefficient of the best-fit.
					*/ let scales_log = this.log2Vector(scales);
        let flucts_log = this.log2Vector(fluctuations);
        let alpha_poly = new Polyfit(scales_log, flucts_log);
        let coefficients = alpha_poly.computeCoefficients(1);
        let alpha = coefficients[1];
        let arraySize = scales.length;
        let alphaScore = this.alphaScore(alpha, level);
        let result = {
            averageVariance: averageVariance,
            meanValue: meanValue,
            lengthOfData: lengthOfData,
            SDNN: SDNN,
            RMSSD: RMSSD,
            lnRMSSD: lnRMSSD,
            PNN50: PNN50,
            averageDifferences: averageDifferences,
            scales: scales,
            segments: arraySize,
            fluctuations: fluctuations,
            scales_log: scales_log,
            fluctuations_log: flucts_log,
            coefficients: coefficients,
            alpha: alpha,
            alphaScore: alphaScore
        };
        return result;
    };
    /* 
				POLINOMIAL CALCULATION
				taken from https://github.com/rfink/polyfit.js
    
				~ Concept:
    
				What is a function that best describes a relationship? 
				n is the degree, so if n = 1, what is the straight line that describes the relationship
			
				~ Use: 
    
				let poly = new Polyfit([0,1,2,3],[0,0,-2,-3]) 
				poly.computeCoefficients(1) // 1 is the degree
				// result: [0.4, -1.1] - python DFA algorithm yields reverse order
				let func = poly.getPolynomial(1)
				func(0)
				func(1)
				etc. for the fit
			
				*/ class Polyfit {
        constructor(x, y){
            // Validate input arrays
            if (!Array.isArray(x) || !Array.isArray(y)) throw new Error("x and y must be arrays");
            if (x.length !== y.length) throw new Error("x and y must have the same length");
            this.x = x;
            this.y = y;
            this.FloatXArray = x instanceof Float32Array ? Float32Array : x instanceof Float64Array ? Float64Array : null;
        }
        static gaussJordanDivide(matrix, row, col, numCols) {
            const divisor = matrix[row][col];
            for(var i = col + 1; i < numCols; i++)matrix[row][i] /= divisor;
            matrix[row][col] = 1;
        }
        static gaussJordanEliminate(matrix, row, col, numRows, numCols) {
            for(var i = 0; i < numRows; i++)if (i !== row) {
                var factor = matrix[i][col];
                for(var j = col + 1; j < numCols; j++)matrix[i][j] -= factor * matrix[row][j];
                matrix[i][col] = 0;
            }
        }
        static gaussJordanEchelonize(matrix) {
            const rows = matrix.length;
            const cols = matrix[0].length;
            for(var col = 0, row = 0; col < cols && row < rows; col++){
                var maxRow = row;
                for(var i = row + 1; i < rows; i++)if (Math.abs(matrix[i][col]) > Math.abs(matrix[maxRow][col])) maxRow = i;
                if (matrix[maxRow][col] === 0) continue;
                // Swap rows
                var temp = matrix[row];
                matrix[row] = matrix[maxRow];
                matrix[maxRow] = temp;
                Polyfit.gaussJordanDivide(matrix, row, col, cols);
                Polyfit.gaussJordanEliminate(matrix, row, col, rows, cols);
                row++;
            }
        }
        computeCoefficients(p) {
            const n = this.x.length;
            var m = [];
            for(var i = 0; i < p + 1; i++){
                var row = [];
                for(var j = 0; j < p + 2; j++)row.push(0);
                m.push(row);
            }
            var mpc = [];
            for(var idx = 0; idx < 2 * (p + 1) - 1; idx++){
                var sum = 0;
                for(var i = 0; i < n; i++)sum += Math.pow(this.x[i], idx);
                mpc.push(sum);
            }
            for(var r = 0; r < p + 1; r++)for(var c = 0; c < p + 1; c++)m[r][c] = mpc[r + c];
            for(var i = 0; i < n; i++){
                var temp = 1;
                for(var j = 0; j < p + 1; j++){
                    m[j][p + 1] += temp * this.y[i];
                    temp *= this.x[i];
                }
            }
            Polyfit.gaussJordanEchelonize(m);
            var result = [];
            for(var i = 0; i < m.length; i++)result.push(m[i][p + 1]);
            return result;
        }
        getPolynomial(degree) {
            if (isNaN(degree) || degree < 0) throw new Error("Degree must be a positive integer");
            var terms = this.computeCoefficients(degree);
            return function(x) {
                var result = 0;
                for(var idx = 0; idx < terms.length; idx++)result += terms[idx] * Math.pow(x, idx);
                return result;
            };
        }
        toExpression(degree) {
            if (isNaN(degree) || degree < 0) throw new Error("Degree must be a positive integer");
            var terms = this.computeCoefficients(degree);
            var expressions = [];
            for(var idx = 0; idx < terms.length; idx++)expressions.push(terms[idx].toPrecision() + "x^" + idx);
            return expressions.join(" + ");
        }
    }
    return DFA;
}();
$77e1714696375bad$exports = $77e1714696375bad$var$DFA;


var $d6541f691ffb0af6$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
$d6541f691ffb0af6$exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("d4xg3"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("3LwY7"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("DwJuQ"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("b7kl8"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("4wWcs"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("fiCvv"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("aGSwO"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};


var $cbaadc3121311d77$require$Readable = $d6541f691ffb0af6$exports.Readable;
const $cbaadc3121311d77$var$generateSignal = function({ signalLength: signalLength = 128, minWindow: minWindow = 4, scaleGrow: scaleGrow = 0.5, signalRange: signalRange = [
    0,
    30000
], signalType: signalType = "Fractal", streaming: streaming = false }) {
    const numPoints = signalLength;
    const numWhiteNoise = 16;
    const numTrials = 100;
    const generatedRange = [
        signalRange[0],
        signalRange[1]
    ];
    const generateIntegers = true;
    let bestDifference = Infinity;
    let bestSequence;
    let dfa;
    let alphaComponent;
    let alphaValue;
    let idealAlpha = 1;
    switch(signalType){
        case "Aleatory":
        case "Random":
        case "Perlin":
        case "Structured":
        case "Sequential":
        case "WhiteNoise":
        case "White_Noise":
        case "White Noise":
        case "Stochastic":
        case "Uniform":
            idealAlpha = 0.5;
            break;
        case "Stable":
        case "Regular":
        case "Mosaic":
        case "Stationary":
            idealAlpha = 0.75;
            break;
        case "Unstable":
        case "Gradient":
        case "Shifting":
        case "BrownNoise":
        case "Brown Noise":
        case "Brown_Noise":
        case "NonStationary":
        case "NonStationary":
        case "Non_Stationary":
        case "Non Stationary":
            idealAlpha = 1.5;
            break;
        case "PinkNoise":
        case "Pink_Noise":
        case "Pink Noise":
        case "Adaptive":
        case "Fractal":
        case "Transitional":
        default:
            idealAlpha = 1;
            break;
    }
    for(let i = 0; i < numTrials; i++){
        let sequence = [];
        switch(signalType){
            case "Sequential":
            case "Structured":
                sequence = generateOrderedSequence(numPoints);
                break;
            case "Random":
            case "Aleatory":
            case "WhiteNoise":
            case "White_Noise":
            case "White Noise":
                sequence = generateWhiteNoise(numPoints);
                break;
            case "Stable":
            case "Regular":
            case "Mosaic":
            case "Stationary":
                sequence = generatePinkNoiseByVoss(numPoints, 4);
                break;
            case "Perlin":
                sequence = generatePerlinNoise(numPoints);
                break;
            case "Unstable":
            case "Gradient":
            case "Shifting":
            case "BrownNoise":
            case "Brown Noise":
            case "Brown_Noise":
            case "NonStationary":
            case "Non_Stationary":
            case "Non Stationary":
                sequence = generateBrownianNoise(numPoints);
                break;
            case "Fractal":
            case "PinkNoise":
            case "Pink_Noise":
            case "Pink Noise":
            case "Adaptive":
            case "Transitional":
            default:
                sequence = generatePinkNoiseByVoss(numPoints, numWhiteNoise);
                break;
        }
        dfa = new $77e1714696375bad$exports(sequence);
        alphaComponent = dfa.compute(minWindow, scaleGrow);
        alphaValue = alphaComponent.alpha;
        const difference = Math.abs(alphaValue - idealAlpha);
        if (difference < bestDifference) {
            bestDifference = difference;
            bestSequence = sequence;
        }
    }
    const returnObject = {
        alpha: alphaValue,
        signalLength: signalLength,
        minWindow: minWindow,
        scaleGrow: scaleGrow,
        signalRange: signalRange,
        desiredSignalType: signalType
    };
    if (streaming) {
        let previousTimer = 0;
        const stream = new $cbaadc3121311d77$require$Readable({
            read () {
                for(let i = 0; i < bestSequence.length; i++){
                    setTimeout(()=>{
                        this.push(bestSequence[i].toString());
                    }, previousTimer + bestSequence[i]);
                    previousTimer += bestSequence[i];
                }
                setTimeout(()=>{
                    this.push(null);
                }, previousTimer);
            }
        });
        return {
            stream: stream,
            ...returnObject
        };
    }
    returnObject.timeSeries = bestSequence;
    return {
        timeSeries: bestSequence,
        alpha: alphaValue,
        signalLength: signalLength,
        minWindow: minWindow,
        scaleGrow: scaleGrow,
        signalRange: signalRange,
        desiredSignalType: signalType
    };
    function generateWhiteNoise(length) {
        return new Array(length).fill(0).map(()=>{
            let randomVal = Math.random() * (generatedRange[1] - generatedRange[0]) + generatedRange[0];
            return generateIntegers ? Math.round(randomVal) : randomVal;
        });
    }
    function generateOrderedSequence(length) {
        let data = [];
        for(let i = 0; i < length; i++){
            const oneValue = Math.floor((i % 4 + 1) * generatedRange[1] / 4);
            const anotherValue = Math.floor((i % 2 + 1) * generatedRange[1] / 4);
            data.push(Math.random() > 0.5 ? oneValue : anotherValue);
        }
        return data;
    }
    function generateBrownianNoise(length) {
        let brownianNoise = new Array(length);
        const valueRange = generatedRange[1] - generatedRange[0];
        brownianNoise[0] = Math.random() * valueRange + generatedRange[0];
        if (generateIntegers) brownianNoise[0] = Math.round(brownianNoise[0]);
        for(let i = 1; i < length; i++){
            let delta = Math.random();
            let operation = Math.random() > 0.5 ? "+" : "-";
            let multiplier = 1;
            let longTrend = 0;
            let shortTrend = 0;
            if (i >= 8) {
                for(let s = 1; s <= 3; s++)shortTrend += brownianNoise[i - s] - brownianNoise[i - s - 1];
                for(let l = 1; l <= 15; l++)longTrend += brownianNoise[i - l] - brownianNoise[i - l - 1];
                if (shortTrend > 0) {
                    operation = "+";
                    multiplier = 0.5;
                }
                if (shortTrend < 0) {
                    operation = "-";
                    multiplier = 0.5;
                }
                if (longTrend > 0) operation = "-";
                if (longTrend < 0) operation = "+";
            }
            let newValue = operation === "+" ? brownianNoise[i - 1] + delta * multiplier : brownianNoise[i - 1] - delta * multiplier;
            if (shortTrend == 0) newValue = brownianNoise[i - 1];
            if (longTrend == 0) newValue = Math.random() > 0.5 ? brownianNoise[i - 1] + delta * (valueRange / 4 // ? brownianNoise[i - 1] + delta * (shortTrend + 1)
            ) : brownianNoise[i - 1] - delta * (valueRange / 4);
            if (newValue > generatedRange[1]) brownianNoise[i] = brownianNoise[i - 1];
            else if (newValue < generatedRange[0]) brownianNoise[i] = brownianNoise[i - 1];
            else brownianNoise[i] = newValue;
            if (generateIntegers) brownianNoise[i] = Math.round(brownianNoise[i]);
        }
        return brownianNoise;
    }
    function generatePerlinNoise(numPoints) {
        let perlin = {
            rand_vect: function() {
                let theta = Math.random() * 2 * Math.PI;
                return {
                    x: Math.cos(theta),
                    y: Math.sin(theta)
                };
            },
            dot_prod_grid: function(x, y, vx, vy) {
                let g_vect;
                let d_vect = {
                    x: x - vx,
                    y: y - vy
                };
                if (this.gradients[[
                    vx,
                    vy
                ]]) g_vect = this.gradients[[
                    vx,
                    vy
                ]];
                else {
                    g_vect = this.rand_vect();
                    this.gradients[[
                        vx,
                        vy
                    ]] = g_vect;
                }
                return d_vect.x * g_vect.x + d_vect.y * g_vect.y;
            },
            orientation: function(x, y) {
                let angleRadians = Math.atan2(y, x); // Angle in radians
                let angleDegrees = angleRadians * (180 / Math.PI); // Convert to degrees
                return angleDegrees;
            },
            smootherstep: function(x) {
                return 6 * x ** 5 - 15 * x ** 4 + 10 * x ** 3;
            },
            interp: function(x, a, b) {
                return a + this.smootherstep(x) * (b - a);
            },
            seed: function() {
                this.gradients = {};
                this.memory = {};
            },
            get: function(x, y) {
                if (this.memory.hasOwnProperty([
                    x,
                    y
                ])) return this.memory[[
                    x,
                    y
                ]];
                let xf = Math.floor(x);
                let yf = Math.floor(y);
                //interpolate
                let tl = this.dot_prod_grid(x, y, xf, yf);
                let tr = this.dot_prod_grid(x, y, xf + 1, yf);
                let bl = this.dot_prod_grid(x, y, xf, yf + 1);
                let br = this.dot_prod_grid(x, y, xf + 1, yf + 1);
                let xt = this.interp(x - xf, tl, tr);
                let xb = this.interp(x - xf, bl, br);
                let v = this.interp(y - yf, xt, xb);
                this.memory[[
                    x,
                    y
                ]] = v;
                return v;
            }
        };
        perlin.seed();
        let perlinNoise = new Array(numPoints).fill(0).map(()=>{
            return perlin.get(Math.random(), Math.random());
        });
        // Normalize pink noise to fall within the specified range
        const maxVal = Math.max(...perlinNoise);
        const minVal = Math.min(...perlinNoise);
        let finalNoise = [];
        for(let i = 0; i < numPoints; i++){
            finalNoise[i] = (perlinNoise[i] - minVal) / (maxVal - minVal) * (generatedRange[1] - generatedRange[0]) + generatedRange[0];
            if (generateIntegers) finalNoise[i] = Math.round(finalNoise[i]);
        }
        return finalNoise;
    }
    function generatePinkNoiseByVoss(numPoints, numWhiteNoise) {
        let whiteNoises = [];
        for(let i = 0; i < numWhiteNoise; i++)whiteNoises.push(generateWhiteNoise(numPoints));
        let pinkNoise = new Array(numPoints).fill(0);
        for(let i = 0; i < numPoints; i++)for(let j = 0; j < numWhiteNoise; j++)pinkNoise[i] += j === 0 ? whiteNoises[j][i] : whiteNoises[j][Math.floor(i / Math.pow(2, j))];
        // Normalize pink noise to fall within the specified range
        const maxVal = Math.max(...pinkNoise);
        const minVal = Math.min(...pinkNoise);
        for(let i = 0; i < numPoints; i++){
            pinkNoise[i] = (pinkNoise[i] - minVal) / (maxVal - minVal) * (generatedRange[1] - generatedRange[0]) + generatedRange[0];
            if (generateIntegers) pinkNoise[i] = Math.round(pinkNoise[i]);
        }
        return pinkNoise;
    }
};
const $cbaadc3121311d77$var$GenerateSignal = {
    create: (settings)=>{
        return {
            settings: settings
        };
    },
    generateSignal: $cbaadc3121311d77$var$generateSignal
};
$cbaadc3121311d77$exports = $cbaadc3121311d77$var$GenerateSignal;


const $4d894c0568f6ab6a$var$signalGenerator = $cbaadc3121311d77$exports;
const $4d894c0568f6ab6a$var$DEFAULT_SQUARE_DIMENSION = 16; // 64, 32, 16, 8, 4, 2, 1
const $4d894c0568f6ab6a$var$DEFAULT_GRID_LENGTH = Math.pow($4d894c0568f6ab6a$var$DEFAULT_SQUARE_DIMENSION, 2); // 4096, 1024, 256, 64, 16, 4, 1
const $4d894c0568f6ab6a$var$ROTATION_STAGES = [
    "Random",
    // Aleatory, Cyclical, Stochastic (Sequential, Perlin, random, Random)
    "Stable",
    // Mosaic, Rhythmical
    "Fractal",
    // Pattern
    "Unstable" // Shifting, Gradient
];
const $4d894c0568f6ab6a$var$rotationConfig = {
    signalLength: 128,
    minWindow: 4,
    scaleGrow: 0.5,
    signalRange: [
        1,
        4
    ],
    signalType: "Random"
};
const $4d894c0568f6ab6a$var$generatedDataRandom = $4d894c0568f6ab6a$var$signalGenerator.generateSignal($4d894c0568f6ab6a$var$rotationConfig);
$4d894c0568f6ab6a$var$rotationConfig.signalType = "Stable";
const $4d894c0568f6ab6a$var$generatedDataStable = $4d894c0568f6ab6a$var$signalGenerator.generateSignal($4d894c0568f6ab6a$var$rotationConfig);
$4d894c0568f6ab6a$var$rotationConfig.signalType = "Fractal";
const $4d894c0568f6ab6a$var$generatedDataFractal = $4d894c0568f6ab6a$var$signalGenerator.generateSignal($4d894c0568f6ab6a$var$rotationConfig);
$4d894c0568f6ab6a$var$rotationConfig.signalType = "Unstable";
const $4d894c0568f6ab6a$var$generatedDataUnstable = $4d894c0568f6ab6a$var$signalGenerator.generateSignal($4d894c0568f6ab6a$var$rotationConfig);
$4d894c0568f6ab6a$var$rotationConfig.signalType = "Perlin";
const $4d894c0568f6ab6a$var$generatedDataPerlin = $4d894c0568f6ab6a$var$signalGenerator.generateSignal($4d894c0568f6ab6a$var$rotationConfig);
function $4d894c0568f6ab6a$var$translateNumbersToStates(timeSeries) {
    return timeSeries.map((value)=>{
        switch(value){
            case 1:
                return "Random";
            case 2:
                return "Stable";
            case 3:
                return "Fractal";
            case 4:
                return "Unstable";
        }
    });
}
const $4d894c0568f6ab6a$var$FRACTAL_ROTATION_STAGES = {
    Sequential: $4d894c0568f6ab6a$var$ROTATION_STAGES,
    Random: $4d894c0568f6ab6a$var$translateNumbersToStates($4d894c0568f6ab6a$var$generatedDataRandom.timeSeries),
    random: $4d894c0568f6ab6a$var$translateNumbersToStates($4d894c0568f6ab6a$var$generatedDataRandom.timeSeries),
    Perlin: $4d894c0568f6ab6a$var$translateNumbersToStates($4d894c0568f6ab6a$var$generatedDataPerlin.timeSeries),
    Stable: $4d894c0568f6ab6a$var$translateNumbersToStates($4d894c0568f6ab6a$var$generatedDataStable.timeSeries),
    Fractal: $4d894c0568f6ab6a$var$translateNumbersToStates($4d894c0568f6ab6a$var$generatedDataFractal.timeSeries),
    Unstable: $4d894c0568f6ab6a$var$translateNumbersToStates($4d894c0568f6ab6a$var$generatedDataUnstable.timeSeries)
};
class $4d894c0568f6ab6a$var$Grid extends (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        this.updateCurrentMessage = this.updateCurrentMessage.bind(this);
        this.state = {
            currentPosition: this.props.currentPosition
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        // Update only if certain props or states have changed
        const modeChanged = this.props.mode !== nextProps.mode;
        const pauseChanged = this.props.pause !== nextProps.pause;
        const positionChanged = this.state.currentPosition !== nextState.currentPosition;
        if (pauseChanged) this.setState((prevState)=>({
                currentPosition: 0
            }));
        return modeChanged || positionChanged;
    }
    generateGridData(mode, range, lengthOfSignal) {
        let data = [];
        const signalType = mode == "random" ? "Random" : mode;
        const beVerbose = this && this.props && this.props.verbose ? this.props.verbose : false;
        const signalConfig = {
            signalLength: lengthOfSignal < 64 ? 64 : lengthOfSignal,
            minWindow: 4,
            scaleGrow: 0.5,
            signalRange: range,
            signalType: signalType
        };
        const gridLength = lengthOfSignal;
        switch(mode){
            case "random":
                for(let i = 0; i < gridLength; i++)data.push(Math.floor(Math.random() * range[1]) + 1);
                break;
            case "Sequential":
                for(let i = 0; i < gridLength; i++){
                    const oneValue = Math.floor((i % 4 + 1) * range[1] / 4);
                    const anotherValue = Math.floor((i % 2 + 1) * range[1] / 4);
                    data.push(Math.random() > 0.5 ? oneValue : anotherValue);
                }
                break;
            default:
                const generatedData = $4d894c0568f6ab6a$var$signalGenerator.generateSignal(signalConfig);
                if (beVerbose) // console.log(`${mode} alpha: ${generatedData.alpha.toFixed(2)}`);
                this.setState((prevState)=>({
                        currentMessage: `${mode} alpha: ${generatedData.alpha.toFixed(2)}`
                    }));
                data = generatedData.timeSeries ? generatedData.timeSeries.slice(0, gridLength) : [];
                break;
        }
        return data;
    }
    updatePropsReorganizedData(data) {
        const reorganizedData = this.reorganizeArray(data);
        this.props.reorganizedData = reorganizedData;
        if (this.props.updateReorganizedData) this.props.updateReorganizedData(reorganizedData);
    }
    renderGrid(mode) {
        const { loopOn: loopOn, currentPosition: currentPosition } = this.state;
        const currentCycle = parseInt(this.props.currentCycle);
        const firstRender = currentPosition === 0 && !loopOn;
        const shouldLoop = this.props.reorganizedData && currentPosition == this.props.reorganizedData.length - 1;
        const lengthOfSignal = this.props.rows ? parseInt(Math.pow(this.props.rows, 2)) : $4d894c0568f6ab6a$var$DEFAULT_GRID_LENGTH;
        const rotateEvery = this.props.rotate ? parseInt(this.props.rotate) : 0;
        const shouldReplaceOnRotation = this.props.replace ? true : false;
        const currentView = this.props.currentView;
        if (firstRender) {
            const data = this.generateGridData(mode, [
                1,
                4
            ], lengthOfSignal);
            this.updatePropsReorganizedData(data);
            if (currentView != "all") this.playMidi(data, mode, lengthOfSignal, this.props.channelsToNotes, currentCycle);
        }
        if (shouldLoop && !firstRender) {
            this.setState((prevState)=>({
                    loopOn: true
                }));
            if (rotateEvery && currentCycle != 0 && currentCycle % rotateEvery == 0) {
                let newMode = mode;
                if (shouldReplaceOnRotation) {
                    const oldMode = this.props.tempMode ? this.props.tempMode : mode;
                    console.log("fractalReplace", this.props.fractalReplace);
                    if (this.props.fractalReplace) newMode = $4d894c0568f6ab6a$var$findNextAfterCycle($4d894c0568f6ab6a$var$FRACTAL_ROTATION_STAGES[this.props.fractalReplace], currentCycle);
                    else newMode = $4d894c0568f6ab6a$var$findNextAfterString($4d894c0568f6ab6a$var$ROTATION_STAGES, oldMode);
                    console.log("switching to mode", newMode);
                    if (this.props.updateTempMode) this.props.updateTempMode(newMode);
                }
                const newData = this.generateGridData(newMode, [
                    1,
                    4
                ], lengthOfSignal);
                this.updatePropsReorganizedData(newData);
                this.playMidi(newData, newMode, lengthOfSignal, this.props.channelsToNotes, currentCycle);
            } else {
                const dataToLoop = this.reorganizeArray(this.props.reorganizedData);
                const firstSound = dataToLoop.shift();
                dataToLoop.push(firstSound);
                // const secondSound = dataToLoop.shift();
                // dataToLoop.push(secondSound);
                this.playMidi(dataToLoop, mode, lengthOfSignal, this.props.channelsToNotes, currentCycle);
            }
        }
        let dataToShow = this.props.reorganizedData;
        if (!firstRender) {
            if (currentPosition > 0) {
                dataToShow = this.reorganizeArray(this.props.reorganizedData);
                const firstElement = dataToShow.shift();
                dataToShow.push(firstElement);
                dataToShow = this.reorganizeArray(dataToShow);
                this.props.updateCurrentPosition(currentPosition);
                this.props.updateReorganizedData(dataToShow);
            }
        }
        if (currentPosition == lengthOfSignal - 1) {
            if (this.props.updateCurrentCycle) this.props.updateCurrentCycle(currentCycle + 1);
        }
        const returnedData = dataToShow.map((value, index)=>{
            // if (index == 0 && this.props.pause) console.log("square value", value);
            const isActive = index == 0 && this.props.pause;
            return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                class: this.getColor(value, isActive)
            });
        });
        return returnedData;
    }
    async playMidi(data, mode, lengthOfSignal, channelsToNotes, currentCycle) {
        let timeOutIds = null;
        // if (this.props.timeOutIds && !this.props.pause) {
        // 	this.props.timeOutIds.forEach((id) => {
        // 		clearTimeout(id);
        // 	});
        // }
        if (this.props.pause) {
            const midiPlayer = this.props.midiPlayer;
            const onNotePlayed = (index)=>{
                this.setState((prevState)=>({
                        currentPosition: index
                    }));
            };
            const msRange = [
                this.props.beatDistance - this.props.beatDistance / 2,
                this.props.beatDistance + this.props.beatDistance / 2
            ];
            const noteLength = Math.floor((this.props.beatDistance - this.props.beatDistance / 2) / 2);
            const rythmData = this.props.formToRhythm ? this.generateGridData(mode, msRange, lengthOfSignal) // 50, 450 //  50, 950 // 200, 1300
             : null;
            timeOutIds = await midiPlayer.play(this.props.WebMidi, data, this.props.pause, "loop", rythmData, onNotePlayed, this.generateGridData, mode, lengthOfSignal, this.props.midiOutput, channelsToNotes, currentCycle, this.props.rotateSolos, noteLength, this.props.verbose, this.updateCurrentMessage);
        }
        if (this.props.updateTimeOutIds) this.props.updateTimeOutIds(timeOutIds);
    }
    getColor(value, isActive) {
        const setActive = isActive ? " border-4 border-solid border-white-300" : "";
        switch(value){
            case 1:
                return "w-full h-full bg-clinical-950 aspect-square" + setActive;
            case 2:
                return "w-full h-full bg-clinical-600 aspect-square" + setActive;
            // 33% gradation
            case 3:
                return "w-full h-full bg-clinical-300 aspect-square" + setActive;
            // 66% gradation
            case 4:
                return "w-full h-full bg-clinical-50 aspect-square" + setActive;
            // bg-emerald
            default:
                return "w-full h-full transparent aspect-square";
        }
    }
    updateCurrentMessage(message) {
        this.setState((prevState)=>({
                currentMessage: message
            }));
    }
    reorganizeArray(arr) {
        const n = arr.length;
        const chunkSize = Math.sqrt(n);
        if (!Number.isInteger(chunkSize)) throw new Error("Array size must be a perfect square");
        let result = [];
        for(let i = 0; i < n; i += chunkSize){
            let chunk = arr.slice(i, i + chunkSize);
            if (i / chunkSize % 2 !== 0) chunk = chunk.reverse();
            result = result.concat(chunk);
        }
        return result;
    }
    render() {
        const currentMode = this.props.mode;
        const midiPlayer = new (0, $2a6fa0b8412142c6$export$2e2bcd8739ae039)();
        this.props.midiPlayer = midiPlayer;
        const beVerbose = this.props.verbose ? true : false;
        const gridRows = this.props.rows && this.props.rows % 2 == 0 ? parseInt(this.props.rows) : $4d894c0568f6ab6a$var$DEFAULT_SQUARE_DIMENSION;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            key: this.props.key,
            onTouchStart: this.props.onTouchStart,
            onClick: this.props.onClick,
            class: "container w-4/5 lg:w-2/5 flex-1 p-0 items-center mt-48 lg:mt-0 justify-center",
            style: "aspect-ratio: 1 / 1;"
        }, beVerbose && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
            class: "font-sans text-lg mb-4 text-gray-600"
        }, this.state.currentMessage ? this.state.currentMessage : "\xa0"), gridRows == 1 && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "grid grid-cols-1",
            style: "aspect-ratio: 1 / 1;"
        }, this.renderGrid(currentMode)), gridRows == 2 && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "grid grid-cols-2",
            style: "aspect-ratio: 1 / 1;"
        }, this.renderGrid(currentMode)), gridRows == 4 && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "grid grid-cols-4",
            style: "aspect-ratio: 1 / 1;"
        }, this.renderGrid(currentMode)), gridRows == 8 && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "grid grid-cols-8",
            style: "aspect-ratio: 1 / 1;"
        }, this.renderGrid(currentMode)), gridRows == 16 && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "grid grid-cols-16",
            style: "aspect-ratio: 1 / 1;"
        }, this.renderGrid(currentMode)), gridRows == 32 && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "grid grid-cols-32",
            style: "aspect-ratio: 1 / 1;"
        }, this.renderGrid(currentMode)), gridRows == 64 && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            class: "grid grid-cols-64",
            style: "aspect-ratio: 1 / 1;"
        }, this.renderGrid(currentMode)));
    }
}
function $4d894c0568f6ab6a$var$findNextAfterString(arr, searchString) {
    // Check if the array is not empty
    if (arr.length === 0) return null; // Or some other value indicating the array is empty
    // Iterate through the array to find the string
    for(let i = 0; i < arr.length - 1; i++){
        // Check if the current element is the search string
        if (arr[i] === searchString) // Return the next element in the array
        return arr[i + 1];
    }
    // If the string wasn't found or is the last element, return the first element
    return arr[0];
}
function $4d894c0568f6ab6a$var$findNextAfterCycle(array, cycle) {
    const index = (cycle + 1) % array.length;
    return array[index];
}
var $4d894c0568f6ab6a$export$2e2bcd8739ae039 = $4d894c0568f6ab6a$var$Grid;




var $4oKKP = parcelRequire("4oKKP");


const $a2938b69b36cc0ac$var$Helper = ({})=>{
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "flex bg-black"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
        type: "checkbox",
        id: "swiper-toggle",
        class: "relative sr-only peer",
        "data-drawer-toggle": "helper-swipe"
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("label", {
        for: "swiper-toggle",
        class: "absolute bottom-0 right-0 inline-block w-16 h-16 p-4 transition-all duration-500 bg-black peer-checked:rotate-90 peer-checked:right-96"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "w-1 h-5 mb-1 bg-neutral-500 rounded-lg"
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "w-6 h-1 bg-neutral-500 rounded-lg"
    })), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        id: "helper-swipe",
        class: "fixed bottom-0 right-0 z-20 w-96 h-full overflow-auto text-xs bg-black transition-all duration-500 transform -translate-y-full shadow-lg peer-checked:translate-y-0"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "px-6 py-4 bg-black text-xs font-mono"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h2", {
        class: "text-lg text-gray-400 font-semibold"
    }, "Fractal Rhythm Machine"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        class: "text-gray-500 text-sm py-4"
    }, "Fractal Rhythm is a visual, sonic, and data sequencer. It produces 4 types of variability, which is then sent to the user via MIDI (to activate other devices, change CV, or play MIDI notes), as a visualization (to be projected), and as a data stream. You can then use this to introduce fractal dynamics into your projects."), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-4 text-base text-gray-400 font-semibold "
    }, "Quick Start"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        class: "text-gray-500 text-sm py-4"
    }, "0. Open the link on your desktop computer", (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), "1. Click on the pattern deck on the left or on the right", (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), '2. Press "Space" to begin playing the pattern', (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), '3. Press "Space" again to stop playing the pattern and refresh it', (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), "4. Click on the pattern to zoom out and choose another pattern deck", (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), '5. Once the pattern is open, press "Space" to start playing the new pattern', (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), "6. Stop playing. Switch. Reiterate."), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-4 text-base text-gray-400 font-semibold "
    }, "MIDI Setup"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        class: "text-gray-500 text-sm py-4"
    }, "0. Turn your MIDI device on before opening the page. Reload the app if necessary to register the device. ", (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), "1. Internal Mac OS Midi On, then open GarageBand and open a musical instrument to start playing. ", (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), "2. Connect an external MIDI device (e.g. TE OPZ-1), modify notes in the Settings, and start playing."), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-4 text-base text-gray-400 font-semibold "
    }, "Settings Suggestions"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        class: "text-gray-500 text-sm py-4"
    }, "If you have a problem, see whether your MIDI device is displayed in the Settings. We recommend to start with a default pattern and then use the self-rotating rhytmical / pattern settings so you get more variability. If you like a setting you can save it as a preset."), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-4 text-base text-gray-400 font-semibold "
    }, "Author & Contact"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        class: "text-gray-500 text-sm py-4"
    }, "Dmitry Paranyushkin | Nodus Labs", (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
        href: "https://noduslabs.com"
    }, "noduslabs.com"), " |", " ", (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
        href: "support.noduslabs.com"
    }, "support.noduslabs.com"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), "info@noduslabs.com |", " ", (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", {
        href: "https://twitter.com/noduslabs"
    }, "@noduslabs")), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        class: "pt-8 text-xs text-gray-400"
    }, "\xa0"))));
};
var $a2938b69b36cc0ac$export$2e2bcd8739ae039 = $a2938b69b36cc0ac$var$Helper;






function $e21355414fd2bd2a$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $e21355414fd2bd2a$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $e21355414fd2bd2a$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $e21355414fd2bd2a$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $e21355414fd2bd2a$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($e21355414fd2bd2a$export$221d75b3f55bb0bd.prototype = new (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8)).isPureReactComponent = !0, $e21355414fd2bd2a$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $e21355414fd2bd2a$var$C(this.props, n) || $e21355414fd2bd2a$var$C(this.state, t);
};
var $e21355414fd2bd2a$var$x = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__b;
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $e21355414fd2bd2a$var$x && $e21355414fd2bd2a$var$x(n);
};
var $e21355414fd2bd2a$var$R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $e21355414fd2bd2a$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $e21355414fd2bd2a$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $e21355414fd2bd2a$var$R, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $e21355414fd2bd2a$var$k = function(n, t) {
    return null == n ? null : (0, $13c40c34b78c8ee2$export$47e4c5b300681277)((0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n).map(t));
}, $e21355414fd2bd2a$export$dca3b0875bd9a954 = {
    map: $e21355414fd2bd2a$var$k,
    forEach: $e21355414fd2bd2a$var$k,
    count: function(n) {
        return n ? (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $13c40c34b78c8ee2$export$47e4c5b300681277)
}, $e21355414fd2bd2a$var$O = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e;
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $e21355414fd2bd2a$var$O(n, t, e, r);
};
var $e21355414fd2bd2a$var$T = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).unmount;
function $e21355414fd2bd2a$var$F(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $e21355414fd2bd2a$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $e21355414fd2bd2a$var$F(n, t, e);
    })), n;
}
function $e21355414fd2bd2a$var$I(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $e21355414fd2bd2a$var$I(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $e21355414fd2bd2a$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $e21355414fd2bd2a$var$U(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $e21355414fd2bd2a$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $e21355414fd2bd2a$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $e21355414fd2bd2a$var$T && $e21355414fd2bd2a$var$T(n);
}, ($e21355414fd2bd2a$export$74bf444e3cd11ea5.prototype = new (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $e21355414fd2bd2a$var$U(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $e21355414fd2bd2a$var$I(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $e21355414fd2bd2a$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $e21355414fd2bd2a$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $e21355414fd2bd2a$var$F(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $e21355414fd2bd2a$var$V = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $e21355414fd2bd2a$var$W(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $e21355414fd2bd2a$var$P(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($e21355414fd2bd2a$var$W, {
        context: e.context
    }, n.__v), e.l);
}
function $e21355414fd2bd2a$export$d39a5bbd09211389(n, e) {
    var r = (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($e21355414fd2bd2a$var$P, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($e21355414fd2bd2a$export$998bcd577473dd93.prototype = new (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8)).__a = function(n) {
    var t = this, e = $e21355414fd2bd2a$var$U(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $e21355414fd2bd2a$var$V(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $e21355414fd2bd2a$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $e21355414fd2bd2a$export$998bcd577473dd93.prototype.componentDidUpdate = $e21355414fd2bd2a$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $e21355414fd2bd2a$var$V(n, e, t);
    });
};
var $e21355414fd2bd2a$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $e21355414fd2bd2a$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $e21355414fd2bd2a$var$H = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $e21355414fd2bd2a$var$Z = /[A-Z0-9]/g, $e21355414fd2bd2a$var$Y = "undefined" != typeof document, $e21355414fd2bd2a$var$$ = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $e21355414fd2bd2a$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $e21355414fd2bd2a$export$fa8d919ba61d84db(n, t, e) {
    return (0, $13c40c34b78c8ee2$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $13c40c34b78c8ee2$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $13c40c34b78c8ee2$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $e21355414fd2bd2a$var$J = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).event;
function $e21355414fd2bd2a$var$K() {}
function $e21355414fd2bd2a$var$Q() {
    return this.cancelBubble;
}
function $e21355414fd2bd2a$var$X() {
    return this.defaultPrevented;
}
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).event = function(n) {
    return $e21355414fd2bd2a$var$J && (n = $e21355414fd2bd2a$var$J(n)), n.persist = $e21355414fd2bd2a$var$K, n.isPropagationStopped = $e21355414fd2bd2a$var$Q, n.isDefaultPrevented = $e21355414fd2bd2a$var$X, n.nativeEvent = n;
};
var $e21355414fd2bd2a$var$nn, $e21355414fd2bd2a$var$tn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $e21355414fd2bd2a$var$en = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).vnode;
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {};
        for(var o in t){
            var i = t[o];
            if (!("value" === o && "defaultValue" in t && null == i || $e21355414fd2bd2a$var$Y && "children" === o && "noscript" === e || "class" === o || "className" === o)) {
                var l = o.toLowerCase();
                "defaultValue" === o && "value" in t && null == t.value ? o = "value" : "download" === o && !0 === i ? i = "" : "ondoubleclick" === l ? o = "ondblclick" : "onchange" !== l || "input" !== e && "textarea" !== e || $e21355414fd2bd2a$var$$(t.type) ? "onfocus" === l ? o = "onfocusin" : "onblur" === l ? o = "onfocusout" : $e21355414fd2bd2a$var$H.test(o) ? o = l : -1 === e.indexOf("-") && $e21355414fd2bd2a$var$B.test(o) ? o = o.replace($e21355414fd2bd2a$var$Z, "-$&").toLowerCase() : null === i && (i = void 0) : l = o = "oninput", "oninput" === l && u[o = l] && (o = "oninputCapture"), u[o] = i;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $e21355414fd2bd2a$var$tn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $e21355414fd2bd2a$var$z, $e21355414fd2bd2a$var$en && $e21355414fd2bd2a$var$en(n);
};
var $e21355414fd2bd2a$var$rn = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__r;
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__r = function(n) {
    $e21355414fd2bd2a$var$rn && $e21355414fd2bd2a$var$rn(n), $e21355414fd2bd2a$var$nn = n.__c;
};
var $e21355414fd2bd2a$var$un = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).diffed;
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).diffed = function(n) {
    $e21355414fd2bd2a$var$un && $e21355414fd2bd2a$var$un(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $e21355414fd2bd2a$var$nn = null;
};
var $e21355414fd2bd2a$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $e21355414fd2bd2a$var$nn.__n[n.__c].props.value;
            }
        }
    }
}, $e21355414fd2bd2a$export$83d89fbfd8236492 = "17.0.2";
function $e21355414fd2bd2a$export$d38cd72104c1f0e9(n) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d).bind(null, n);
}
function $e21355414fd2bd2a$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $e21355414fd2bd2a$var$z;
}
function $e21355414fd2bd2a$export$9522e17588c12572(n) {
    return $e21355414fd2bd2a$export$a8257692ac88316c(n) && n.type === (0, $13c40c34b78c8ee2$export$ffb0004e005737fa);
}
function $e21355414fd2bd2a$export$e530037191fcd5d7(n) {
    return $e21355414fd2bd2a$export$a8257692ac88316c(n) ? (0, $13c40c34b78c8ee2$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $e21355414fd2bd2a$export$502457920280e6be(n) {
    return !!n.__k && ((0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(null, n), !0);
}
function $e21355414fd2bd2a$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $e21355414fd2bd2a$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $e21355414fd2bd2a$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $e21355414fd2bd2a$export$5f8d39834fd61797 = (0, $13c40c34b78c8ee2$export$ffb0004e005737fa);
function $e21355414fd2bd2a$export$7568632d0d33d16d(n) {
    n();
}
function $e21355414fd2bd2a$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $e21355414fd2bd2a$export$7b286972b8d8ccbf() {
    return [
        !1,
        $e21355414fd2bd2a$export$7568632d0d33d16d
    ];
}
var $e21355414fd2bd2a$export$aaabe4eda9ed9969 = (0, $204a33a7557cbbd0$export$e5c5a5f917a5871c), $e21355414fd2bd2a$export$45a5e7f76e0caa8d = $e21355414fd2bd2a$export$a8257692ac88316c;
function $e21355414fd2bd2a$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $204a33a7557cbbd0$export$60241385465d0a34)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $204a33a7557cbbd0$export$e5c5a5f917a5871c)(function() {
        u.__ = e, u.v = t, $e21355414fd2bd2a$var$En(u) && o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(function() {
        return $e21355414fd2bd2a$var$En(u) && o({
            h: u
        }), n(function() {
            $e21355414fd2bd2a$var$En(u) && o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
function $e21355414fd2bd2a$var$En(n) {
    var t, e, r = n.v, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
var $e21355414fd2bd2a$export$2e2bcd8739ae039 = {
    useState: (0, $204a33a7557cbbd0$export$60241385465d0a34),
    useId: (0, $204a33a7557cbbd0$export$f680877a34711e37),
    useReducer: (0, $204a33a7557cbbd0$export$13e3392192263954),
    useEffect: (0, $204a33a7557cbbd0$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $204a33a7557cbbd0$export$e5c5a5f917a5871c),
    useInsertionEffect: $e21355414fd2bd2a$export$aaabe4eda9ed9969,
    useTransition: $e21355414fd2bd2a$export$7b286972b8d8ccbf,
    useDeferredValue: $e21355414fd2bd2a$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $e21355414fd2bd2a$export$306c0aa65ff9ec16,
    startTransition: $e21355414fd2bd2a$export$7568632d0d33d16d,
    useRef: (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $204a33a7557cbbd0$export$d5a552a76deda3c2),
    useMemo: (0, $204a33a7557cbbd0$export$1538c33de8887b59),
    useCallback: (0, $204a33a7557cbbd0$export$35808ee640e87ca7),
    useContext: (0, $204a33a7557cbbd0$export$fae74005e78b1a27),
    useDebugValue: (0, $204a33a7557cbbd0$export$dc8fbce3eb94dc1e),
    version: "17.0.2",
    Children: $e21355414fd2bd2a$export$dca3b0875bd9a954,
    render: $e21355414fd2bd2a$export$b3890eb0ae9dca99,
    hydrate: $e21355414fd2bd2a$export$fa8d919ba61d84db,
    unmountComponentAtNode: $e21355414fd2bd2a$export$502457920280e6be,
    createPortal: $e21355414fd2bd2a$export$d39a5bbd09211389,
    createElement: (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d),
    createContext: (0, $13c40c34b78c8ee2$export$fd42f52fd3ae1109),
    createFactory: $e21355414fd2bd2a$export$d38cd72104c1f0e9,
    cloneElement: $e21355414fd2bd2a$export$e530037191fcd5d7,
    createRef: (0, $13c40c34b78c8ee2$export$7d1e3a5e95ceca43),
    Fragment: (0, $13c40c34b78c8ee2$export$ffb0004e005737fa),
    isValidElement: $e21355414fd2bd2a$export$a8257692ac88316c,
    isElement: $e21355414fd2bd2a$export$45a5e7f76e0caa8d,
    isFragment: $e21355414fd2bd2a$export$9522e17588c12572,
    findDOMNode: $e21355414fd2bd2a$export$466bfc07425424d5,
    Component: (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8),
    PureComponent: $e21355414fd2bd2a$export$221d75b3f55bb0bd,
    memo: $e21355414fd2bd2a$export$7c73462e0d25e514,
    forwardRef: $e21355414fd2bd2a$export$257a8862b851cb5b,
    flushSync: $e21355414fd2bd2a$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $e21355414fd2bd2a$export$c78a37762a8d58e1,
    StrictMode: $e21355414fd2bd2a$export$5f8d39834fd61797,
    Suspense: $e21355414fd2bd2a$export$74bf444e3cd11ea5,
    SuspenseList: $e21355414fd2bd2a$export$998bcd577473dd93,
    lazy: $e21355414fd2bd2a$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $e21355414fd2bd2a$export$ae55be85d98224ed
};



const $e95cdfe4627ff789$var$Select = ({ selectedValue: selectedValue, onSelectedValueChange: onSelectedValueChange, label: label, options: options, disabled: disabled })=>{
    // Function to update state based on selection
    const handleChange = (event)=>{
        // Call the function passed from the parent component
        onSelectedValueChange(event.target.value);
    };
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "pt-4 flex text-xs"
    }, label && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("label", {
        for: "simple-select",
        class: "block mt-2 mr-2 text-xs w-16 font-medium text-gray-500"
    }, label), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("select", {
        id: "simple-select",
        value: selectedValue,
        onChange: handleChange,
        disabled: disabled,
        class: "bg-gray-950 pl-2 text-xs border border-gray-300 text-gray-500 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
    }, options.map((option)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("option", {
            value: option.value,
            key: option.value
        }, option.label))));
};
var $e95cdfe4627ff789$export$2e2bcd8739ae039 = $e95cdfe4627ff789$var$Select;




const $f231f83936b50e82$var$TextInput = ({ defaultValue: defaultValue, onValueChange: onValueChange, label: label, presetName: presetName, readOnly: readOnly })=>{
    const [value, setValue] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(defaultValue);
    const handleChange = (event)=>{
        const newValue = event.target.value;
        const intValue = newValue;
        setValue(intValue);
        if (intValue && intValue.length > 0) onValueChange(intValue);
    };
    const handleFocus = ()=>{};
    const handleBlur = ()=>{};
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "flex pt-4 items-center"
    }, label && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("label", {
        htmlFor: "text-input",
        class: "block mt-2 mr-2 text-xs w-16 font-medium text-gray-500"
    }, label), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
        type: "text",
        id: "text-input",
        value: value,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        readOnly: readOnly,
        class: "bg-gray-950 pl-2 border border-gray-300 text-gray-500 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
    }));
};
var $f231f83936b50e82$export$2e2bcd8739ae039 = $f231f83936b50e82$var$TextInput;




const $74b4d7c9fef7c353$var$UrlInput = ({ defaultValue: defaultValue, label: label })=>{
    const [value, setValue] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(defaultValue);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        setValue(decodeURIComponent(defaultValue));
    }, [
        defaultValue
    ]);
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "flex pt-4 items-center"
    }, label && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("label", {
        htmlFor: "text-input",
        class: "block mt-2 mr-2 text-xs w-16 font-medium text-gray-500"
    }, label), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
        type: "text",
        id: "text-input",
        value: value,
        readOnly: true,
        class: "bg-gray-950 pl-2 border border-gray-300 text-gray-500 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
    }));
};
var $74b4d7c9fef7c353$export$2e2bcd8739ae039 = $74b4d7c9fef7c353$var$UrlInput;




const $05b4ff1f58864b74$var$channelRange = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16
];
const $05b4ff1f58864b74$var$TextInputChannel = ({ defaultValue: defaultValue, onValueChange: onValueChange, channel: channel, note: note })=>{
    const [value, setValue] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(defaultValue);
    const channelId = `ch${channel}-${note}`;
    const handleChange = (event)=>{
        const newValue = event.target.value;
        const intValue = parseInt(newValue, 10);
        if (!isNaN(intValue)) setValue(intValue);
    };
    const handleFocus = ()=>{};
    const handleBlur = ()=>{
        if ($05b4ff1f58864b74$var$channelRange.includes(value) == false) {
            alert("Channel can be a number between 0 and 16");
            return;
        }
        if (!isNaN(value)) onValueChange(value);
    };
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
        type: "text",
        id: channelId,
        value: value,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        class: "bg-gray-950 pl-2 border border-gray-300 text-gray-500 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 w-8 mr-4 p-2.5"
    });
};
var $05b4ff1f58864b74$export$2e2bcd8739ae039 = $05b4ff1f58864b74$var$TextInputChannel;




const $e2ce247375ca17de$var$TextInputNote = ({ defaultValue: defaultValue, onValueChange: onValueChange, channel: channel, note: note })=>{
    const [value, setValue] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(defaultValue);
    const channelId = `ch${channel}-${note}`;
    const handleChange = (event)=>{
        const newValue = event.target.value;
        setValue(newValue);
    };
    const handleFocus = ()=>{};
    const handleBlur = ()=>{
        if ($e2ce247375ca17de$var$isMusicalNote(value) == false) {
            alert("You did not provide a correct musical note. Please, try again.");
            return;
        }
        if (value) onValueChange(value);
    };
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
        type: "text",
        id: channelId,
        value: value,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        class: "bg-gray-950 pl-2 border border-gray-300 text-gray-500 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 w-10 mr-4 p-2.5"
    });
};
function $e2ce247375ca17de$var$isMusicalNote(note) {
    const regex = /^[A-Ga-g](#|b)?[0-8]?$/;
    return regex.test(note);
}
var $e2ce247375ca17de$export$2e2bcd8739ae039 = $e2ce247375ca17de$var$TextInputNote;




const $c0e1dce05d2b58db$var$TextInputBpm = ({ defaultValue: defaultValue, onValueChange: onValueChange, pause: pause, updatePause: updatePause, label: label, options: options, readOnly: readOnly })=>{
    const [value, setValue] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(defaultValue);
    const handleChange = (event)=>{
        const newValue = event.target.value;
        const intValue = parseInt(newValue, 10);
        if (!isNaN(intValue)) setValue(intValue);
    };
    const handleFocus = ()=>{
    // updatePause();
    };
    const handleBlur = ()=>{
        if (isNaN(value) || !value) {
            alert("BPM must be a number");
            return;
        }
        if (!isNaN(value) && value > 0) onValueChange(value);
    };
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "flex pt-4 items-center"
    }, label && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("label", {
        htmlFor: "text-input",
        class: "block mt-2 mr-2 text-xs w-16 font-medium text-gray-500"
    }, label), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
        type: "text",
        id: "text-input",
        value: value,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        readOnly: readOnly,
        class: "bg-gray-950 pl-2 border border-gray-300 text-gray-500 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
    }));
};
var $c0e1dce05d2b58db$export$2e2bcd8739ae039 = $c0e1dce05d2b58db$var$TextInputBpm;



const $d63ff206b62487d7$var$Button = ({ onClick: onClick, label: label, customClasses: customClasses })=>{
    const classesToUse = customClasses ? customClasses : "bg-clinical-600 hover:bg-clinical-300 text-black mr-2 font-bold py-2 px-4 rounded";
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "pt-4 flex text-xs"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("button", {
        onClick: onClick,
        class: classesToUse
    }, label));
};
var $d63ff206b62487d7$export$2e2bcd8739ae039 = $d63ff206b62487d7$var$Button;


const $0fd5a01cc16db09b$var$Settings = (0, $e21355414fd2bd2a$export$7c73462e0d25e514)(({ updateDrawerOpen: updateDrawerOpen, SequenceTypes: SequenceTypes, leftDeck: leftDeck, leftPause: leftPause, updateLeftDeck: updateLeftDeck, rightDeck: rightDeck, rightPause: rightPause, updateRightDeck: updateRightDeck, midiOutput: midiOutput, updateMidiOutput: updateMidiOutput, midiDevices: midiDevices, rowsLength: rowsLength, updateRowsLength: updateRowsLength, SequenceLengths: SequenceLengths, sequenceIsRhythm: sequenceIsRhythm, updateSequenceRhythm: updateSequenceRhythm, SequenceIsRhythm: SequenceIsRhythm, rotateEvery: rotateEvery, updateRotateEvery: updateRotateEvery, SequenceRotateEvery: SequenceRotateEvery, shouldReplace: shouldReplace, updateShouldReplace: updateShouldReplace, SequenceReplace: SequenceReplace, fractalReplace: fractalReplace, updateFractalReplace: updateFractalReplace, SequenceFractalReplace: SequenceFractalReplace, rotateSolos: rotateSolos, updateRotateSolos: updateRotateSolos, SequenceRotateSolos: SequenceRotateSolos, bpm: bpm, updateBpm: updateBpm, channelsToNotesMap: channelsToNotesMap, updatePresetChannels: updatePresetChannels, updatePresetNotes: updatePresetNotes, savedSettingsUrl: savedSettingsUrl, fullSettingsUrl: fullSettingsUrl, presetSettingsUrl: presetSettingsUrl, loadPresetUrl: loadPresetUrl, allPresetUrls: allPresetUrls, shouldBeVerbose: shouldBeVerbose, updateShouldBeVerbose: updateShouldBeVerbose, SequenceVerbose: SequenceVerbose, addToPresets: addToPresets, presetName: presetName, updatePresetName: updatePresetName, savedPresetName: savedPresetName, channelsInChords: channelsInChords })=>{
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "flex bg-black",
        id: "settings-panel",
        key: "settings-panel"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
        type: "checkbox",
        id: "drawer-toggle",
        class: "relative sr-only peer",
        onClick: ()=>updateDrawerOpen()
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("label", {
        for: "drawer-toggle",
        class: "absolute top-0 left-0 inline-block w-16 h-16 p-4 transition-all duration-500 bg-black peer-checked:rotate-90 peer-checked:left-96"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "w-7 h-1 mb-1 bg-neutral-500 rounded-lg"
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "w-7 h-1 mb-1 bg-neutral-500 rounded-lg"
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "w-7 h-1 bg-neutral-500 rounded-lg"
    })), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "fixed top-0 left-0 z-20 w-96 h-full overflow-auto text-xs bg-black transition-all duration-500 transform -translate-x-full shadow-lg peer-checked:translate-x-0"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "px-6 py-4 bg-black text-xs font-mono"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h2", {
        class: "text-lg text-gray-400 font-semibold"
    }, "Fractal Rhythm Settings"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        class: "text-gray-500 text-xs py-4"
    }, "To activate, click the square, and start the sequencer (space button). To save or share your settings, please, copy & reload the URL."), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-4 text-base text-gray-400 font-semibold "
    }, "Pattern Decks"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: leftDeck,
        onSelectedValueChange: updateLeftDeck,
        label: "Left",
        options: SequenceTypes,
        disabled: leftPause
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: rightDeck,
        onSelectedValueChange: updateRightDeck,
        label: "Right",
        options: SequenceTypes,
        disabled: rightPause
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-8 text-base text-gray-400 font-semibold"
    }, "MIDI Devices"), !midiOutput.value && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        class: "text-xs pt-1 text-gray-400"
    }, "Please, activate or connect a MIDI device and configure it for receiving MIDI messages."), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: midiOutput.value,
        onSelectedValueChange: updateMidiOutput,
        label: "MIDI Output",
        options: midiDevices
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-8 text-base text-gray-400 font-semibold"
    }, "Sequencer"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: rowsLength,
        onSelectedValueChange: updateRowsLength,
        label: "Steps",
        options: SequenceLengths
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: sequenceIsRhythm,
        onSelectedValueChange: updateSequenceRhythm,
        label: "Rhythm",
        options: SequenceIsRhythm
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: rotateEvery,
        onSelectedValueChange: updateRotateEvery,
        label: "Change Pattern",
        options: SequenceRotateEvery
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: shouldReplace,
        onSelectedValueChange: updateShouldReplace,
        label: "Change Type",
        options: SequenceReplace
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: fractalReplace,
        onSelectedValueChange: updateFractalReplace,
        label: "Vary Change",
        options: SequenceFractalReplace
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: rotateSolos,
        onSelectedValueChange: updateRotateSolos,
        label: "Vary Solos",
        options: SequenceRotateSolos
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $c0e1dce05d2b58db$export$2e2bcd8739ae039), {
        defaultValue: bpm,
        onValueChange: updateBpm,
        label: "BPM"
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-8 text-base text-gray-400 font-semibold"
    }, "Channels to Chords Variations"), channelsToNotesMap.map((pattern, patternIndex)=>{
        return pattern.map((channel, channelIndex)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                class: "flex flex-col"
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
                class: "flex pt-4 "
            }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $05b4ff1f58864b74$export$2e2bcd8739ae039), {
                defaultValue: channel.channel,
                onValueChange: (newValue)=>updatePresetChannels(patternIndex, channelIndex, newValue)
            }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
                class: "text-sm text-gray-400 font-semibold mr-4 pt-4"
            }, "to"), channel.notes.map((note, noteIndex)=>(0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e2ce247375ca17de$export$2e2bcd8739ae039), {
                    defaultValue: note,
                    onValueChange: (newValue)=>updatePresetNotes(patternIndex, channelIndex, noteIndex, newValue),
                    channel: channel.channel,
                    note: note
                }))), channelIndex != 0 && channelIndex % (channelsInChords - 1) == 0 && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("hr", {
                class: "mt-4 border-gray-300"
            })));
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-8 text-base text-gray-400 font-semibold"
    }, "Presets URL"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        class: "pt-2 text-xs text-gray-400"
    }, "save or share this URL to open the current setup"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $74b4d7c9fef7c353$export$2e2bcd8739ae039), {
        defaultValue: savedSettingsUrl
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $f231f83936b50e82$export$2e2bcd8739ae039), {
        defaultValue: presetName,
        onValueChange: updatePresetName
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "flex"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $d63ff206b62487d7$export$2e2bcd8739ae039), {
        onClick: ()=>addToPresets(fullSettingsUrl, savedPresetName),
        label: "Save to Presets"
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $d63ff206b62487d7$export$2e2bcd8739ae039), {
        onClick: ()=>$0fd5a01cc16db09b$var$loadLink(fullSettingsUrl),
        label: "Open in New Tab"
    })), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-8 text-base text-gray-400 font-semibold"
    }, "Load Presets"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: presetSettingsUrl,
        onSelectedValueChange: loadPresetUrl,
        options: allPresetUrls
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $d63ff206b62487d7$export$2e2bcd8739ae039), {
        onClick: ()=>$0fd5a01cc16db09b$var$removeLocalStorage(),
        label: "Clear Your Presets"
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("h3", {
        class: "pt-8 text-base text-gray-400 font-semibold"
    }, "Advanced Settings"), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e95cdfe4627ff789$export$2e2bcd8739ae039), {
        selectedValue: shouldBeVerbose,
        onSelectedValueChange: updateShouldBeVerbose,
        label: "Debug Mode",
        options: SequenceVerbose
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", {
        class: "pt-8 text-xs text-gray-400"
    }, "\xa0"))));
});
function $0fd5a01cc16db09b$var$loadLink(url) {
    window.open(url, "_blank");
}
function $0fd5a01cc16db09b$var$removeLocalStorage() {
    confirm("Are you sure you want to remove all your presets from the browser's cache and reload this page?", localStorage.removeItem("presetUrls"));
    window.location.href = "/";
}
var $0fd5a01cc16db09b$export$2e2bcd8739ae039 = $0fd5a01cc16db09b$var$Settings;



const $2e1f416c8aa7b962$export$e7756fa211fd7445 = [
    [
        {
            channel: 1,
            notes: [
                "C2",
                "D3",
                "F3",
                "G2"
            ]
        }
    ],
    [
        {
            channel: 1,
            notes: [
                "C2",
                "D3",
                "F3",
                "G2"
            ]
        }
    ]
];
const $2e1f416c8aa7b962$export$ff782c69715e4102 = [
    [
        {
            channel: 5,
            notes: [
                "C3",
                "D3",
                "F3",
                "G3"
            ]
        },
        {
            channel: 6,
            notes: [
                "F2",
                "G2",
                "Bb2",
                "C2"
            ]
        },
        {
            channel: 8,
            notes: [
                "Bb3",
                "G2",
                "Bb3",
                "C3"
            ]
        },
        {
            channel: 1,
            notes: [
                "B3",
                "A3",
                "F3",
                "G3"
            ]
        }
    ],
    [
        {
            channel: 5,
            notes: [
                "B3",
                "E3",
                "G3",
                "F3"
            ]
        },
        {
            channel: 6,
            notes: [
                "E2",
                "A2",
                "D2",
                "B2"
            ]
        },
        {
            channel: 8,
            notes: [
                "G3",
                "D2",
                "B3",
                "D3"
            ]
        },
        {
            channel: 1,
            notes: [
                "B3",
                "A3",
                "F3",
                "G3"
            ]
        }
    ]
];


const $410657484a834f5b$export$88e53662731c09b5 = [
    {
        value: "Sequential",
        label: "Sequential (Rhythmical)"
    },
    {
        value: "random",
        label: "Stochastic (Random)"
    },
    {
        value: "Random",
        label: "Aleatory (White Noise)"
    },
    {
        value: "Perlin",
        label: "Aleatory (Random Patterns)"
    },
    {
        value: "Stable",
        label: "Mosaic (Emerging Patterns)"
    },
    {
        value: "Fractal",
        label: "Fractal (Self-Similar Patterns"
    },
    {
        value: "Unstable",
        label: "Gradient (Shifting Patterns)"
    }
];
const $410657484a834f5b$export$c5e6744d3cb96f76 = [
    {
        value: 2,
        label: "4 [2x2]"
    },
    {
        value: 4,
        label: "16 [4x4]"
    },
    {
        value: 8,
        label: "64 [8x8]"
    },
    {
        value: 16,
        label: "256 [16x16]"
    },
    {
        value: 32,
        label: "1024 [32x32]"
    },
    {
        value: 64,
        label: "4096 [64x64]"
    }
];
const $410657484a834f5b$export$5f083b8855148cb9 = [
    {
        value: 1,
        label: "Reflects Pattern Type"
    },
    {
        value: 0,
        label: "Stays Constant"
    }
];
const $410657484a834f5b$export$502dada5677ab86d = [
    {
        value: 0,
        label: "do not rotate"
    },
    {
        value: 1,
        label: "every 1 cycle"
    },
    {
        value: 2,
        label: "every 2 cycles"
    },
    {
        value: 3,
        label: "every 3 cycles"
    },
    {
        value: 4,
        label: "every 4 cycles"
    },
    {
        value: 8,
        label: "every 8 cycles"
    }
];
const $410657484a834f5b$export$a6ea9929f07c23b8 = [
    {
        value: 0,
        label: "same variability"
    },
    {
        value: 1,
        label: "different variability"
    }
];
const $410657484a834f5b$export$a36f88f60c76ce87 = [
    {
        value: false,
        label: "play all channels at once"
    },
    {
        value: true,
        label: "use sequencer logic to choose which channel to play"
    }
];
const $410657484a834f5b$export$49e0194f7c0e2e93 = [
    {
        value: 0,
        label: "do not show extra data"
    },
    {
        value: 1,
        label: "show extra data"
    }
];
const $410657484a834f5b$export$6ac1b0284f1ec638 = [
    {
        value: false,
        label: "sequential pattern cycle"
    },
    {
        value: "Random",
        label: "aleatory pattern cycle"
    },
    {
        value: "Stable",
        label: "mosaic pattern cycle"
    },
    {
        value: "Fractal",
        label: "fractal pattern cycle"
    },
    {
        value: "Unstable",
        label: "gradient pattern cycle"
    }
];


const $35da740d59af89ba$var$queryParams = new URLSearchParams(window.location.search);

const $35da740d59af89ba$var$signalGenerator = $cbaadc3121311d77$exports;
const $35da740d59af89ba$var$defaultBpm = $35da740d59af89ba$var$queryParams.get("bpm") ? parseInt($35da740d59af89ba$var$queryParams.get("bpm"), 10) : 200;
const $35da740d59af89ba$var$rows = $35da740d59af89ba$var$queryParams.get("rows") ? parseInt($35da740d59af89ba$var$queryParams.get("rows"), 10) : 16;
const $35da740d59af89ba$var$verbose = $35da740d59af89ba$var$queryParams.get("verbose") ? parseInt($35da740d59af89ba$var$queryParams.get("verbose"), 10) : 0;
const $35da740d59af89ba$var$left = $35da740d59af89ba$var$queryParams.get("left") ? $35da740d59af89ba$var$queryParams.get("left") : "Random";
const $35da740d59af89ba$var$right = $35da740d59af89ba$var$queryParams.get("right") ? $35da740d59af89ba$var$queryParams.get("right") : "Fractal";
const $35da740d59af89ba$var$rotate = $35da740d59af89ba$var$queryParams.get("rotate") ? parseInt($35da740d59af89ba$var$queryParams.get("rotate"), 10) : 0;
const $35da740d59af89ba$var$replace = $35da740d59af89ba$var$queryParams.get("replace") ? parseInt($35da740d59af89ba$var$queryParams.get("replace"), 10) : 0;
const $35da740d59af89ba$var$switcher = $35da740d59af89ba$var$queryParams.get("switcher") ? $35da740d59af89ba$var$queryParams.get("switcher") : false;
const $35da740d59af89ba$var$rhythm = $35da740d59af89ba$var$queryParams.get("rhythm") ? $35da740d59af89ba$var$queryParams.get("rhythm") : 1;
const $35da740d59af89ba$var$presetMidi = $35da740d59af89ba$var$queryParams.get("midi") ? $35da740d59af89ba$var$queryParams.get("midi") : false;
const $35da740d59af89ba$var$presetChannels = $35da740d59af89ba$var$queryParams.get("channels") ? $35da740d59af89ba$var$queryParams.get("channels").split(" ") : false;
const $35da740d59af89ba$var$presetNotes = $35da740d59af89ba$var$queryParams.get("notes") ? $35da740d59af89ba$var$queryParams.get("notes").split(" ") : false;
const $35da740d59af89ba$var$channelsInChords = $35da740d59af89ba$var$presetChannels ? Math.floor($35da740d59af89ba$var$presetChannels.length / (0, $2e1f416c8aa7b962$export$e7756fa211fd7445).length) : Math.floor((0, $2e1f416c8aa7b962$export$e7756fa211fd7445)[0].length);
const $35da740d59af89ba$var$playAllChannelsAtOnce = $35da740d59af89ba$var$queryParams.get("chorus") ? true : false;
const $35da740d59af89ba$var$channelsToNotes = !$35da740d59af89ba$var$presetChannels && !$35da740d59af89ba$var$presetNotes ? (0, $2e1f416c8aa7b962$export$e7756fa211fd7445) : (0, $2e1f416c8aa7b962$export$e7756fa211fd7445).map((pattern, patternIndex)=>{
    return $35da740d59af89ba$var$presetChannels.map((channel, channelIndex)=>{
        if (patternIndex * $35da740d59af89ba$var$channelsInChords <= channelIndex && channelIndex < $35da740d59af89ba$var$channelsInChords * (patternIndex + 1)) return {
            channel: channel,
            notes: $35da740d59af89ba$var$presetNotes.slice(4 * channelIndex, 4 * channelIndex + 4)
        };
    }).filter((channel)=>channel);
});
console.log("channelsToNotes", $35da740d59af89ba$var$channelsToNotes);
const $35da740d59af89ba$var$presetSettingsUrl = new URL(window.location.href);
const $35da740d59af89ba$var$bpmToMs = (bpm)=>{
    return Math.floor(60 / bpm * 1000);
};
const $35da740d59af89ba$var$returnTimeSeries = (signalConfig)=>{
    return $35da740d59af89ba$var$signalGenerator.generateSignal(signalConfig);
};
function $35da740d59af89ba$var$enableWebMidi(setWebMidi) {
    console.log("Enabling webmidi");
    const isSafari = $35da740d59af89ba$var$detectSafari();
    console.log("isSafari", isSafari);
    if (isSafari) {
        alert("WebMidi is not supported on Safari. Please use Chrome or Firefox instead. You can still use it for fractal visualizations.");
        return;
    }
    (0, $4oKKP.WebMidi).enable().then(()=>{
        console.log("WebMidi enabled");
        console.log((0, $4oKKP.WebMidi).inputs);
        console.log((0, $4oKKP.WebMidi).outputs);
        const midiInputs = (0, $4oKKP.WebMidi).inputs;
        const midiInputsExist = midiInputs && midiInputs.length > 0;
        if (!midiInputsExist) {
            alert("No MIDI inputs detected. Please connect your software or hardware MIDI device (e.g. Bespoke, GarageBand, Analog Rhytm, OPZ) or activate it to receive incoming signals.");
            return;
        }
        setWebMidi((0, $4oKKP.WebMidi));
    }).catch((err)=>alert(err));
}
function $35da740d59af89ba$var$setMidiInputListener(myInput, shouldBeVerbose) {
    myInput.addListener("noteon", (e)=>{
        if (shouldBeVerbose) console.log(`received ${e.note._name}${e.note.octave} on ch ${e.message.channel}`);
    }, {
        channels: [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ]
    });
}
const $35da740d59af89ba$var$presetUrls = [
    {
        value: "/",
        label: "Default Mode: Fractal Pattern, Fast, 256 Steps, Stable"
    },
    {
        value: "/?rows=4",
        label: "Easy Mode: Fractal Pattern, Fast, 16 Steps, Stable"
    },
    {
        value: "/?channels=1+1&notes=B1+A1+G1+E1+C2+A1+B1+D2&bpm=400&rows=8&rotate=1",
        label: "Garage Band w So Cal Drum, Fractal Rhythm (1 channel, 2 patterns)"
    },
    {
        value: "/?channels=1+1&notes=B1+A1+G1+E1+C2+A1+B1+D2&bpm=400&rows=8&rotate=1&replace=1&switcher=Fractal",
        label: "Garage Band w So Cal Drum, Rhythm Changes (4 channels, 2 patterns)"
    },
    {
        value: "/?rows=8&bpm=400&rotate=2&channels=5+6+8+1+5+6+8+1&notes=C3+D3+F3+G3+F2+G2+Bb2+C2+Bb3+G2+Bb3+C3+B3+A3+F3+G3+B3+E3+G3+F3+E2+A2+D2+B2+G3+D2+B3+D3+B3+A3+F3+G3",
        label: "Elektron Analog Rytm: Fast Drumming & Rhythm, Change Pattern Every 2 Cycles"
    },
    {
        value: "/?rows=8&bpm=400&rotate=2&channels=5+6+8+1+5+6+8+1&notes=C3+D3+F3+G3+F2+G2+Bb2+C2+Bb3+G2+Bb3+C3+B3+A3+F3+G3+B3+E3+G3+F3+E2+A2+D2+B2+G3+D2+B3+D3+B3+A3+F3+G3",
        label: "Teenage Engeneering OPZ: Fast Melody & Rhythm, Fractal Pattern Varied"
    },
    {
        value: "/?rhythm=0&rotate=2&bpm=400",
        label: "Constant Fractal Rhythm, Change of Melody / Instruments Only"
    }
];
const $35da740d59af89ba$var$localStorageUrls = localStorage.getItem("presetUrls") ? JSON.parse(localStorage.getItem("presetUrls")) : [];
const $35da740d59af89ba$var$App = ()=>{
    const [currentView, setCurrentView] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("all");
    const currentViewRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(currentView);
    const [leftDeck, setLeftDeck] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$left);
    const [rightDeck, setRightDeck] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$right);
    const [rowsLength, setRowsLength] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$rows);
    const [sequenceIsRhythm, setSequenceIsRhythm] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$rhythm);
    const [rotateEvery, setRotateEvery] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$rotate);
    const [shouldReplace, setShouldReplace] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$replace);
    const [fractalReplace, setFractalReplace] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$switcher);
    const [shouldBeVerbose, setShouldBeVerbose] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$verbose);
    const [drawerOpen, setDrawerOpen] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const [bpm, setBpm] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$defaultBpm);
    const [beatDistance, setBeatDistance] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$bpmToMs($35da740d59af89ba$var$defaultBpm));
    const [refreshRandomKey, setRefreshRandomKey] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    const [randomIndex, setRandomIndex] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    const [refreshFractalKey, setRefreshFractalKey] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    const [fractalIndex, setFractalIndex] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    const [leftPause, setLeftPause] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const leftPauseRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(leftPause);
    const [rightPause, setRightPause] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(false);
    const rightPauseRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(rightPause);
    const [timeOutIdsLeft, setTimeOutIdsLeft] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const timeOutIdsLeftRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(timeOutIdsLeft);
    const [timeOutIdsRight, setTimeOutIdsRight] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const timeOutIdsRightRef = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(timeOutIdsRight);
    const [reorganizedDataLeft, setReorganizedDataLeft] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const [reorganizedDataRight, setReorganizedDataRight] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const [currentCycle, setCurrentCycle] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    const [tempMode, setTempMode] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("");
    const [patternTimeSeries, setPatternTimeSeries] = (0, $204a33a7557cbbd0$export$60241385465d0a34)({});
    const [webMidi, setWebMidi] = (0, $204a33a7557cbbd0$export$60241385465d0a34)();
    const [midiDevices, setMidiDevices] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const [midiOutput, setMidiOutput] = (0, $204a33a7557cbbd0$export$60241385465d0a34)({});
    const [channelsToNotesMap, setChannelsToNotesMap] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$channelsToNotes);
    const [savedSettingsUrl, setSavedSettingsUrl] = (0, $204a33a7557cbbd0$export$60241385465d0a34)($35da740d59af89ba$var$presetSettingsUrl);
    const [fullSettingsUrl, setFullSettingsUrl] = (0, $204a33a7557cbbd0$export$60241385465d0a34)({});
    const [allPresetUrls, setAllPresetUrls] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const [rotateSolos, setRotateSolos] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(!$35da740d59af89ba$var$playAllChannelsAtOnce);
    const [currentPositionLeft, setCurrentPositionLeft] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    const [currentPositionRight, setCurrentPositionRight] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    const [presetName, setPresetName] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("User Preset: Custom Name");
    const [savedPresetName, setSavedPresetsName] = (0, $204a33a7557cbbd0$export$60241385465d0a34)("");
    const updatePresetName = (value)=>{
        setPresetName(value);
        setSavedPresetsName(value);
    };
    const updateRotateSolos = (value)=>{
        setRotateSolos(value);
    };
    function updateDrawerOpen() {
        setDrawerOpen((prevOpen)=>!prevOpen);
    }
    function updateCurrentPositionLeft(value) {
        setCurrentPositionLeft(value);
    }
    function updateCurrentPositionRight(value) {
        setCurrentPositionRight(value);
    }
    function updateTimeOutIdsLeft(newIds) {
        setTimeOutIdsLeft(newIds);
    }
    function updateTimeOutIdsRight(newIds) {
        setTimeOutIdsRight(newIds);
    }
    function updateMidiOutput(value) {
        const newMidiOutput = (0, $4oKKP.WebMidi).getOutputById(value);
        setMidiOutput({
            value: newMidiOutput.id,
            label: newMidiOutput.name
        });
    }
    function updateLeftPause() {
        setLeftPause((prevPause)=>!prevPause);
    }
    function updateRightPause() {
        setRightPause((prevPause)=>!prevPause);
    }
    function updatePause() {
        updateLeftPause();
        updateRightPause();
        setPause((prevPause)=>!prevPause);
    }
    function updateBpm(value) {
        console.log(`changing bpm to ${value}`);
        console.log(`changing beat distance to ${$35da740d59af89ba$var$bpmToMs(parseInt(value))}`);
        setBpm(parseInt(value));
    }
    function updateShouldBeVerbose(value) {
        setShouldBeVerbose(value);
    }
    function updateShouldReplace(value) {
        setShouldReplace(parseInt(value));
    }
    function updateFractalReplace(value) {
        setFractalReplace(value);
    }
    function updateRotateEvery(value) {
        setRotateEvery(parseInt(value));
    }
    function updateSequenceRhythm(value) {
        setSequenceIsRhythm(value);
    }
    function updateRowsLength(value) {
        setRowsLength(value);
    }
    function updateLeftDeck(value) {
        setLeftDeck(value);
    }
    function updateRightDeck(value) {
        setRightDeck(value);
    }
    function updateTimeOutIds(newIds) {
        setTimeOutIds(newIds);
    }
    function updateReorganizedDataLeft(array) {
        setReorganizedDataLeft(array);
    }
    function updateReorganizedDataRight(array) {
        setReorganizedDataRight(array);
    }
    function updateCurrentCycle(value) {
        setCurrentCycle(parseInt(value));
    }
    function updateTempMode(value) {
        setTempMode(value);
    }
    function updateSavedSettingsUrl(value) {
        setSavedSettingsUrl(value);
    }
    function loadPresetUrl(value) {
        window.location.href = value;
    }
    function addToPresets(url, name) {
        console.log("new name", name);
        const currentStorage = localStorage.getItem("presetUrls") ? JSON.parse(localStorage.getItem("presetUrls")) : [];
        const newStorage = [
            ...currentStorage,
            {
                value: url.href,
                label: name
            }
        ];
        const defaultAndPreset = [
            ...$35da740d59af89ba$var$presetUrls,
            ...newStorage
        ];
        localStorage.setItem("presetUrls", JSON.stringify(newStorage));
        setAllPresetUrls(defaultAndPreset);
        alert("Saved your configuration to the list of presets.");
    }
    function updatePresetNotes(patternIndex, channelIndex, noteIndex, noteId) {
        const newChannelsToNotes = channelsToNotesMap.map((_pattern, _patternIndex)=>{
            if (_patternIndex === patternIndex) return _pattern.map((_channel, _channelIndex)=>{
                if (_channelIndex === channelIndex) {
                    console.log(_channel);
                    return {
                        channel: _channel.channel,
                        notes: _channel.notes.map((note, _noteIndex)=>{
                            if (_noteIndex === noteIndex) return noteId;
                            return note;
                        })
                    };
                }
                return _channel;
            });
            return _pattern;
        });
        console.log("newChannelsToNotes", newChannelsToNotes);
        setChannelsToNotesMap(newChannelsToNotes);
    }
    function updatePresetChannels(patternIndex, channelIndex, channelId) {
        const newChannelsToNotes = channelsToNotesMap.map((_pattern, _patternIndex)=>{
            if (_patternIndex === patternIndex) return _pattern.map((_channel, _channelIndex)=>{
                if (_channelIndex === channelIndex) return {
                    channel: channelId,
                    notes: _channel.notes
                };
                return _channel;
            });
            return _pattern;
        });
        setChannelsToNotesMap(newChannelsToNotes);
    }
    function startPlaying() {
        const userCurrentView = currentViewRef.current;
        if (userCurrentView == "left" || userCurrentView == "right") {
            if (timeOutIdsLeftRef.current) timeOutIdsLeftRef.current.forEach((id)=>{
                clearTimeout(id);
            });
            if (timeOutIdsRightRef.current) timeOutIdsRightRef.current.forEach((id)=>{
                clearTimeout(id);
            });
        }
        switch(userCurrentView){
            case "left":
                if (rightPauseRef.current) setRightPause((prevPause)=>!prevPause);
                if (leftPauseRef.current) setRandomIndex((prevIndex)=>prevIndex + 1);
                setLeftPause((prevPause)=>!prevPause);
                setCurrentPositionLeft(0);
                break;
            case "right":
                if (leftPauseRef.current) setLeftPause((prevPause)=>!prevPause);
                if (rightPauseRef.current) setFractalIndex((prevIndex)=>prevIndex + 1);
                setRightPause((prevPause)=>!prevPause);
                setCurrentPositionRight(0);
                break;
        }
    }
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        leftPauseRef.current = leftPause;
    }, [
        leftPause
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        rightPauseRef.current = rightPause;
    }, [
        rightPause
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        timeOutIdsLeftRef.current = timeOutIdsLeft;
        timeOutIdsRightRef.current = timeOutIdsRight;
    }, [
        timeOutIdsLeft,
        timeOutIdsRight
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const handleKeyPress = (event)=>{
            if (event.code === "Space") startPlaying();
        };
        window.addEventListener("keydown", handleKeyPress);
        $35da740d59af89ba$var$enableWebMidi(setWebMidi);
        setAllPresetUrls([
            ...$35da740d59af89ba$var$presetUrls,
            ...$35da740d59af89ba$var$localStorageUrls
        ]);
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, []);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = new URL(window.location.href);
        const extractedChannels = channelsToNotesMap.map((pattern)=>{
            return pattern.map((channels)=>{
                return channels.channel;
            });
        });
        const fullChannelArray = extractedChannels.flat();
        currentSettingsUrl.searchParams.set("channels", fullChannelArray.join("+"));
        const extractedNotes = channelsToNotesMap.map((pattern)=>{
            return pattern.map((channels)=>{
                return channels.notes;
            });
        });
        const fullNoteArray = extractedNotes.flat().flat();
        currentSettingsUrl.searchParams.set("notes", fullNoteArray.join("+"));
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        channelsToNotesMap
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const allMidiOutputDevices = (0, $4oKKP.WebMidi).outputs.map((output)=>{
            return {
                value: output.id,
                label: output.name
            };
        });
        setMidiDevices(allMidiOutputDevices);
        if (allMidiOutputDevices && allMidiOutputDevices.length > 0) {
            if ($35da740d59af89ba$var$presetMidi) {
                const myOutput = (0, $4oKKP.WebMidi).getOutputByName($35da740d59af89ba$var$presetMidi) ? (0, $4oKKP.WebMidi).getOutputByName($35da740d59af89ba$var$presetMidi) : false;
                const myInput = (0, $4oKKP.WebMidi).inputs.filter((input)=>input.name.slice(0, 16) == myOutput.name.slice(0, 16))[0];
                if (myOutput) setMidiOutput({
                    value: myOutput.id,
                    label: myOutput.name
                });
                else setMidiOutput(allMidiOutputDevices[0]);
                if (myInput) $35da740d59af89ba$var$setMidiInputListener(myInput, shouldBeVerbose);
            } else {
                setMidiOutput(allMidiOutputDevices[0]);
                $35da740d59af89ba$var$setMidiInputListener((0, $4oKKP.WebMidi).inputs[0], shouldBeVerbose);
            }
        }
    }, [
        webMidi
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const signalConfig = {
            left: {
                signalLength: 256,
                minWindow: 4,
                scaleGrow: 0.5,
                signalRange: [
                    beatDistance - Math.floor(beatDistance / 2),
                    beatDistance + Math.floor(beatDistance / 2)
                ],
                // 0, 500
                signalType: leftDeck
            },
            right: {
                signalLength: 256,
                minWindow: 4,
                scaleGrow: 0.5,
                signalRange: [
                    beatDistance - Math.floor(beatDistance / 2),
                    beatDistance + Math.floor(beatDistance / 2)
                ],
                // 0, 500
                signalType: rightDeck
            }
        };
        patternTimeSeries.left = $35da740d59af89ba$var$returnTimeSeries(signalConfig.left).timeSeries;
        patternTimeSeries.right = $35da740d59af89ba$var$returnTimeSeries(signalConfig.right).timeSeries;
        setPatternTimeSeries({
            left: patternTimeSeries.left,
            right: patternTimeSeries.right
        });
    // const averageLeft =
    // 	patternTimeSeries.left.reduce((a, b) => a + b, 0) /
    // 	patternTimeSeries.left.length;
    // const averageRight =
    // 	patternTimeSeries.right.reduce((a, b) => a + b, 0) /
    // 	patternTimeSeries.right.length;
    }, [
        leftDeck,
        rightDeck
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (leftPauseRef.current || currentView == "right") return;
        if (randomIndex >= patternTimeSeries["left"].length) setRandomIndex(0);
        const randomInterval = setInterval(()=>{
            setRefreshRandomKey((prevKey)=>prevKey + 1);
            setRandomIndex((prevIndex)=>{
                return prevIndex < patternTimeSeries["left"].length - 1 ? prevIndex + 1 : prevIndex;
            });
        }, patternTimeSeries["left"][randomIndex]);
        return ()=>clearInterval(randomInterval);
    }, [
        randomIndex
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (rightPauseRef.current || currentView == "left") return;
        if (fractalIndex >= patternTimeSeries["right"].length) setFractalIndex(0);
        const fractalInterval = setInterval(()=>{
            setRefreshFractalKey((prevKey)=>prevKey + 1);
            setFractalIndex((prevIndex)=>{
                return prevIndex < patternTimeSeries["right"].length - 1 ? prevIndex + 1 : prevIndex;
            });
        }, patternTimeSeries["right"][fractalIndex]);
        return ()=>clearInterval(fractalInterval);
    }, [
        fractalIndex
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        currentViewRef.current = currentView;
        if (currentView == "all") {
            if (leftPauseRef.current) setFractalIndex((prevIndex)=>prevIndex + 1);
            if (rightPauseRef.current) setRandomIndex((prevIndex)=>prevIndex + 1);
        }
    // setRandomIndex((prevIndex) => prevIndex + 1);
    //
    // if (currentView == "all" && leftPause) {
    // 	updateCurrentPositionLeft(currentPositionLeft + 1);
    // }
    // if (currentView == "all" && rightPause) {
    // 	updateCurrentPositionRight(currentPositionRight + 1);
    // }
    // if (timeOutIds) {
    // 	timeOutIds.forEach((id) => {
    // 		clearTimeout(id);
    // 	});
    // }
    }, [
        currentView
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("rows", rowsLength);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        rowsLength
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("rhythm", sequenceIsRhythm);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        sequenceIsRhythm
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("rotate", rotateEvery);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        rotateEvery
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("chorus", !rotateSolos);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        rotateSolos
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("replace", shouldReplace);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        shouldReplace
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("switcher", fractalReplace);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        fractalReplace
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("left", leftDeck);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        leftDeck
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("right", rightDeck);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        rightDeck
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        setBeatDistance($35da740d59af89ba$var$bpmToMs(parseInt(bpm)));
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("bpm", bpm);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        bpm
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("verbose", shouldBeVerbose);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        shouldBeVerbose
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        const currentSettingsUrl = fullSettingsUrl.href ? fullSettingsUrl : new URL(window.location.href);
        currentSettingsUrl.searchParams.set("midi", midiOutput.label);
        setFullSettingsUrl(currentSettingsUrl);
        updateSavedSettingsUrl(currentSettingsUrl.href);
    }, [
        midiOutput
    ]);
    const toggleLeftView = ()=>{
        setCurrentView(currentView === "left" ? "all" : "left");
    };
    const toggleRightView = ()=>{
        setCurrentView(currentView === "right" ? "all" : "right");
    };
    const containerClasses = currentView === "all" ? "flex flex-col lg:flex-row gap-32 w-4/5 h-4/5 items-center justify-center" : "flex flex-col lg:flex-row gap-16 lg:w-2/5 w-4/5 items-center justify-center";
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: "container mx-auto w-screen h-screen flex items-center justify-center bg-black"
    }, (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        class: containerClasses
    }, currentView != "right" && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $4d894c0568f6ab6a$export$2e2bcd8739ae039), {
        key: refreshRandomKey,
        mode: leftDeck,
        onTouchStart: toggleLeftView,
        onClick: toggleLeftView,
        rows: rowsLength,
        verbose: shouldBeVerbose,
        rotate: rotateEvery,
        rotateSolos: rotateSolos,
        replace: shouldReplace,
        fractalReplace: fractalReplace,
        tempMode: tempMode,
        updateTempMode: updateTempMode,
        WebMidi: (0, $4oKKP.WebMidi),
        pause: leftPause,
        timeOutIds: timeOutIdsLeft,
        updateTimeOutIds: updateTimeOutIdsLeft,
        reorganizedData: reorganizedDataLeft,
        updateReorganizedData: updateReorganizedDataLeft,
        formToRhythm: sequenceIsRhythm,
        currentCycle: currentCycle,
        updateCurrentCycle: updateCurrentCycle,
        beatDistance: beatDistance,
        midiOutput: midiOutput,
        channelsToNotes: channelsToNotesMap,
        currentPosition: currentPositionLeft,
        updateCurrentPosition: updateCurrentPositionLeft,
        currentView: currentView
    }), currentView != "left" && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $4d894c0568f6ab6a$export$2e2bcd8739ae039), {
        key: refreshFractalKey,
        mode: rightDeck,
        onTouchStart: toggleRightView,
        onClick: toggleRightView,
        rows: rowsLength,
        verbose: shouldBeVerbose,
        rotate: rotateEvery,
        rotateSolos: rotateSolos,
        tempMode: tempMode,
        updateTempMode: updateTempMode,
        replace: shouldReplace,
        fractalReplace: fractalReplace,
        WebMidi: (0, $4oKKP.WebMidi),
        pause: rightPause,
        timeOutIds: timeOutIdsRight,
        updateTimeOutIds: updateTimeOutIdsRight,
        reorganizedData: reorganizedDataRight,
        updateReorganizedData: updateReorganizedDataRight,
        formToRhythm: sequenceIsRhythm,
        currentCycle: currentCycle,
        updateCurrentCycle: updateCurrentCycle,
        beatDistance: beatDistance,
        midiOutput: midiOutput,
        channelsToNotes: channelsToNotesMap,
        currentPosition: currentPositionRight,
        updateCurrentPosition: updateCurrentPositionRight,
        currentView: currentView
    })), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $0fd5a01cc16db09b$export$2e2bcd8739ae039), {
        updateDrawerOpen: updateDrawerOpen,
        SequenceTypes: (0, $410657484a834f5b$export$88e53662731c09b5),
        leftDeck: leftDeck,
        leftPause: leftPause,
        updateLeftDeck: updateLeftDeck,
        rightDeck: rightDeck,
        rightPause: rightPause,
        updateRightDeck: updateRightDeck,
        midiOutput: midiOutput,
        updateMidiOutput: updateMidiOutput,
        midiDevices: midiDevices,
        rowsLength: rowsLength,
        updateRowsLength: updateRowsLength,
        SequenceLengths: (0, $410657484a834f5b$export$c5e6744d3cb96f76),
        sequenceIsRhythm: sequenceIsRhythm,
        updateSequenceRhythm: updateSequenceRhythm,
        SequenceIsRhythm: (0, $410657484a834f5b$export$5f083b8855148cb9),
        rotateEvery: rotateEvery,
        updateRotateEvery: updateRotateEvery,
        SequenceRotateEvery: (0, $410657484a834f5b$export$502dada5677ab86d),
        shouldReplace: shouldReplace,
        updateShouldReplace: updateShouldReplace,
        SequenceReplace: (0, $410657484a834f5b$export$a6ea9929f07c23b8),
        fractalReplace: fractalReplace,
        updateFractalReplace: updateFractalReplace,
        SequenceFractalReplace: (0, $410657484a834f5b$export$6ac1b0284f1ec638),
        rotateSolos: rotateSolos,
        updateRotateSolos: updateRotateSolos,
        SequenceRotateSolos: (0, $410657484a834f5b$export$a36f88f60c76ce87),
        bpm: bpm,
        updateBpm: updateBpm,
        channelsToNotesMap: channelsToNotesMap,
        updatePresetChannels: updatePresetChannels,
        updatePresetNotes: updatePresetNotes,
        savedSettingsUrl: savedSettingsUrl,
        fullSettingsUrl: fullSettingsUrl,
        presetSettingsUrl: $35da740d59af89ba$var$presetSettingsUrl,
        loadPresetUrl: loadPresetUrl,
        allPresetUrls: allPresetUrls,
        shouldBeVerbose: shouldBeVerbose,
        updateShouldBeVerbose: updateShouldBeVerbose,
        SequenceVerbose: (0, $410657484a834f5b$export$49e0194f7c0e2e93),
        addToPresets: addToPresets,
        presetName: presetName,
        updatePresetName: updatePresetName,
        savedPresetName: savedPresetName,
        channelsInChords: $35da740d59af89ba$var$channelsInChords
    }), (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $a2938b69b36cc0ac$export$2e2bcd8739ae039), null), currentView == "left" && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $d63ff206b62487d7$export$2e2bcd8739ae039), {
        customClasses: "fixed bottom-5 left-1/2 text-xl transform -translate-x-1/2 bg-black text-clinical-600 mr-2 py-2 px-4",
        onClick: startPlaying,
        label: leftPause ? "| |" : "\u25B6"
    }), currentView == "right" && (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $d63ff206b62487d7$export$2e2bcd8739ae039), {
        customClasses: "fixed bottom-5 left-1/2 text-xl transform -translate-x-1/2 bg-black text-clinical-600 mr-2 py-2 px-4",
        onClick: startPlaying,
        label: rightPause ? "| |" : "\u25B6"
    }));
};
function $35da740d59af89ba$var$detectSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($35da740d59af89ba$var$App, null), document.getElementById("app"));


//# sourceMappingURL=index.a3c29064.js.map
